import React from 'react';

export const SourceIcon = (
  <svg
    width='17'
    height='16'
    viewBox='0 0 17 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <rect x='0.5' width='16' height='16' rx='2' fill='white' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.09386 5.81966C7.08645 5.81966 7.07209 5.81966 7.06468 5.81966C6.94154 5.80465 6.84017 5.6918 6.84017 5.56394C6.83275 5.44357 6.76744 2.63036 8.35442 1.99102C8.75301 1.83305 9.12294 1.86312 9.4345 2.09634C9.81826 2.37464 10.0937 2.93125 10.2604 3.74362C10.3761 4.31529 10.3979 4.81171 10.3979 4.8343C10.4053 4.95463 10.3113 5.04494 10.1877 5.02235C10.0645 5.00729 9.96317 4.89449 9.96317 4.77411C9.94141 4.26263 9.77475 2.85605 9.22433 2.44984C9.05025 2.32199 8.83264 2.30693 8.57201 2.41224C7.20956 2.96132 7.27485 5.60154 7.27485 5.63161C7.27485 5.73693 7.20266 5.81966 7.09386 5.81966Z'
      fill='#595961'
    />
    <path
      opacity='0.46'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.35447 2.1116C9.06467 1.90096 8.72441 1.87089 8.3545 2.01381C7.70962 2.27705 7.25318 2.9691 7.02866 4.02218C6.862 4.7969 6.88374 5.49647 6.88374 5.52654C6.88374 5.56414 6.89809 5.60179 6.92727 5.63186C6.95595 5.66193 6.98513 5.68452 7.02123 5.68452C7.02865 5.68452 7.03607 5.68452 7.043 5.68452C7.10827 5.68452 7.1592 5.63186 7.1592 5.56414C7.1592 5.53407 7.09395 2.84872 8.4925 2.28458C8.77488 2.17179 9.02115 2.1868 9.22441 2.33724C9.81093 2.76599 9.98499 4.21775 10.0068 4.73676C10.0068 4.81196 10.072 4.88721 10.1517 4.89469C10.2244 4.90222 10.2822 4.84956 10.2822 4.77436C10.2748 4.6841 10.1952 2.72839 9.35447 2.1116Z'
      fill='#B2B2C2'
    />
    <path
      opacity='0.46'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.02908 5.59425C7.02166 5.59425 7.02166 5.59425 7.01474 5.59425C6.97122 5.58672 6.93461 5.54159 6.92769 5.49646C6.92769 5.46634 6.90594 4.78188 7.0726 4.0071C7.28971 2.97662 7.74664 2.2921 8.37668 2.03634C8.73176 1.89342 9.05076 1.92354 9.32622 2.11912C10.1378 2.71332 10.2174 4.63896 10.2174 4.72169C10.2174 4.76682 10.1813 4.79689 10.1377 4.78941C10.0942 4.78188 10.0581 4.74428 10.0507 4.69162C10.0507 4.66903 9.97108 2.78104 9.23917 2.23944C9.02157 2.08152 8.75354 2.05893 8.4494 2.17925C7.02908 2.77351 7.09437 5.49646 7.09437 5.52653C7.10129 5.56413 7.0726 5.59425 7.02908 5.59425Z'
      fill='#B2B2C2'
    />
    <path
      opacity='0.62'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.61612 3.44363C7.67398 3.33083 7.73183 3.21798 7.78276 3.09766C7.761 3.13526 7.6161 3.52641 7.17398 3.46622C7.16656 3.46622 7.43462 3.54895 7.61612 3.44363Z'
      fill='#595961'
    />
    <path
      opacity='0.62'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.4562 3.92325C7.49972 3.80287 7.54323 3.67502 7.57241 3.55469C7.55807 3.59982 7.48536 4.00598 7.02148 4.00598C7.02148 4.00598 7.28954 4.05864 7.4562 3.92325Z'
      fill='#595961'
    />
    <path
      opacity='0.62'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10 2.95337C9.94218 2.81793 9.87688 2.69007 9.8116 2.55469C9.83336 2.59982 10.051 3.02857 9.80469 3.33694C9.80469 3.33694 9.99312 3.18654 10 2.95337Z'
      fill='#595961'
    />
    <path
      opacity='0.62'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.60208 2.27663C9.48586 2.17885 9.37012 2.08859 9.25391 2.00586C9.29743 2.04346 9.68167 2.32176 9.65991 2.74303C9.6525 2.74303 9.7178 2.4948 9.60208 2.27663Z'
      fill='#595961'
    />
    <path
      opacity='0.62'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.82656 3.02969C7.9136 2.93943 7.98579 2.84165 8.06541 2.73633C8.03673 2.7664 7.7974 3.07482 7.37012 2.96197C7.37012 2.96197 7.61638 3.09741 7.82656 3.02969Z'
      fill='#595961'
    />
    <path
      opacity='0.62'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.09414 2.68239C8.19552 2.6072 8.28948 2.53195 8.38394 2.44922C8.34784 2.47181 8.05063 2.71999 7.6377 2.53948C7.6377 2.53948 7.87654 2.71246 8.09414 2.68239Z'
      fill='#595961'
    />
    <path
      opacity='0.62'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.4858 2.43517C8.60894 2.39757 8.72517 2.35244 8.84089 2.30731C8.79737 2.32232 8.42793 2.45771 8.06543 2.17188C8.07285 2.17188 8.26128 2.39757 8.4858 2.43517Z'
      fill='#595961'
    />
    <path
      opacity='0.62'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.84036 2.29894C8.94174 2.314 9.04312 2.32153 9.1445 2.32906C9.1084 2.32153 8.7894 2.29894 8.6084 1.99805C8.6084 1.99805 8.68112 2.20115 8.84036 2.29894Z'
      fill='#595961'
    />
    <path
      opacity='0.62'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.26088 2.46511C9.33309 2.54789 9.41319 2.63062 9.49973 2.70582C9.47105 2.67575 9.22478 2.42751 9.28265 2.11914C9.27523 2.11914 9.1956 2.29213 9.26088 2.46511Z'
      fill='#595961'
    />
    <path
      opacity='0.74'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.1377 4.6836C10.1377 4.60083 10.0581 2.69778 9.26835 2.11863C9.11604 2.00578 8.94937 1.95312 8.77529 1.95312C8.64474 1.95312 8.50724 1.98319 8.36234 2.04338C7.73181 2.29162 7.28971 2.96107 7.0726 3.98403C6.90594 4.75128 6.92769 5.43579 6.92769 5.46586C6.92769 5.48845 6.94946 5.51099 6.97121 5.51099H6.97813C6.99989 5.51099 7.01474 5.49598 7.01474 5.47339C7.01474 5.44332 6.94203 2.69778 8.39844 2.1111C8.71742 1.98319 8.99289 2.00578 9.22483 2.17877C9.97801 2.7279 10.0581 4.64601 10.0581 4.66855C10.0581 4.69114 10.0799 4.71367 10.1016 4.71367C10.1016 4.71367 10.1016 4.71367 10.1086 4.71367C10.1234 4.7212 10.1377 4.70615 10.1377 4.6836Z'
      fill='url(#paint0_linear_16013_239882)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.2612 3.74307C10.0946 2.9307 9.81914 2.38157 9.43538 2.09574C9.2252 1.94534 9.00019 1.87762 8.75391 1.89268C8.94974 1.90769 9.13074 1.97541 9.2974 2.09574C9.68166 2.37409 9.95713 2.9307 10.1238 3.74307C10.2395 4.31474 10.2612 4.81116 10.2612 4.83375C10.2612 4.92401 10.2177 4.99172 10.145 5.01426C10.1599 5.02179 10.1742 5.02179 10.1816 5.02179C10.3048 5.03685 10.3987 4.95407 10.3918 4.83375C10.3987 4.81116 10.377 4.32227 10.2612 3.74307Z'
      fill='url(#paint1_linear_16013_239882)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.43489 2.41251C7.07244 2.96159 7.13769 5.60181 7.13769 5.63188C7.13769 5.72214 7.09418 5.78986 7.02148 5.8124C7.03632 5.81993 7.04326 5.81993 7.0581 5.81993C7.06502 5.81993 7.07985 5.81993 7.08677 5.81993C7.19557 5.81993 7.26776 5.7372 7.26776 5.63188C7.26776 5.60181 7.203 2.96912 8.56495 2.42004C8.65941 2.38244 8.74643 2.35985 8.82605 2.35232C8.70983 2.32978 8.57979 2.35232 8.43489 2.41251Z'
      fill='url(#paint2_linear_16013_239882)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.4997 3.06671L4.35506 5.03743C4.35506 5.03743 4.09444 5.11267 4.02916 5.1954C3.96388 5.27813 3.94953 5.51131 3.94953 5.51131L3 13.1085L10.1303 14.4925L10.6812 3.05918C10.6016 3.04412 10.5214 3.05918 10.4997 3.06671Z'
      fill='url(#paint3_linear_16013_239882)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.6229 4.04395C12.6229 4.04395 12.6155 3.98376 12.5794 3.96122C12.5502 3.93863 12.5141 3.93864 12.5141 3.93864L11.5068 3.86344L10.7679 3.10372C10.7387 3.08113 10.7096 3.06612 10.6735 3.05859L10.123 14.4919L13.9849 13.6269L12.6229 4.04395Z'
      fill='url(#paint4_linear_16013_239882)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.96383 9.4141C7.85503 9.26365 7.72496 9.12826 7.5944 9.00789C7.46384 8.88756 7.32637 8.78977 7.18839 8.69951C7.09443 8.63932 7.00739 8.57914 6.9347 8.51895C6.86249 8.45881 6.80462 8.39862 6.76111 8.34596C6.71759 8.28577 6.68148 8.23311 6.65972 8.17297C6.63796 8.11279 6.63053 8.0526 6.63053 7.99241C6.63053 7.90968 6.6523 7.82695 6.68148 7.75923C6.71016 7.69157 6.7611 7.63138 6.81154 7.57872C6.8699 7.52606 6.93469 7.48846 7.0148 7.45839C7.09442 7.42827 7.18837 7.41326 7.28975 7.40573C7.39855 7.3982 7.50736 7.40573 7.60874 7.41326C7.71012 7.42074 7.80457 7.44333 7.89854 7.46587C7.98558 7.48846 8.07261 7.51853 8.14481 7.54865C8.21751 7.57872 8.28971 7.60879 8.34065 7.63891L8.81888 6.16461C8.74668 6.12701 8.65964 6.08936 8.56519 6.06682C8.46381 6.0367 8.355 6.01416 8.23186 5.9991C8.10872 5.98409 7.97816 5.97656 7.84067 5.97656C7.70319 5.97656 7.55831 5.98409 7.40599 6.00663C7.08009 6.05176 6.78979 6.14202 6.52917 6.27741C6.28289 6.40531 6.06529 6.57077 5.88428 6.77387C5.71021 6.96945 5.57271 7.1951 5.47133 7.45086C5.37688 7.69909 5.31903 7.9774 5.30469 8.27824C5.29727 8.45881 5.31161 8.62427 5.35513 8.77471C5.39123 8.92516 5.44958 9.06808 5.5292 9.20346C5.6014 9.33885 5.69585 9.45923 5.79723 9.57202C5.89861 9.68487 6.02175 9.79019 6.14489 9.88798C6.24628 9.96318 6.33332 10.0384 6.40602 10.1061C6.47822 10.1738 6.53658 10.2415 6.57961 10.3167C6.62313 10.3844 6.65229 10.4521 6.67405 10.5273C6.69581 10.595 6.70324 10.6702 6.69582 10.7455C6.69582 10.8207 6.67407 10.8959 6.6449 10.9561C6.61621 11.0163 6.57961 11.0764 6.52174 11.1216C6.4713 11.1667 6.40603 11.1968 6.33333 11.2118C6.26113 11.2268 6.17409 11.2344 6.07964 11.2194C5.97133 11.2043 5.86251 11.1742 5.76113 11.1291C5.65975 11.0915 5.5579 11.0388 5.46394 10.9861C5.36998 10.9335 5.28294 10.8733 5.21024 10.8207C5.13062 10.768 5.06533 10.7078 5.01489 10.6627L4.68848 11.7835C4.73941 11.8587 4.81163 11.9264 4.89125 11.9941C4.97137 12.0618 5.06534 12.1295 5.17414 12.1972C5.28294 12.2574 5.39866 12.3175 5.5218 12.3702C5.64494 12.4228 5.7829 12.468 5.92038 12.5056H5.92781H5.93472H5.94215H5.94957C6.2463 12.5733 6.52917 12.5883 6.79721 12.5507C7.07266 12.5131 7.32635 12.4153 7.54345 12.2649C7.76797 12.1069 7.94947 11.8963 8.08695 11.618C8.22492 11.3397 8.30454 11.0012 8.31888 10.6176C8.3263 10.3769 8.29714 10.1663 8.23186 9.97071C8.16658 9.74506 8.07262 9.57202 7.96383 9.4141Z'
      fill='url(#paint5_linear_16013_239882)'
    />
    <path
      opacity='0.226763'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.73541 11.8457C4.71859 11.8258 4.70275 11.8054 4.68841 11.7845L5.01482 10.6637C5.01927 10.6679 5.02422 10.6722 5.02916 10.6767C5.07763 10.72 5.13797 10.7739 5.21018 10.8217C5.28287 10.8744 5.36991 10.9346 5.46387 10.9872C5.55784 11.0398 5.65969 11.0925 5.76107 11.1301C5.86245 11.1753 5.97127 11.2053 6.07957 11.2204C6.17403 11.2354 6.26107 11.2279 6.33327 11.2129C6.40597 11.1978 6.47124 11.1677 6.52168 11.1226C6.57954 11.0775 6.61615 11.0173 6.64483 10.9571C6.67401 10.8969 6.69575 10.8217 6.69575 10.7465C6.70317 10.6713 6.69575 10.5961 6.67399 10.5283C6.65223 10.4531 6.62306 10.3854 6.57954 10.3178C6.5385 10.2463 6.48409 10.1816 6.41634 10.1172C6.45194 10.1574 6.48212 10.1987 6.50734 10.2425C6.55086 10.3102 6.57955 10.3779 6.60131 10.4531C6.62307 10.5208 6.63049 10.5961 6.62307 10.6713C6.62307 10.7465 6.60131 10.8217 6.57263 10.8819C6.54345 10.9421 6.50734 11.0022 6.44948 11.0474C6.39854 11.0925 6.33327 11.1226 6.26107 11.1376C6.18837 11.1527 6.10133 11.1602 6.00737 11.1451C5.89857 11.1301 5.78976 11.1 5.68838 11.0549C5.587 11.0173 5.48562 10.9646 5.39116 10.912C5.2972 10.8593 5.21018 10.7992 5.13798 10.7465C5.06528 10.6987 5.00494 10.6448 4.95648 10.6015C4.95153 10.597 4.94706 10.5927 4.94211 10.5885L4.61621 11.7093C4.64836 11.7572 4.68942 11.802 4.73541 11.8457ZM5.80311 9.57989C5.77591 9.55297 5.74971 9.52566 5.72448 9.49786C5.6231 9.38501 5.52915 9.26468 5.45645 9.12929C5.37683 8.99386 5.31896 8.85094 5.28286 8.70054C5.23934 8.5501 5.22449 8.38459 5.23191 8.20407C5.24625 7.90318 5.30462 7.62488 5.39859 7.37664C5.49997 7.12093 5.63795 6.89528 5.81154 6.69971C5.99303 6.4966 6.21011 6.33109 6.45639 6.20324C6.71751 6.06785 7.00731 5.97759 7.33321 5.93246C7.48553 5.90987 7.63044 5.90234 7.76793 5.90234C7.9059 5.90234 8.03646 5.90987 8.1596 5.92493C8.28274 5.93999 8.39154 5.96253 8.49292 5.99265C8.58688 6.01519 8.67392 6.05279 8.74662 6.09039L8.73524 6.12558C8.68282 6.10279 8.62545 6.08227 8.56512 6.06785C8.46374 6.03778 8.35494 6.01519 8.2318 6.00013C8.10866 5.98512 7.97809 5.97759 7.84061 5.97759C7.70313 5.97759 7.55824 5.98512 7.40593 6.00766C7.08003 6.05279 6.78973 6.14305 6.52911 6.27849C6.28283 6.40634 6.06522 6.5718 5.88422 6.7749C5.71014 6.97048 5.57265 7.19612 5.47127 7.45189C5.37681 7.70012 5.31896 7.97843 5.30462 8.27927C5.2972 8.45984 5.31154 8.62529 5.35506 8.77574C5.39116 8.92619 5.44951 9.06911 5.52913 9.20449C5.60133 9.33988 5.69579 9.46026 5.79717 9.57305C5.79915 9.57532 5.80114 9.57763 5.80311 9.57989ZM6.78724 8.3778C6.8268 8.42253 6.87627 8.47126 6.93463 8.51998C7.00733 8.58017 7.09437 8.64035 7.18833 8.70054C7.3263 8.7908 7.46378 8.88859 7.59434 9.00892C7.63242 9.04396 7.67 9.08023 7.70759 9.11783C7.64725 9.05296 7.58443 8.99159 7.52162 8.93372C7.39156 8.81334 7.25361 8.71555 7.11613 8.62529C7.02167 8.5651 6.93463 8.50497 6.86243 8.44478C6.83523 8.42234 6.81048 8.39989 6.78724 8.3778Z'
      fill='black'
    />
    <path
      opacity='0.41'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.7529 12.3635L11.5067 3.86372L11.4631 3.81859L11.5794 12.2432C11.5794 12.2432 10.5577 13.8528 10.4053 13.8077C10.1808 13.74 10.8475 3.18673 10.8475 3.18673L10.7748 3.11154C10.7461 3.08895 10.7095 3.07394 10.6808 3.06641L10.1373 14.3418L10.1299 14.4998L10.3183 14.2515L11.7529 12.3635Z'
      fill='url(#paint6_linear_16013_239882)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.97823 3.55474C8.89168 3.90825 8.7829 4.23921 8.70328 4.44231C8.65234 4.56269 8.71021 4.67549 8.819 4.69055C8.93522 4.70561 9.06528 4.62283 9.1088 4.5025C9.11622 4.47991 9.31155 3.99102 9.43518 3.41183V3.4043L8.97823 3.55474Z'
      fill='url(#paint7_linear_16013_239882)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.71001 4.60858C5.60863 4.83423 5.50725 5.0298 5.43455 5.16519C5.36976 5.27804 5.40586 5.39836 5.51466 5.42843C5.62296 5.46608 5.76785 5.39837 5.83313 5.28552C5.84055 5.27051 6.05075 4.90195 6.23917 4.43555L5.71001 4.60858Z'
      fill='url(#paint8_linear_16013_239882)'
    />
    <path
      opacity='0.32'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.1299 14.492L11.7529 12.3633L13.9996 13.627L10.1299 14.492Z'
      fill='url(#paint9_linear_16013_239882)'
    />
    <path
      opacity='0.19'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.1299 14.492L11.7386 12.3633L13.9996 13.627L10.1299 14.492Z'
      fill='url(#paint10_linear_16013_239882)'
    />
    <path
      opacity='0.19'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.1299 14.492L11.7386 12.3633L13.9996 13.627L10.1299 14.492Z'
      fill='url(#paint11_linear_16013_239882)'
    />
    <path
      opacity='0.6'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.55085 8.53484C9.39157 9.71578 9.95679 10.9945 10.2392 12.2356L10.6813 3.05134C10.6017 3.03633 10.5216 3.05134 10.4998 3.05887L4.35519 5.03717C4.35519 5.03717 4.29731 5.05218 4.22461 5.0823C5.7829 5.63891 7.34072 6.8349 8.55085 8.53484Z'
      fill='url(#paint12_linear_16013_239882)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.5864 3.96827C12.623 3.99838 12.623 4.04351 12.623 4.04351L13.9706 13.6189L11.7531 12.3552L11.5068 3.85547L12.4999 3.93067C12.5068 3.9382 12.5503 3.9382 12.5864 3.96827Z'
      fill='url(#paint13_linear_16013_239882)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.4276 3.99142C12.4276 3.99142 12.4711 3.99142 12.5072 4.02902C12.5433 4.05914 12.5507 4.10427 12.5507 4.10427L13.877 13.5744L13.9784 13.6346L12.6303 4.05161C12.6303 4.05161 12.6234 4.00648 12.5942 3.97641C12.5581 3.94629 12.5072 3.94629 12.5072 3.94629L11.5146 3.87109L12.4276 3.99142Z'
      fill='url(#paint14_linear_16013_239882)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3 13.1081L10.1303 14.4922L10.4784 6.6543L3.88669 6.84167L3 13.1081Z'
      fill='url(#paint15_linear_16013_239882)'
    />
    <path
      opacity='0.3'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.34074 5.14752C5.27595 5.33035 5.33974 5.52243 5.48414 5.57667C5.62806 5.63085 5.79719 5.52662 5.86247 5.34384C5.92726 5.16106 5.86298 4.96892 5.71907 4.91474C5.57516 4.86051 5.40552 4.96474 5.34074 5.14752Z'
      fill='white'
    />
    <path
      opacity='0.89'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.33285 5.05968C5.26807 5.24246 5.33235 5.43459 5.47626 5.48878C5.62017 5.54301 5.7898 5.43877 5.85458 5.25599C5.91937 5.07317 5.85558 4.88103 5.71118 4.82685C5.56727 4.77262 5.39813 4.87685 5.33285 5.05968Z'
      fill='black'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.5141 3.86344L10.7748 3.10372C10.7461 3.08113 10.7095 3.06612 10.6808 3.05859L10.1299 14.4919L11.7604 12.3557L11.5141 3.86344Z'
      fill='url(#paint16_linear_16013_239882)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.4995 3.06662L4.35491 5.03734C4.35491 5.03734 4.0943 5.11258 4.02902 5.19531C4.0216 5.20284 4.02157 5.21037 4.01465 5.2179L10.2097 3.44271C10.2607 3.42765 10.3838 3.38252 10.3695 3.75108L9.99263 14.4774L10.1232 14.5L10.6736 3.06662C10.6014 3.04403 10.5213 3.05909 10.4995 3.06662Z'
      fill='url(#paint17_linear_16013_239882)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.4995 3.06662L4.35491 5.03734C4.35491 5.03734 4.0943 5.11258 4.02902 5.19531C4.0216 5.20284 4.02157 5.21037 4.01465 5.2179L5.4493 4.80416L10.3838 3.21706C10.4056 3.20953 10.4852 3.19448 10.5648 3.20954L10.0213 14.4774L10.1232 14.5L10.6736 3.06662C10.6014 3.04403 10.5213 3.05909 10.4995 3.06662Z'
      fill='url(#paint18_linear_16013_239882)'
    />
    <path
      opacity='0.32'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.0794 12.5435L11.753 12.3555L10.123 14.4917L10.2096 14.4691C10.2096 14.4691 11.6447 12.551 11.7748 12.4909C11.8692 12.4533 12.0794 12.5435 12.0794 12.5435Z'
      fill='url(#paint19_linear_16013_239882)'
    />
    <path
      opacity='0.57'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.1299 14.4917L11.7604 12.3555C11.753 12.363 10.7243 13.5289 10.1299 14.4917Z'
      fill='url(#paint20_linear_16013_239882)'
    />
    <path
      opacity='0.46'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.0002 13.627L11.7609 12.3633C11.7535 12.3633 12.0146 12.4084 14.0002 13.627Z'
      fill='url(#paint21_linear_16013_239882)'
    />
    <path
      opacity='0.3'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.65346 4.3975C8.58818 4.58033 8.65247 4.77246 8.79638 4.8267C8.94079 4.88093 9.10993 4.7767 9.17471 4.59392C9.23999 4.41109 9.1757 4.21896 9.03179 4.16472C8.88788 4.11054 8.71824 4.21472 8.65346 4.3975Z'
      fill='white'
    />
    <path
      opacity='0.89'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.64535 4.30963C8.58056 4.49246 8.64487 4.68459 8.78878 4.73882C8.93269 4.79301 9.10229 4.68882 9.16708 4.50599C9.23186 4.32321 9.16807 4.13108 9.02416 4.07685C8.87975 4.02262 8.71062 4.12685 8.64535 4.30963Z'
      fill='black'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.59465 5.42903C5.58724 5.42903 5.57288 5.42903 5.56547 5.42903C5.44974 5.41402 5.37014 5.30118 5.38448 5.17332C5.39882 5.05294 5.81175 2.23973 7.50752 1.6004C7.9348 1.44242 8.29729 1.47249 8.57275 1.70571C8.90607 1.98402 9.08707 2.54063 9.11625 3.353C9.13801 3.92467 9.07275 4.42109 9.07275 4.44368C9.05841 4.564 8.94961 4.65431 8.83339 4.63172C8.71767 4.61666 8.63061 4.50387 8.65237 4.38349C8.71765 3.87201 8.78985 2.46543 8.30471 2.05922C8.1524 1.93136 7.94224 1.9163 7.65986 2.02162C6.20344 2.5707 5.81916 5.21092 5.81916 5.23346C5.78999 5.34631 5.70345 5.42903 5.59465 5.42903Z'
      fill='#595961'
    />
    <path
      opacity='0.46'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.48518 1.72093C8.23148 1.51034 7.89817 1.48027 7.49958 1.62319C6.81118 1.88643 6.23155 2.57843 5.83295 3.62398C5.53623 4.39875 5.43437 5.09827 5.43437 5.12839C5.42745 5.16599 5.4418 5.20359 5.46356 5.23371C5.48532 5.26378 5.51448 5.28637 5.55058 5.28637C5.5575 5.28637 5.56493 5.28637 5.57234 5.28637C5.63762 5.28637 5.69547 5.23371 5.70289 5.16599C5.70981 5.13592 6.09409 2.45057 7.59402 1.88643C7.89816 1.77359 8.14443 1.78865 8.3185 1.93909C8.83282 2.36784 8.76063 3.81955 8.69535 4.33856C8.68793 4.41381 8.73888 4.48901 8.81108 4.49654C8.88378 4.50407 8.95597 4.45141 8.96339 4.37621C8.97081 4.29343 9.22451 2.33777 8.48518 1.72093Z'
      fill='#B2B2C2'
    />
    <path
      opacity='0.81'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.56515 5.20362C5.55773 5.20362 5.55774 5.20362 5.55082 5.20362C5.5073 5.19609 5.47811 5.15097 5.48553 5.10584C5.49294 5.07572 5.58692 4.39125 5.88414 3.61648C6.28274 2.58599 6.84798 1.90148 7.52154 1.64571C7.9058 1.5028 8.21736 1.53291 8.45623 1.72849C9.16638 2.3227 8.9201 4.24834 8.90576 4.33106C8.89834 4.37619 8.86225 4.40626 8.81131 4.39878C8.76829 4.39125 8.73911 4.35365 8.73911 4.30099C8.73911 4.27841 8.98538 2.39042 8.34793 1.84882C8.15951 1.7059 7.8984 1.69089 7.57992 1.81122C6.05081 2.39042 5.6522 5.10584 5.6522 5.13591C5.64479 5.17351 5.60867 5.20362 5.56515 5.20362Z'
      fill='#B2B2C2'
    />
    <path
      opacity='0.42'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.52147 3.05105C6.6011 2.93825 6.67378 2.82541 6.74599 2.70508C6.7173 2.74268 6.50712 3.13383 6.07242 3.07364C6.06501 3.07364 6.31871 3.15637 6.52147 3.05105Z'
      fill='#595961'
    />
    <path
      opacity='0.42'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.27515 3.53263C6.34043 3.41225 6.40569 3.28439 6.45613 3.16406C6.43437 3.20919 6.28947 3.61535 5.83301 3.61535C5.83301 3.61535 6.08673 3.66801 6.27515 3.53263Z'
      fill='#595961'
    />
    <path
      opacity='0.42'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.08703 4.03011C6.14489 3.9022 6.18842 3.77434 6.23194 3.64648C6.21018 3.69161 6.13056 4.1053 5.65234 4.15796C5.65234 4.15043 5.91295 4.18055 6.08703 4.03011Z'
      fill='#595961'
    />
    <path
      opacity='0.62'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.98522 2.56274C8.94912 2.42731 8.91301 2.29945 8.86207 2.16406C8.87641 2.20919 9.02133 2.63794 8.72461 2.94632C8.72461 2.94632 8.9417 2.79592 8.98522 2.56274Z'
      fill='#595961'
    />
    <path
      opacity='0.62'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.70309 1.88601C8.60171 1.78822 8.49982 1.69796 8.39844 1.61523C8.43503 1.65283 8.77529 1.93114 8.68132 2.35236C8.67391 2.35236 8.78271 2.10412 8.70309 1.88601Z'
      fill='#595961'
    />
    <path
      opacity='0.62'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.05783 3.25554C9.05041 3.12015 9.02867 2.97723 9.00691 2.8418C9.00691 2.89446 9.0796 3.33826 8.73145 3.57897C8.73145 3.57897 8.97079 3.47365 9.05783 3.25554Z'
      fill='#595961'
    />
    <path
      opacity='0.62'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.09396 3.96252C9.10138 3.82713 9.10138 3.68422 9.09396 3.54883C9.09396 3.60149 9.10136 4.0453 8.73145 4.24835C8.73145 4.24087 8.98516 4.16562 9.09396 3.96252Z'
      fill='#595961'
    />
    <path
      opacity='0.42'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.92035 4.57837C5.96386 4.44298 5.99305 4.30759 6.02173 4.17969C6.00739 4.22482 5.94212 4.65357 5.5 4.75888C5.50742 4.75888 5.76803 4.75136 5.92035 4.57837Z'
      fill='#595961'
    />
    <path
      opacity='0.42'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.79671 2.63711C6.89809 2.54686 6.99252 2.44907 7.07956 2.34375C7.04297 2.37382 6.75318 2.68224 6.34766 2.5694C6.35458 2.5694 6.57911 2.70483 6.79671 2.63711Z'
      fill='#595961'
    />
    <path
      opacity='0.42'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.1226 2.29177C7.23882 2.21657 7.34762 2.14132 7.45592 2.05859C7.4129 2.08118 7.07957 2.32937 6.69531 2.14885C6.69531 2.14885 6.89808 2.32184 7.1226 2.29177Z'
      fill='#595961'
    />
    <path
      opacity='0.62'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.5653 2.04454C7.69585 2.0069 7.81901 1.96177 7.94215 1.91664C7.89863 1.9317 7.50745 2.06708 7.18848 1.78125C7.18848 1.78125 7.34078 2.0069 7.5653 2.04454Z'
      fill='#595961'
    />
    <path
      opacity='0.62'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.93492 1.90831C8.0368 1.92337 8.13819 1.9309 8.23957 1.93843C8.20347 1.9309 7.89188 1.90832 7.75391 1.60742C7.76132 1.60742 7.79744 1.81053 7.93492 1.90831Z'
      fill='#595961'
    />
    <path
      opacity='0.62'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.32627 2.07454C8.39155 2.15727 8.45635 2.23999 8.52162 2.31524C8.49986 2.28512 8.29709 2.03694 8.39847 1.72852C8.40589 1.72852 8.29709 1.90155 8.32627 2.07454Z'
      fill='#595961'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.82596 4.29293C8.83288 4.2102 9.07967 2.30715 8.39128 1.72796C8.26072 1.61516 8.10148 1.5625 7.9274 1.5625C7.79685 1.5625 7.65195 1.59257 7.49963 1.65276C6.833 1.90099 6.27514 2.57045 5.88396 3.59341C5.58675 4.36065 5.49277 5.04516 5.48535 5.07523C5.48535 5.09777 5.49972 5.12036 5.52148 5.12036H5.52888C5.55064 5.12036 5.56498 5.1053 5.56498 5.08276C5.5724 5.05264 5.96357 2.30715 7.52137 1.72043C7.85469 1.59257 8.13756 1.61516 8.34032 1.78815C8.99954 2.33722 8.75329 4.25533 8.74636 4.27792C8.74636 4.30046 8.7607 4.32305 8.78246 4.32305C8.78246 4.32305 8.78245 4.32305 8.78938 4.32305C8.81113 4.33058 8.82596 4.31552 8.82596 4.29293Z'
      fill='url(#paint22_linear_16013_239882)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.11609 3.35244C9.08691 2.54007 8.90591 1.99095 8.57259 1.70511C8.39159 1.55471 8.17401 1.487 7.92773 1.50205C8.11615 1.51707 8.28974 1.58478 8.43513 1.70511C8.76845 1.98347 8.94943 2.54007 8.97811 3.35244C8.99987 3.92411 8.9351 4.42053 8.9351 4.44312C8.92027 4.53338 8.8624 4.6011 8.7897 4.62364C8.80454 4.63117 8.81145 4.63117 8.82629 4.63117C8.94201 4.64623 9.05082 4.56345 9.06517 4.44312C9.07258 4.42053 9.13785 3.93164 9.11609 3.35244Z'
      fill='url(#paint23_linear_16013_239882)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.51487 2.0218C6.05846 2.57088 5.67421 5.2111 5.67421 5.24117C5.65987 5.33143 5.6015 5.39915 5.5293 5.42169C5.54364 5.42922 5.55106 5.42922 5.5654 5.42922C5.57282 5.42922 5.58717 5.42922 5.59459 5.42922C5.70338 5.42922 5.78992 5.34649 5.80476 5.24117C5.81168 5.2111 6.18852 2.57841 7.64494 2.02928C7.74681 1.99168 7.83337 1.96914 7.91349 1.96161C7.80469 1.94655 7.6667 1.96914 7.51487 2.0218Z'
      fill='url(#paint24_linear_16013_239882)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_16013_239882'
        x1='7.30552'
        y1='1.9701'
        x2='7.07826'
        y2='5.06419'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' stopOpacity='0.65' />
        <stop offset='1' stopColor='white' stopOpacity='0.01' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_16013_239882'
        x1='8.96656'
        y1='3.74081'
        x2='10.5666'
        y2='5.14221'
        gradientUnits='userSpaceOnUse'>
        <stop stopOpacity='0.01' />
        <stop offset='1' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_16013_239882'
        x1='8.32459'
        y1='5.36283'
        x2='10.0181'
        y2='3.78539'
        gradientUnits='userSpaceOnUse'>
        <stop stopOpacity='0.01' />
        <stop offset='1' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_16013_239882'
        x1='6.16901'
        y1='0.759318'
        x2='-0.408908'
        y2='8.33852'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#B8D26E' />
        <stop offset='1' stopColor='#7FB525' />
      </linearGradient>
      <linearGradient
        id='paint4_linear_16013_239882'
        x1='15.1668'
        y1='2.65622'
        x2='11.5567'
        y2='2.72326'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#B4E034' />
        <stop offset='1' stopColor='#60A927' />
      </linearGradient>
      <linearGradient
        id='paint5_linear_16013_239882'
        x1='4.42934'
        y1='7.70953'
        x2='1.46954'
        y2='14.9172'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='#CECEEB' />
      </linearGradient>
      <linearGradient
        id='paint6_linear_16013_239882'
        x1='8.67249'
        y1='25.4606'
        x2='13.3602'
        y2='25.4511'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#1D1D1B' stopOpacity='0.5' />
        <stop offset='0.038033' stopColor='#1D1D1B' stopOpacity='0.4837' />
        <stop offset='0.4243' stopColor='#1D1D1B' stopOpacity='0.3185' />
        <stop offset='1' stopColor='#1D1D1B' stopOpacity='0.01' />
      </linearGradient>
      <linearGradient
        id='paint7_linear_16013_239882'
        x1='9.21759'
        y1='2.89946'
        x2='8.4399'
        y2='3.31802'
        gradientUnits='userSpaceOnUse'>
        <stop stopOpacity='0.01' />
        <stop offset='1' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint8_linear_16013_239882'
        x1='5.95679'
        y1='4.14169'
        x2='5.41011'
        y2='4.61151'
        gradientUnits='userSpaceOnUse'>
        <stop stopOpacity='0.01' />
        <stop offset='1' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint9_linear_16013_239882'
        x1='11.2891'
        y1='13.6326'
        x2='11.3444'
        y2='14.3622'
        gradientUnits='userSpaceOnUse'>
        <stop stopOpacity='0.01' />
        <stop offset='1' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint10_linear_16013_239882'
        x1='9.99685'
        y1='12.5645'
        x2='10.1252'
        y2='14.4614'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' stopOpacity='0.5' />
        <stop offset='0.0896271' stopColor='white' stopOpacity='0.4552' />
        <stop offset='1' stopColor='white' stopOpacity='0.01' />
      </linearGradient>
      <linearGradient
        id='paint11_linear_16013_239882'
        x1='9.75008'
        y1='12.8596'
        x2='9.97833'
        y2='14.8858'
        gradientUnits='userSpaceOnUse'>
        <stop stopOpacity='0.01' />
        <stop offset='1' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint12_linear_16013_239882'
        x1='8.85498'
        y1='1.20169'
        x2='3.00103'
        y2='4.58738'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' stopOpacity='0.5' />
        <stop offset='1' stopColor='white' stopOpacity='0.01' />
      </linearGradient>
      <linearGradient
        id='paint13_linear_16013_239882'
        x1='9.98415'
        y1='18.8958'
        x2='15.1511'
        y2='18.9062'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#1D1D1B' stopOpacity='0.5' />
        <stop offset='0.0896271' stopColor='#1D1D1B' stopOpacity='0.4552' />
        <stop offset='1' stopColor='#1D1D1B' stopOpacity='0.01' />
      </linearGradient>
      <linearGradient
        id='paint14_linear_16013_239882'
        x1='13.6847'
        y1='3.58605'
        x2='12.9507'
        y2='3.76589'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' stopOpacity='0.4' />
        <stop offset='1' stopColor='white' stopOpacity='0.01' />
      </linearGradient>
      <linearGradient
        id='paint15_linear_16013_239882'
        x1='7.09923'
        y1='14.5759'
        x2='7.4809'
        y2='12.7358'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#1D1D1B' stopOpacity='0.5' />
        <stop offset='0.0896271' stopColor='#1D1D1B' stopOpacity='0.4552' />
        <stop offset='1' stopColor='#1D1D1B' stopOpacity='0.01' />
      </linearGradient>
      <linearGradient
        id='paint16_linear_16013_239882'
        x1='9.30549'
        y1='25.2261'
        x2='14.01'
        y2='25.2302'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#1D1D1B' stopOpacity='0.5' />
        <stop offset='1' stopColor='#1D1D1B' stopOpacity='0.01' />
      </linearGradient>
      <linearGradient
        id='paint17_linear_16013_239882'
        x1='5.00669'
        y1='2.40376'
        x2='2.72501'
        y2='11.1699'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' stopOpacity='0.5' />
        <stop offset='1' stopColor='white' stopOpacity='0.01' />
      </linearGradient>
      <linearGradient
        id='paint18_linear_16013_239882'
        x1='5.00669'
        y1='2.40376'
        x2='2.72501'
        y2='11.1699'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' stopOpacity='0.5' />
        <stop offset='1' stopColor='white' stopOpacity='0.01' />
      </linearGradient>
      <linearGradient
        id='paint19_linear_16013_239882'
        x1='10.5439'
        y1='11.5924'
        x2='8.74044'
        y2='14.0746'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' stopOpacity='0.5' />
        <stop offset='0.0896271' stopColor='white' stopOpacity='0.4552' />
        <stop offset='1' stopColor='white' stopOpacity='0.01' />
      </linearGradient>
      <linearGradient
        id='paint20_linear_16013_239882'
        x1='11.0878'
        y1='12.163'
        x2='10.9092'
        y2='12.5633'
        gradientUnits='userSpaceOnUse'>
        <stop stopOpacity='0.01' />
        <stop offset='1' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint21_linear_16013_239882'
        x1='12.8593'
        y1='12.6926'
        x2='12.8504'
        y2='12.8002'
        gradientUnits='userSpaceOnUse'>
        <stop stopOpacity='0.01' />
        <stop offset='1' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint22_linear_16013_239882'
        x1='6.36464'
        y1='1.30929'
        x2='5.58499'
        y2='4.38928'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' stopOpacity='0.65' />
        <stop offset='1' stopColor='white' stopOpacity='0.01' />
      </linearGradient>
      <linearGradient
        id='paint23_linear_16013_239882'
        x1='8.10972'
        y1='3.08576'
        x2='9.46596'
        y2='4.46461'
        gradientUnits='userSpaceOnUse'>
        <stop stopOpacity='0.01' />
        <stop offset='1' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint24_linear_16013_239882'
        x1='7.24289'
        y1='5.117'
        x2='9.11673'
        y2='3.19257'
        gradientUnits='userSpaceOnUse'>
        <stop stopOpacity='0.01' />
        <stop offset='1' stopOpacity='0.4' />
      </linearGradient>
    </defs>
  </svg>
);

export const StarIconReview = (
  <svg
    width='15'
    height='15'
    viewBox='0 0 15 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <rect
      width='15.0099'
      height='15.0099'
      transform='translate(0 -0.0078125)'
      fill='white'
    />
    <path
      d='M7.50412 1.24219L9.43665 5.15727L13.7582 5.78894L10.6312 8.83469L11.3692 13.1375L7.50412 11.1049L3.63908 13.1375L4.37706 8.83469L1.25 5.78894L5.5716 5.15727L7.50412 1.24219Z'
      fill='#FEC84B'
      stroke='#FEC84B'
      strokeWidth='1.25082'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
export const BigCommerceSource = (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <rect width='16' height='16' rx='2' fill='white' />
    <g clip-path='url(#clip0_16293_167646)'>
      <path
        d='M8.29565 8.7623H9.68302C10.0776 8.7623 10.3274 8.54505 10.3274 8.19626C10.3274 7.86763 10.0776 7.63067 9.68302 7.63067H8.29565C8.24981 7.63067 8.20994 7.67009 8.20994 7.70951V8.68347C8.21681 8.7293 8.24936 8.7623 8.29565 8.7623ZM8.29565 11.0063H9.72931C10.1698 11.0063 10.4329 10.7826 10.4329 10.3875C10.4329 10.0456 10.1831 9.7688 9.72931 9.7688H8.29565C8.24981 9.7688 8.20994 9.80867 8.20994 9.84809V10.9206C8.21681 10.9733 8.24936 11.0063 8.29565 11.0063ZM13.3717 2.52438L9.26823 6.6173H9.93923C10.9847 6.6173 11.603 7.27501 11.603 7.9923C11.603 8.55834 11.2216 8.97313 10.8137 9.15692C10.7482 9.18351 10.7482 9.27563 10.8201 9.30176C11.2936 9.48601 11.6291 9.98009 11.6291 10.5585C11.6291 11.3743 11.0837 12.0261 10.0249 12.0261H7.11819C7.07236 12.0261 7.03248 11.9867 7.03248 11.9473V8.84801L2.52844 13.3351C2.46885 13.3947 2.50873 13.4996 2.59398 13.4996H13.4249C13.444 13.4994 13.4623 13.4917 13.4758 13.4782C13.4893 13.4646 13.497 13.4463 13.4973 13.4272V2.58351C13.517 2.51109 13.4249 2.47167 13.3721 2.52392L13.3717 2.52438Z'
        fill='black'
      />
    </g>
    <defs>
      <clipPath id='clip0_16293_167646'>
        <rect
          width='11'
          height='11'
          fill='white'
          transform='translate(2.5 2.5)'
        />
      </clipPath>
    </defs>
  </svg>
);

export const WooCommerceSource = (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <rect width='16' height='16' rx='2' fill='white' />
    <path
      d='M3.40623 4.99609H12.1939C12.75 4.99609 13.2001 5.44627 13.2001 6.00242V9.3568C13.2001 9.91291 12.75 10.3631 12.1938 10.3631H9.04249L9.47504 11.4224L7.5727 10.3631H3.41074C2.85459 10.3631 2.40433 9.91295 2.40433 9.3568V6.00242C2.39994 5.4507 2.85008 4.99609 3.40627 4.99609H3.40623Z'
      fill='#7F54B3'
    />
    <path
      d='M3.02082 5.91364C3.08226 5.83027 3.17441 5.78637 3.29729 5.77759C3.5211 5.76005 3.64837 5.86535 3.67911 6.09358C3.81516 7.01081 3.96436 7.78756 4.12233 8.42392L5.08341 6.5939C5.17121 6.42711 5.2809 6.33936 5.41256 6.33058C5.6057 6.31743 5.7242 6.44027 5.77245 6.6992C5.88213 7.28289 6.02256 7.77878 6.18935 8.20007C6.30346 7.08536 6.49657 6.2823 6.76865 5.78637C6.83448 5.66352 6.93101 5.60208 7.05829 5.59326C7.15924 5.58449 7.25143 5.61519 7.33476 5.68107C7.41817 5.74685 7.46203 5.83027 7.4708 5.93118C7.47519 6.01021 7.46203 6.076 7.42695 6.14183C7.25577 6.45782 7.11534 6.98883 7.00127 7.72607C6.89154 8.44146 6.85203 8.9988 6.87838 9.39816C6.88716 9.50784 6.86961 9.60437 6.82571 9.68779C6.77304 9.78436 6.69405 9.83699 6.59314 9.84576C6.47902 9.85453 6.36052 9.8019 6.24645 9.6834C5.83832 9.2665 5.51351 8.64333 5.2766 7.81387C4.99131 8.37559 4.78066 8.79688 4.64466 9.07774C4.38573 9.57367 4.16632 9.82822 3.98198 9.84137C3.86348 9.85015 3.76253 9.74919 3.67477 9.53859C3.45097 8.96362 3.20958 7.85334 2.95065 6.20766C2.9331 6.09358 2.95942 5.99263 3.02086 5.91364H3.02082ZM12.452 6.60263C12.294 6.32616 12.0614 6.15937 11.7498 6.09354C11.6665 6.076 11.5875 6.06723 11.5128 6.06723C11.0915 6.06723 10.7492 6.28664 10.4815 6.72552C10.2533 7.09852 10.1392 7.51108 10.1392 7.96307C10.1392 8.30099 10.2094 8.59058 10.3499 8.83201C10.5079 9.10848 10.7405 9.27523 11.052 9.3411C11.1354 9.35864 11.2144 9.36741 11.289 9.36741C11.7147 9.36741 12.057 9.148 12.3203 8.70912C12.5485 8.33169 12.6626 7.91917 12.6626 7.46718C12.667 7.12488 12.5924 6.83963 12.452 6.60263ZM11.899 7.81826C11.8376 8.10789 11.7279 8.32292 11.5655 8.46778C11.4382 8.58189 11.3197 8.63014 11.21 8.60821C11.1047 8.58628 11.0169 8.49409 10.9511 8.32296C10.8984 8.18692 10.8721 8.05087 10.8721 7.9236C10.8721 7.81387 10.8809 7.70418 10.9028 7.60323C10.9423 7.42332 11.0169 7.24777 11.1354 7.08098C11.2802 6.86595 11.4338 6.77819 11.5918 6.80889C11.6972 6.83082 11.785 6.92301 11.8507 7.09418C11.9034 7.23022 11.9297 7.36627 11.9297 7.49354C11.9297 7.60761 11.921 7.71734 11.899 7.81826ZM9.70474 6.60263C9.54672 6.32616 9.30976 6.15937 9.00259 6.09354C8.91921 6.076 8.84023 6.06723 8.76558 6.06723C8.34429 6.06723 8.00199 6.28664 7.73429 6.72552C7.5061 7.09852 7.39199 7.51108 7.39199 7.96307C7.39199 8.30099 7.4622 8.59058 7.60263 8.83201C7.76065 9.10848 7.99322 9.27523 8.30478 9.3411C8.38815 9.35864 8.46714 9.36741 8.54178 9.36741C8.96746 9.36741 9.30972 9.148 9.57308 8.70912C9.80127 8.33169 9.91538 7.91917 9.91538 7.46718C9.91538 7.12488 9.84517 6.83963 9.70474 6.60263ZM9.1474 7.81826C9.08596 8.10789 8.97623 8.32292 8.81383 8.46778C8.6866 8.58189 8.5681 8.63014 8.45841 8.60821C8.35307 8.58628 8.26527 8.49409 8.19948 8.32296C8.14681 8.18692 8.12049 8.05087 8.12049 7.9236C8.12049 7.81387 8.12926 7.70418 8.15119 7.60323C8.19071 7.42332 8.26531 7.24777 8.38377 7.08098C8.52862 6.86595 8.68221 6.77819 8.84019 6.80889C8.94553 6.83082 9.03333 6.92301 9.09912 7.09418C9.15179 7.23022 9.1781 7.36627 9.1781 7.49354C9.18249 7.60761 9.16933 7.71734 9.1474 7.81826Z'
      fill='white'
    />
  </svg>
);

export const EtsySource = (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <rect width='16' height='16' rx='2' fill='white' />
    <g clip-path='url(#clip0_16293_166263)'>
      <path
        d='M6.37295 3.98622C6.37295 3.84968 6.38682 3.76775 6.62084 3.76775H9.75717C10.3034 3.76775 10.6059 4.23411 10.8243 5.10926L11.0008 5.80921H11.5344C11.631 3.82279 11.715 2.95898 11.715 2.95898C11.715 2.95898 10.3723 3.11023 9.57651 3.11023H5.56461L3.41602 3.04133V3.61692L4.14076 3.75389C4.64912 3.85472 4.77096 3.96228 4.81298 4.42863C4.81298 4.42863 4.85919 5.80248 4.85919 8.05863C4.85919 10.3211 4.82138 11.676 4.82138 11.676C4.82138 12.0848 4.65753 12.2361 4.15336 12.3369L3.42988 12.4755V13.0423L5.58519 12.973H9.17738C9.99035 12.973 11.8621 13.0423 11.8621 13.0423C11.9062 12.5508 12.1772 10.3198 12.2213 10.0745H11.7171L11.1777 11.2971C10.7554 12.255 10.1374 12.3243 9.45089 12.3243H7.38969C6.70486 12.3243 6.37505 12.0554 6.37505 11.463V8.33676C6.37505 8.33676 7.89596 8.33676 8.38752 8.3771C8.77069 8.40398 9.00218 8.51364 9.12696 9.04848L9.29082 9.76061H9.88321L9.8454 7.96326L9.92607 6.15456H9.34165L9.15259 6.94862C9.03369 7.47128 8.95093 7.56623 8.41567 7.62085C7.71572 7.69227 6.3927 7.67966 6.3927 7.67966V3.98832H6.37169L6.37295 3.98622Z'
        fill='#F45800'
      />
    </g>
    <defs>
      <clipPath id='clip0_16293_166263'>
        <rect
          width='11'
          height='11'
          fill='white'
          transform='translate(2.5 2.5)'
        />
      </clipPath>
    </defs>
  </svg>
);

export const GreenCheckFill = (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M9.99935 18.3332C14.5827 18.3332 18.3327 14.5832 18.3327 9.99984C18.3327 5.4165 14.5827 1.6665 9.99935 1.6665C5.41602 1.6665 1.66602 5.4165 1.66602 9.99984C1.66602 14.5832 5.41602 18.3332 9.99935 18.3332Z'
      fill='white'
      stroke='white'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M6.45898 9.99993L8.81732 12.3583L13.5423 7.6416'
      stroke='#027A48'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
export const BlueCheck = (
  <svg
    width='20'
    height='21'
    viewBox='0 0 20 21'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <rect y='0.5' width='20' height='20' rx='10' fill='#F0EDFA' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.9861 7.13886C15.2546 7.40735 15.2546 7.84265 14.9861 8.11114L9.48614 13.6111C9.21765 13.8796 8.78235 13.8796 8.51386 13.6111L5.76386 10.8611C5.49538 10.5927 5.49538 10.1573 5.76386 9.88886C6.03235 9.62038 6.46765 9.62038 6.73614 9.88886L9 12.1527L14.0139 7.13886C14.2824 6.87038 14.7177 6.87038 14.9861 7.13886Z'
      fill='#413BBC'
    />
  </svg>
);
export const IdeaIcon = (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M11.6667 14.0675V14.1686C11.6667 15.0891 10.9205 15.8353 10.0001 15.8353C9.07958 15.8353 8.33337 15.0891 8.33337 14.1686V14.0675C8.33337 13.5986 8.14712 13.149 7.8156 12.8175L6.40311 11.405C5.53262 10.5345 5.18269 9.27111 5.48126 8.07681C5.7067 7.17508 6.28111 6.39983 7.07814 5.92161L7.53507 5.64745C9.05232 4.7371 10.9478 4.7371 12.4651 5.64745L12.922 5.92161C13.719 6.39983 14.2934 7.17508 14.5189 8.07681C14.8174 9.27111 14.4675 10.5345 13.597 11.405L12.1845 12.8175C11.853 13.149 11.6667 13.5986 11.6667 14.0675Z'
      fill='white'
      stroke='#413BBC'
      strokeWidth='1.66669'
      strokeLinecap='round'
    />
    <path
      d='M10 1.66846V2.5018'
      stroke='#413BBC'
      strokeWidth='1.66669'
      strokeLinecap='round'
    />
    <path
      d='M16.1016 4.26611L15.5659 4.90449'
      stroke='#413BBC'
      strokeWidth='1.66669'
      strokeLinecap='round'
    />
    <path
      d='M3.89844 4.26611L4.4341 4.90449'
      stroke='#413BBC'
      strokeWidth='1.66669'
      strokeLinecap='round'
    />
    <path
      d='M9.16602 18.3354H10.8327'
      stroke='#413BBC'
      strokeWidth='1.66669'
      strokeLinecap='round'
    />
  </svg>
);

export const TickCheckThingWhite: any = (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <circle cx='8' cy='8' r='8' fill='#D4D5D9' />
    <path
      d='M11.2624 4.70907C11.1276 4.5742 10.9527 4.5 10.77 4.5C10.5659 4.5 10.3698 4.59421 10.2303 4.76062L6.68899 9.15414L5.50182 8.19133C5.33703 8.03816 5.12718 7.95386 4.91094 7.95386C4.64401 7.95386 4.39141 8.08068 4.21799 8.30177C3.89215 8.71706 3.93602 9.34518 4.31993 9.70564L6.17796 11.3123C6.30678 11.4334 6.4713 11.5 6.64126 11.5C6.84797 11.5 7.044 11.4022 7.1806 11.2297L11.3212 5.81464C11.5807 5.48715 11.5548 5.00152 11.2624 4.70907Z'
      fill='white'
    />
  </svg>
);
export const CurrentActivity: any = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='21'
    height='21'
    viewBox='0 0 21 21'
    fill='none'>
    <path
      d='M18.5014 10.4295H15.1679L12.6678 17.9299L7.66759 2.9292L5.16747 10.4295H1.83398'
      stroke='currentColor'
      strokeWidth='1.66674'
      strokeLinecap='round'
      strokeLinejoin='round'></path>
  </svg>
);

export const inProgress: any = (
  <svg
    width='41'
    height='40'
    viewBox='0 0 41 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <circle cx='20.334' cy='20' r='20' fill='#FFFAED' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20.334 9C20.8863 9 21.334 9.44772 21.334 10V14C21.334 14.5523 20.8863 15 20.334 15C19.7817 15 19.334 14.5523 19.334 14V10C19.334 9.44772 19.7817 9 20.334 9ZM12.5569 12.2229C12.9474 11.8324 13.5806 11.8324 13.9711 12.2229L16.8011 15.0529C17.1916 15.4434 17.1916 16.0766 16.8011 16.4671C16.4106 16.8576 15.7774 16.8576 15.3869 16.4671L12.5569 13.6371C12.1663 13.2466 12.1663 12.6134 12.5569 12.2229ZM28.1111 12.2229C28.5016 12.6134 28.5016 13.2466 28.1111 13.6371L25.2811 16.4671C24.8906 16.8576 24.2574 16.8576 23.8669 16.4671C23.4763 16.0766 23.4763 15.4434 23.8669 15.0529L26.6969 12.2229C27.0874 11.8324 27.7206 11.8324 28.1111 12.2229ZM9.33398 20C9.33398 19.4477 9.7817 19 10.334 19H14.334C14.8863 19 15.334 19.4477 15.334 20C15.334 20.5523 14.8863 21 14.334 21H10.334C9.7817 21 9.33398 20.5523 9.33398 20ZM25.334 20C25.334 19.4477 25.7817 19 26.334 19H30.334C30.8863 19 31.334 19.4477 31.334 20C31.334 20.5523 30.8863 21 30.334 21H26.334C25.7817 21 25.334 20.5523 25.334 20ZM16.8011 23.5329C17.1916 23.9234 17.1916 24.5566 16.8011 24.9471L13.9711 27.7771C13.5806 28.1676 12.9474 28.1676 12.5569 27.7771C12.1663 27.3866 12.1663 26.7534 12.5569 26.3629L15.3869 23.5329C15.7774 23.1424 16.4106 23.1424 16.8011 23.5329ZM23.8669 23.5329C24.2574 23.1424 24.8906 23.1424 25.2811 23.5329L28.1111 26.3629C28.5016 26.7534 28.5016 27.3866 28.1111 27.7771C27.7206 28.1676 27.0874 28.1676 26.6969 27.7771L23.8669 24.9471C23.4763 24.5566 23.4763 23.9234 23.8669 23.5329ZM20.334 25C20.8863 25 21.334 25.4477 21.334 26V30C21.334 30.5523 20.8863 31 20.334 31C19.7817 31 19.334 30.5523 19.334 30V26C19.334 25.4477 19.7817 25 20.334 25Z'
      fill='#FED16A'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20.334 9C20.8863 9 21.334 9.44772 21.334 10V14C21.334 14.5523 20.8863 15 20.334 15C19.7817 15 19.334 14.5523 19.334 14V10C19.334 9.44772 19.7817 9 20.334 9ZM12.5569 12.2229C12.9474 11.8324 13.5806 11.8324 13.9711 12.2229L16.8011 15.0529C17.1916 15.4434 17.1916 16.0766 16.8011 16.4671C16.4106 16.8576 15.7774 16.8576 15.3869 16.4671L12.5569 13.6371C12.1663 13.2466 12.1663 12.6134 12.5569 12.2229ZM28.1111 12.2229C28.5016 12.6134 28.5016 13.2466 28.1111 13.6371L25.2811 16.4671C24.8906 16.8576 24.2574 16.8576 23.8669 16.4671C23.4763 16.0766 23.4763 15.4434 23.8669 15.0529L26.6969 12.2229C27.0874 11.8324 27.7206 11.8324 28.1111 12.2229ZM9.33398 20C9.33398 19.4477 9.7817 19 10.334 19H14.334C14.8863 19 15.334 19.4477 15.334 20C15.334 20.5523 14.8863 21 14.334 21H10.334C9.7817 21 9.33398 20.5523 9.33398 20ZM25.334 20C25.334 19.4477 25.7817 19 26.334 19H30.334C30.8863 19 31.334 19.4477 31.334 20C31.334 20.5523 30.8863 21 30.334 21H26.334C25.7817 21 25.334 20.5523 25.334 20ZM23.8669 23.5329C24.2574 23.1424 24.8906 23.1424 25.2811 23.5329L28.1111 26.3629C28.5016 26.7534 28.5016 27.3866 28.1111 27.7771C27.7206 28.1676 27.0874 28.1676 26.6969 27.7771L23.8669 24.9471C23.4763 24.5566 23.4763 23.9234 23.8669 23.5329Z'
      fill='#9B7A2E'
    />
  </svg>
);

export const Reviewing: any = (
  <svg
    width='41'
    height='40'
    viewBox='0 0 41 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <circle cx='20.666' cy='20' r='20' fill='#F5FAFF' />
    <path
      d='M12.666 16.2116V12C12.666 10.8954 13.5614 10 14.666 10H24.8376C25.368 10 25.8767 10.2107 26.2518 10.5858L30.0802 14.4142C30.4553 14.7893 30.666 15.298 30.666 15.8284V22V28C30.666 29.1046 29.7706 30 28.666 30H20.666H14.666C13.5614 30 12.666 29.1046 12.666 28V25.7437'
      stroke='#2E90FA'
      strokeWidth='2'
      strokeMiterlimit='16'
      strokeLinecap='round'
    />
    <path
      d='M12.666 21L15.9722 23.4796C16.3703 23.7782 16.9274 23.7386 17.2793 23.3867L23.666 17'
      stroke='#2E90FA'
      strokeWidth='2'
      strokeLinecap='round'
    />
  </svg>
);

export const AwaitingShipment: any = (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <rect width='40' height='40' rx='20' fill='#FFF1F0' />
    <path
      d='M26.5576 20.6426V23.6426L28.5576 24.6426M31.5576 23.6426C31.5576 26.404 29.319 28.6426 26.5576 28.6426C23.7962 28.6426 21.5576 26.404 21.5576 23.6426C21.5576 20.8812 23.7962 18.6426 26.5576 18.6426C29.319 18.6426 31.5576 20.8812 31.5576 23.6426Z'
      stroke='#F85E1B'
      strokeWidth='1.66674'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18 8C17.4742 8 16.9577 8.13818 16.5021 8.40069L9.50386 12.3997L9.50386 12.3997L9.5 12.4019C9.13 12.6155 8.8109 12.9051 8.56304 13.2504C8.50271 13.3107 8.44917 13.3799 8.40441 13.4572C8.36586 13.5239 8.33586 13.5931 8.31407 13.6637C8.10834 14.0772 8.00048 14.5334 8 14.9969V14.9979V22.998V22.999C8.00054 23.5251 8.13941 24.0418 8.40269 24.4972C8.66597 24.9527 9.04439 25.3309 9.5 25.594L9.50386 25.5962L16.5 29.594L16.5022 29.5953C16.8193 29.778 17.166 29.9005 17.5247 29.958C17.6661 30.0345 17.828 30.078 18 30.078C18.172 30.078 18.3339 30.0345 18.4753 29.958C18.834 29.9004 19.1807 29.778 19.4978 29.5952L19.5 29.594L22.3102 27.9882C21.8298 27.5185 21.4269 26.9699 21.1226 26.3633L19 27.5762V19.5848L26 15.5355V17.5912C26.1836 17.5745 26.3696 17.566 26.5576 17.566C27.0546 17.566 27.5377 17.6256 28 17.7382V14.9979V14.9969C27.9995 14.5335 27.8917 14.0773 27.686 13.6639C27.6642 13.5932 27.6342 13.5239 27.5956 13.4572C27.5508 13.3798 27.4973 13.3106 27.4369 13.2502C27.189 12.9051 26.87 12.6155 26.5 12.4019L26.4961 12.3997L19.5 8.40192L19.4979 8.40072C19.0424 8.1382 18.5258 8 18 8ZM10 22.9974V15.5355L17 19.5847V27.5762L10.5 23.8619L10.4984 23.861C10.3473 23.7734 10.2217 23.6476 10.1342 23.4963C10.0465 23.3446 10.0003 23.1726 10 22.9974ZM18.5039 10.1362L24.961 13.826L18 17.8527L11.039 13.826L17.4961 10.1362L17.4961 10.1362L17.5 10.134C17.652 10.0462 17.8245 10 18 10C18.1755 10 18.348 10.0462 18.5 10.134L18.5 10.134L18.5039 10.1362Z'
      fill='#F85E1B'
    />
  </svg>
);

export const AwaitingCollection: any = (
  <svg
    width='41'
    height='40'
    viewBox='0 0 41 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <rect x='0.333496' width='40' height='40' rx='20' fill='#FFFAED' />
    <path
      d='M26.8911 20.6426V23.6426L28.8911 24.6426M31.8911 23.6426C31.8911 26.404 29.6525 28.6426 26.8911 28.6426C24.1297 28.6426 21.8911 26.404 21.8911 23.6426C21.8911 20.8812 24.1297 18.6426 26.8911 18.6426C29.6525 18.6426 31.8911 20.8812 31.8911 23.6426Z'
      stroke='#B28C35'
      strokeWidth='1.66674'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18.3335 8C17.8077 8 17.2912 8.13818 16.8356 8.40069L9.83736 12.3997L9.83735 12.3997L9.8335 12.4019C9.46349 12.6155 9.14439 12.9051 8.89653 13.2504C8.8362 13.3107 8.78267 13.3799 8.73791 13.4572C8.69936 13.5239 8.66936 13.5931 8.64757 13.6637C8.44184 14.0772 8.33397 14.5334 8.3335 14.9969V14.9979V22.998V22.999C8.33404 23.5251 8.47291 24.0418 8.73619 24.4972C8.99947 24.9527 9.37789 25.3309 9.8335 25.594L9.83736 25.5962L16.8335 29.594L16.8357 29.5953C17.1528 29.778 17.4995 29.9005 17.8582 29.958C17.9996 30.0345 18.1615 30.078 18.3335 30.078C18.5055 30.078 18.6674 30.0345 18.8088 29.958C19.1675 29.9004 19.5142 29.778 19.8313 29.5952L19.8335 29.594L22.6437 27.9882C22.1632 27.5185 21.7604 26.9699 21.4561 26.3633L19.3335 27.5762V19.5848L26.3335 15.5355V17.5912C26.5171 17.5745 26.7031 17.566 26.8911 17.566C27.3881 17.566 27.8712 17.6256 28.3335 17.7382V14.9979V14.9969C28.333 14.5335 28.2252 14.0773 28.0195 13.6639C27.9977 13.5932 27.9677 13.5239 27.9291 13.4572C27.8843 13.3798 27.8307 13.3106 27.7704 13.2502C27.5225 12.9051 27.2035 12.6155 26.8335 12.4019L26.8296 12.3997L19.8335 8.40192L19.8314 8.40072C19.3759 8.1382 18.8593 8 18.3335 8ZM10.3335 22.9974V15.5355L17.3335 19.5847V27.5762L10.8335 23.8619L10.8319 23.861C10.6808 23.7734 10.5552 23.6476 10.4677 23.4963C10.38 23.3446 10.3338 23.1726 10.3335 22.9974ZM18.8374 10.1362L25.2945 13.826L18.3335 17.8527L11.3725 13.826L17.8296 10.1362L17.8296 10.1362L17.8335 10.134C17.9855 10.0462 18.158 10 18.3335 10C18.509 10 18.6815 10.0462 18.8335 10.134L18.8335 10.134L18.8374 10.1362Z'
      fill='#B28C35'
    />
  </svg>
);

export const Complete: any = (
  <svg
    width='41'
    height='40'
    viewBox='0 0 41 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <rect x='0.666016' width='40' height='40' rx='20' fill='#E6F2ED' />
    <path
      d='M30.666 19.0857V20.0057C30.6648 22.1621 29.9665 24.2604 28.6753 25.9875C27.3842 27.7147 25.5693 28.9782 23.5014 29.5896C21.4334 30.201 19.2233 30.1276 17.2005 29.3803C15.1777 28.633 13.4507 27.2518 12.277 25.4428C11.1033 23.6338 10.5458 21.4938 10.6877 19.342C10.8296 17.1903 11.6632 15.142 13.0643 13.5028C14.4654 11.8635 16.3588 10.7211 18.4622 10.2459C20.5656 9.77063 22.7663 9.98806 24.736 10.8657'
      stroke='#219653'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M30.6663 11.9048L20.6541 22.0635L17.6504 19.0189'
      stroke='#219653'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const EtsySvg = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='32'
    height='32'
    viewBox='0 0 48 24'>
    <path
      d='M6.547,3.125v6.008c0,0,2.117,0,3.25-0.086c0.891-0.156,1.055-0.242,1.219-1.133l0.328-1.305h0.969l-0.164,2.852 l0.086,2.922h-0.977l-0.242-1.141c-0.242-0.812-0.57-0.977-1.219-1.055c-0.812-0.086-3.25-0.086-3.25-0.086v5.039 c0,0.969,0.492,1.383,1.625,1.383h3.414c1.055,0,2.109-0.086,2.766-1.625l0.883-1.953h0.82c-0.086,0.406-0.492,3.984-0.57,4.789 c0,0-3.086-0.078-4.383-0.078H5.25l-3.492,0.078v-0.883l1.133-0.25c0.82-0.164,1.062-0.406,1.062-1.055 c0,0,0.086-2.195,0.086-5.852c0-3.648-0.086-5.844-0.086-5.844c0-0.727-0.242-0.891-1.062-1.055L1.758,2.555V1.664l3.414,0.07h6.5 c1.297,0,3.484-0.234,3.484-0.234s-0.078,1.375-0.164,4.625h-0.891l-0.328-1.141c-0.32-1.461-0.805-2.188-1.703-2.188H6.961 C6.547,2.797,6.547,2.875,6.547,3.125z M19.703,3.766h0.977V7.18l3.336-0.164l-0.164,1.547l-3.25-0.25v6.016 c0,1.703,0.57,2.359,1.547,2.359c0.883,0,1.539-0.492,1.781-0.898l0.484,0.57c-0.484,1.133-1.859,1.703-3.164,1.703 c-1.617,0-2.93-0.969-2.93-2.836V8.398h-1.938V7.586C18.008,7.422,19.219,6.445,19.703,3.766z M26.695,14.242l0.648,1.547 c0.242,0.648,0.812,1.305,2.109,1.305c1.383,0,1.953-0.734,1.953-1.625c0-2.766-5.445-1.953-5.445-5.688c0-2.109,1.703-3.094,3.898-3.094c0.977,0,2.438,0.164,3.172,0.492c-0.164,0.812-0.25,1.867-0.25,2.68l-0.805,0.078l-0.57-1.625 c-0.164-0.398-0.82-0.727-1.625-0.727c-0.977,0-1.953,0.406-1.953,1.461c0,2.516,5.609,1.953,5.609,5.688c0,2.117-1.867,3.25-4.148,3.25c-1.703,0-3.414-0.656-3.414-0.656c0.164-0.969,0.086-2.023,0-3.086H26.695z M33.031,22.039 c0.242-0.891,0.406-2.023,0.57-3.086l0.891-0.078l0.328,1.703c0.078,0.406,0.32,0.734,0.969,0.734c1.055,0,2.438-0.648,3.742-2.922 c-0.578-1.383-2.281-5.844-3.828-9.258c-0.406-0.898-0.484-0.977-1.047-1.141l-0.414-0.156v-0.82l2.445,0.086l3-0.164V7.75 l-0.734,0.164c-0.57,0.078-0.805,0.398-0.805,0.727c0,0.086,0,0.164,0.078,0.328c0.156,0.492,1.461,4.141,2.438,6.578c0.805-1.703,2.352-5.523,2.594-6.172c0.086-0.328,0.164-0.406,0.164-0.648c0-0.414-0.242-0.656-0.805-0.812L42.039,7.75V6.938 l2.281,0.078l2.109-0.078V7.75l-0.406,0.32c-0.812,0.328-0.898,0.406-1.219,1.062l-3.57,8.359 c-2.117,4.797-4.312,5.203-5.852,5.203C34.406,22.695,33.672,22.445,33.031,22.039z'
      fill='#f45800'
    />
  </svg>
);
export const AnnouncementIcon2: any = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='21'
    height='20'
    viewBox='0 0 21 20'
    fill='none'>
    <path
      d='M9.66663 14.1668V17.8015C9.66663 18.0953 9.4284 18.3336 9.13454 18.3336V18.3336C8.94764 18.3336 8.77445 18.2355 8.67829 18.0752L6.33325 14.1668'
      stroke='currentColor'
      strokeWidth='1.66669'
      strokeLinecap='round'
    />
    <path
      d='M2.65454 12.8527L2.41804 11.8741C2.26483 11.2401 2.49552 10.575 3.00838 10.172L12.1745 2.97011C13.0209 2.30506 14.2664 2.60484 14.7175 3.58222L17.8658 10.4037C18.3421 11.4357 17.6684 12.6313 16.5389 12.7584L4.46096 14.1174C3.62613 14.2114 2.85188 13.6693 2.65454 12.8527Z'
      stroke='currentColor'
      strokeWidth='1.66669'
      strokeLinecap='round'
    />
    <path
      d='M17.1667 7.55366L17.2601 7.36509C17.6007 6.67762 17.1006 5.87164 16.3334 5.87164V5.87164'
      stroke='currentColor'
      strokeWidth='1.66669'
      strokeLinecap='round'
    />
  </svg>
);

export const ShopifyMinify = (
  <svg
    width='32'
    height='32'
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <rect x='0.5' y='0.5' width='31' height='31' rx='15.5' fill='white' />
    <rect x='0.5' y='0.5' width='31' height='31' rx='15.5' stroke='#D7D9DB' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.8918 10.7295C13.8806 10.7295 13.8591 10.7295 13.848 10.7295C13.6633 10.707 13.5112 10.5377 13.5112 10.3459C13.5001 10.1654 13.4021 5.94554 15.7826 4.98653C16.3805 4.74957 16.9354 4.79467 17.4027 5.14451C17.9784 5.56197 18.3915 6.39688 18.6415 7.61544C18.8151 8.47294 18.8478 9.21757 18.8478 9.25145C18.8589 9.43194 18.718 9.5674 18.5325 9.53352C18.3478 9.51093 18.1957 9.34174 18.1957 9.16117C18.1631 8.39395 17.9131 6.28408 17.0875 5.67476C16.8263 5.48298 16.4999 5.46039 16.109 5.61836C14.0653 6.44198 14.1632 10.4023 14.1632 10.4474C14.1632 10.6054 14.055 10.7295 13.8918 10.7295Z'
      fill='#595961'
    />
    <path
      opacity='0.46'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.2817 5.16691C16.847 4.85096 16.3366 4.80585 15.7817 5.02023C14.8144 5.41509 14.1298 6.45316 13.793 8.03278C13.543 9.19486 13.5756 10.2442 13.5756 10.2893C13.5756 10.3457 13.5971 10.4022 13.6409 10.4473C13.6839 10.4924 13.7277 10.5263 13.7818 10.5263C13.793 10.5263 13.8041 10.5263 13.8145 10.5263C13.9124 10.5263 13.9888 10.4473 13.9888 10.3457C13.9888 10.3006 13.8909 6.2726 15.9888 5.42639C16.4123 5.25719 16.7817 5.27971 17.0866 5.50538C17.9664 6.1485 18.2275 8.32614 18.2601 9.10465C18.2601 9.21745 18.3581 9.33032 18.4775 9.34155C18.5865 9.35284 18.6733 9.27385 18.6733 9.16105C18.6622 9.02567 18.5428 6.0921 17.2817 5.16691Z'
      fill='#B2B2C2'
    />
    <path
      opacity='0.46'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.7941 10.3909C13.783 10.3909 13.783 10.3909 13.7726 10.3909C13.7073 10.3796 13.6524 10.3119 13.642 10.2442C13.642 10.199 13.6094 9.17233 13.8594 8.01017C14.185 6.46444 14.8704 5.43766 15.8155 5.05402C16.3481 4.83964 16.8266 4.88482 17.2398 5.17818C18.4571 6.0695 18.5766 8.95795 18.5766 9.08205C18.5766 9.14974 18.5224 9.19484 18.4571 9.18362C18.3918 9.17233 18.3377 9.11593 18.3265 9.03694C18.3265 9.00306 18.2071 6.17107 17.1092 5.35868C16.7828 5.12179 16.3808 5.0879 15.9246 5.26839C13.7941 6.15978 13.892 10.2442 13.892 10.2893C13.9024 10.3457 13.8594 10.3909 13.7941 10.3909Z'
      fill='#B2B2C2'
    />
    <path
      opacity='0.62'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.6752 7.16398C14.7619 6.99478 14.8487 6.82551 14.9251 6.64502C14.8925 6.70142 14.6751 7.28815 14.0119 7.19786C14.0008 7.19786 14.4029 7.32195 14.6752 7.16398Z'
      fill='#595961'
    />
    <path
      opacity='0.62'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.4333 7.88634C14.4986 7.70577 14.5639 7.51399 14.6076 7.3335C14.5861 7.40119 14.4771 8.01043 13.7812 8.01043C13.7812 8.01043 14.1833 8.08942 14.4333 7.88634Z'
      fill='#595961'
    />
    <path
      opacity='0.62'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18.2501 6.43103C18.1633 6.22788 18.0653 6.03609 17.9674 5.83301C18 5.9007 18.3265 6.54383 17.957 7.00639C17.957 7.00639 18.2397 6.78079 18.2501 6.43103Z'
      fill='#595961'
    />
    <path
      opacity='0.62'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.6531 5.41544C17.4788 5.26876 17.3052 5.13337 17.1309 5.00928C17.1961 5.06568 17.7725 5.48313 17.7399 6.11504C17.7287 6.11504 17.8267 5.74269 17.6531 5.41544Z'
      fill='#595961'
    />
    <path
      opacity='0.62'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.9894 6.54356C15.1199 6.40817 15.2282 6.26149 15.3476 6.10352C15.3046 6.14862 14.9456 6.61125 14.3047 6.44198C14.3047 6.44198 14.6741 6.64514 14.9894 6.54356Z'
      fill='#595961'
    />
    <path
      opacity='0.62'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.3917 6.02457C15.5438 5.91177 15.6847 5.7989 15.8264 5.6748C15.7722 5.70869 15.3264 6.08097 14.707 5.81019C14.707 5.81019 15.0653 6.06967 15.3917 6.02457Z'
      fill='#595961'
    />
    <path
      opacity='0.62'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.9782 5.65178C16.1629 5.59538 16.3373 5.52768 16.5108 5.45999C16.4456 5.48251 15.8914 5.68559 15.3477 5.25684C15.3588 5.25684 15.6414 5.59538 15.9782 5.65178Z'
      fill='#595961'
    />
    <path
      opacity='0.62'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.5101 5.44938C16.6621 5.47197 16.8142 5.48327 16.9663 5.49456C16.9121 5.48327 16.4336 5.44939 16.1621 4.99805C16.1621 4.99805 16.2712 5.3027 16.5101 5.44938Z'
      fill='#595961'
    />
    <path
      opacity='0.62'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.1418 5.69669C17.2501 5.82086 17.3703 5.94495 17.5001 6.05775C17.4571 6.01265 17.0877 5.6403 17.1745 5.17773C17.1633 5.17773 17.0439 5.43721 17.1418 5.69669Z'
      fill='#595961'
    />
    <path
      opacity='0.74'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18.4571 9.0259C18.4571 8.90173 18.3377 6.04716 17.153 5.17843C16.9245 5.00916 16.6745 4.93018 16.4134 4.93018C16.2176 4.93018 16.0114 4.97528 15.794 5.06556C14.8482 5.43791 14.185 6.4421 13.8594 7.97654C13.6094 9.1274 13.642 10.1542 13.642 10.1993C13.642 10.2332 13.6747 10.267 13.7073 10.267H13.7177C13.7503 10.267 13.7726 10.2445 13.7726 10.2106C13.7726 10.1655 13.6635 6.04716 15.8482 5.16714C16.3266 4.97528 16.7398 5.00916 17.0877 5.26864C18.2175 6.09234 18.3377 8.9695 18.3377 9.00331C18.3377 9.03719 18.3703 9.071 18.403 9.071C18.403 9.071 18.4029 9.071 18.4133 9.071C18.4356 9.0823 18.4571 9.05971 18.4571 9.0259Z'
      fill='url(#paint0_linear_1039_41168)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18.6419 7.61558C18.3919 6.39702 17.9787 5.57333 17.4031 5.14458C17.0878 4.91899 16.7503 4.81741 16.3809 4.84C16.6746 4.86251 16.9461 4.96409 17.1961 5.14458C17.7725 5.56211 18.1857 6.39702 18.4357 7.61558C18.6093 8.47308 18.6419 9.21771 18.6419 9.2516C18.6419 9.38698 18.5766 9.48856 18.4676 9.52237C18.4898 9.53366 18.5113 9.53367 18.5225 9.53367C18.7072 9.55625 18.8481 9.43209 18.8377 9.2516C18.8481 9.21771 18.8155 8.48438 18.6419 7.61558Z'
      fill='url(#paint1_linear_1039_41168)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.9014 5.61828C13.8577 6.4419 13.9556 10.4022 13.9556 10.4473C13.9556 10.5827 13.8903 10.6843 13.7812 10.7181C13.8035 10.7294 13.8139 10.7294 13.8362 10.7294C13.8466 10.7294 13.8688 10.7294 13.8792 10.7294C14.0424 10.7294 14.1507 10.6053 14.1507 10.4473C14.1507 10.4022 14.0535 6.45319 16.0965 5.62957C16.2381 5.57317 16.3687 5.53929 16.4881 5.528C16.3138 5.49419 16.1187 5.52799 15.9014 5.61828Z'
      fill='url(#paint2_linear_1039_41168)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18.9995 6.60006L9.78259 9.55614C9.78259 9.55614 9.39166 9.66901 9.29374 9.7931C9.19582 9.9172 9.1743 10.267 9.1743 10.267L7.75 21.6627L18.4454 23.7388L19.2718 6.58877C19.1523 6.56618 19.0322 6.58877 18.9995 6.60006Z'
      fill='url(#paint3_linear_1039_41168)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M22.1834 8.06691C22.1834 8.06691 22.1723 7.97662 22.1181 7.94281C22.0744 7.90893 22.0202 7.90893 22.0202 7.90893L20.5092 7.79613L19.4009 6.65656C19.3571 6.62268 19.3134 6.60016 19.2592 6.58887L18.4336 23.7389L24.2263 22.4414L22.1834 8.06691Z'
      fill='url(#paint4_linear_1039_41168)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.1962 16.1226C15.033 15.8969 14.8379 15.6939 14.6421 15.5133C14.4463 15.3328 14.24 15.1861 14.0331 15.0507C13.8921 14.9605 13.7616 14.8702 13.6525 14.7799C13.5442 14.6897 13.4574 14.5994 13.3921 14.5204C13.3269 14.4301 13.2727 14.3511 13.2401 14.2609C13.2074 14.1706 13.1963 14.0804 13.1963 13.9901C13.1963 13.866 13.2289 13.7419 13.2727 13.6403C13.3157 13.5388 13.3921 13.4485 13.4678 13.3695C13.5553 13.2906 13.6525 13.2342 13.7727 13.189C13.8921 13.1439 14.033 13.1214 14.1851 13.1101C14.3483 13.0988 14.5115 13.1101 14.6636 13.1214C14.8157 13.1326 14.9573 13.1665 15.0983 13.2003C15.2289 13.2342 15.3594 13.2793 15.4677 13.3244C15.5767 13.3695 15.685 13.4146 15.7615 13.4598L16.4788 11.2484C16.3705 11.192 16.24 11.1355 16.0983 11.1017C15.9462 11.0565 15.783 11.0227 15.5983 11.0001C15.4136 10.9776 15.2177 10.9663 15.0115 10.9663C14.8053 10.9663 14.588 10.9776 14.3595 11.0114C13.8706 11.0791 13.4352 11.2145 13.0442 11.4176C12.6748 11.6094 12.3484 11.8576 12.0769 12.1623C11.8158 12.4556 11.6096 12.7941 11.4575 13.1778C11.3158 13.5501 11.229 13.9676 11.2075 14.4188C11.1964 14.6897 11.2179 14.9379 11.2832 15.1635C11.3373 15.3892 11.4249 15.6036 11.5443 15.8067C11.6526 16.0097 11.7943 16.1903 11.9463 16.3595C12.0984 16.5288 12.2831 16.6867 12.4678 16.8334C12.6199 16.9462 12.7505 17.059 12.8595 17.1606C12.9678 17.2622 13.0554 17.3637 13.1199 17.4766C13.1852 17.5781 13.2289 17.6796 13.2616 17.7924C13.2942 17.894 13.3053 18.0068 13.2942 18.1197C13.2942 18.2325 13.2616 18.3453 13.2178 18.4356C13.1748 18.5258 13.1199 18.6161 13.0331 18.6838C12.9574 18.7515 12.8595 18.7966 12.7505 18.8192C12.6422 18.8417 12.5116 18.853 12.3699 18.8305C12.2075 18.8079 12.0443 18.7628 11.8922 18.695C11.7401 18.6386 11.5873 18.5597 11.4464 18.4807C11.3055 18.4018 11.1749 18.3115 11.0658 18.2325C10.9464 18.1535 10.8485 18.0632 10.7728 17.9955L10.2832 19.6767C10.3596 19.7895 10.4679 19.8911 10.5874 19.9926C10.7075 20.0942 10.8485 20.1957 11.0117 20.2972C11.1749 20.3875 11.3485 20.4777 11.5332 20.5567C11.7179 20.6357 11.9248 20.7034 12.1311 20.7599H12.1422H12.1526H12.1637H12.1748C12.6199 20.8614 13.0442 20.884 13.4463 20.8276C13.8595 20.7711 14.24 20.6244 14.5657 20.3988C14.9024 20.1619 15.1747 19.8459 15.3809 19.4285C15.5879 19.011 15.7073 18.5033 15.7288 17.9278C15.7399 17.5668 15.6962 17.2509 15.5983 16.9575C15.5004 16.6191 15.3594 16.3595 15.1962 16.1226Z'
      fill='url(#paint5_linear_1039_41168)'
    />
    <path
      opacity='0.226763'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.3526 19.7686C10.3274 19.7387 10.3036 19.7082 10.2821 19.6768L10.7717 17.9956C10.7784 18.0019 10.7858 18.0084 10.7933 18.015C10.866 18.08 10.9565 18.1609 11.0648 18.2326C11.1738 18.3115 11.3044 18.4018 11.4453 18.4808C11.5863 18.5597 11.739 18.6387 11.8911 18.6952C12.0432 18.7629 12.2064 18.808 12.3689 18.8306C12.5106 18.8531 12.6411 18.8419 12.7494 18.8193C12.8585 18.7967 12.9564 18.7516 13.032 18.6839C13.1188 18.6162 13.1737 18.5259 13.2168 18.4356C13.2605 18.3454 13.2931 18.2326 13.2931 18.1198C13.3043 18.0069 13.2931 17.8941 13.2605 17.7925C13.2279 17.6797 13.1841 17.5781 13.1188 17.4766C13.0573 17.3694 12.9756 17.2724 12.874 17.1758C12.9274 17.2361 12.9727 17.2981 13.0105 17.3638C13.0758 17.4653 13.1188 17.5668 13.1515 17.6797C13.1841 17.7812 13.1952 17.8941 13.1841 18.0069C13.1841 18.1198 13.1515 18.2326 13.1085 18.3228C13.0647 18.4131 13.0105 18.5033 12.9237 18.571C12.8473 18.6387 12.7494 18.6839 12.6411 18.7064C12.5321 18.729 12.4015 18.7403 12.2606 18.7177C12.0974 18.6952 11.9342 18.65 11.7821 18.5823C11.63 18.5259 11.4779 18.4469 11.3363 18.3679C11.1953 18.289 11.0648 18.1987 10.9565 18.1198C10.8474 18.0481 10.7569 17.9672 10.6842 17.9022C10.6768 17.8956 10.6701 17.8891 10.6627 17.8828L10.1738 19.5639C10.222 19.6357 10.2836 19.703 10.3526 19.7686ZM11.9542 16.3698C11.9134 16.3295 11.8741 16.2885 11.8362 16.2468C11.6842 16.0775 11.5432 15.897 11.4342 15.6939C11.3148 15.4908 11.228 15.2764 11.1738 15.0508C11.1085 14.8251 11.0862 14.5769 11.0974 14.3061C11.1189 13.8548 11.2064 13.4373 11.3474 13.065C11.4995 12.6814 11.7064 12.3429 11.9668 12.0496C12.2391 11.7449 12.5647 11.4966 12.9341 11.3049C13.3258 11.1018 13.7605 10.9664 14.2493 10.8987C14.4778 10.8648 14.6952 10.8535 14.9014 10.8535C15.1084 10.8535 15.3042 10.8648 15.4889 10.8874C15.6736 10.91 15.8368 10.9438 15.9889 10.989C16.1298 11.0228 16.2604 11.0792 16.3694 11.1356L16.3524 11.1884C16.2737 11.1542 16.1877 11.1234 16.0972 11.1018C15.9451 11.0567 15.7819 11.0228 15.5972 11.0002C15.4125 10.9777 15.2166 10.9664 15.0104 10.9664C14.8042 10.9664 14.5869 10.9777 14.3584 11.0115C13.8695 11.0792 13.4341 11.2146 13.0432 11.4177C12.6737 11.6095 12.3473 11.8577 12.0758 12.1624C11.8147 12.4557 11.6085 12.7942 11.4564 13.1778C11.3147 13.5502 11.228 13.9676 11.2064 14.4189C11.1953 14.6898 11.2168 14.9379 11.2821 15.1636C11.3363 15.3893 11.4238 15.6037 11.5432 15.8067C11.6515 16.0098 11.7932 16.1904 11.9453 16.3596C11.9482 16.363 11.9512 16.3664 11.9542 16.3698ZM13.4304 14.5667C13.4897 14.6338 13.5639 14.7069 13.6515 14.78C13.7605 14.8702 13.8911 14.9605 14.032 15.0508C14.239 15.1862 14.4452 15.3329 14.641 15.5134C14.6981 15.5659 14.7545 15.6203 14.8109 15.6767C14.7204 15.5794 14.6262 15.4874 14.5319 15.4006C14.3368 15.22 14.1299 15.0733 13.9237 14.9379C13.782 14.8477 13.6515 14.7575 13.5432 14.6672C13.5024 14.6335 13.4652 14.5998 13.4304 14.5667Z'
      fill='black'
    />
    <path
      opacity='0.41'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20.8799 20.5458L20.5105 7.79607L20.4452 7.72837L20.6196 20.3652C20.6196 20.3652 19.087 22.7798 18.8585 22.7121C18.5217 22.6106 19.5217 6.78059 19.5217 6.78059L19.4126 6.66779C19.3696 6.63391 19.3147 6.61139 19.2717 6.6001L18.4565 23.5132L18.4453 23.7501L18.7279 23.3778L20.8799 20.5458Z'
      fill='url(#paint6_linear_1039_41168)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.7178 7.33358C16.588 7.86383 16.4248 8.36028 16.3054 8.66494C16.229 8.8455 16.3158 9.0147 16.479 9.03729C16.6533 9.05988 16.8484 8.93571 16.9137 8.75522C16.9248 8.72133 17.2178 7.988 17.4033 7.1192V7.10791L16.7178 7.33358Z'
      fill='url(#paint7_linear_1039_41168)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.815 8.91287C11.6629 9.25134 11.5109 9.54471 11.4018 9.74779C11.3046 9.91706 11.3588 10.0975 11.522 10.1427C11.6844 10.1991 11.9018 10.0975 11.9997 9.92828C12.0108 9.90576 12.3261 9.35292 12.6088 8.65332L11.815 8.91287Z'
      fill='url(#paint8_linear_1039_41168)'
    />
    <path
      opacity='0.32'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18.4453 23.739L20.8799 20.5459L24.25 22.4415L18.4453 23.739Z'
      fill='url(#paint9_linear_1039_41168)'
    />
    <path
      opacity='0.19'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18.4453 23.739L20.8584 20.5459L24.25 22.4415L18.4453 23.739Z'
      fill='url(#paint10_linear_1039_41168)'
    />
    <path
      opacity='0.19'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18.4453 23.739L20.8584 20.5459L24.25 22.4415L18.4453 23.739Z'
      fill='url(#paint11_linear_1039_41168)'
    />
    <path
      opacity='0.6'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.0753 14.8028C17.3364 16.5742 18.1842 18.4922 18.6078 20.3539L19.271 6.5775C19.1516 6.55499 19.0314 6.5775 18.9987 6.5888L9.7818 9.55625C9.7818 9.55625 9.69498 9.57876 9.58594 9.62394C11.9234 10.4588 14.2601 12.2528 16.0753 14.8028Z'
      fill='url(#paint12_linear_1039_41168)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M22.1291 7.95386C22.184 7.99904 22.184 8.06674 22.184 8.06674L24.2054 22.4298L20.8792 20.5343L20.5098 7.78467L21.9993 7.89746C22.0097 7.90876 22.075 7.90876 22.1291 7.95386Z'
      fill='url(#paint13_linear_1039_41168)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M21.8909 7.98811C21.8909 7.98811 21.9562 7.98811 22.0103 8.04451C22.0645 8.08969 22.0755 8.15738 22.0755 8.15738L24.0651 22.3626L24.2172 22.4528L22.195 8.07839C22.195 8.07839 22.1846 8.0107 22.1408 7.96559C22.0867 7.92042 22.0103 7.92042 22.0103 7.92042L20.5215 7.80762L21.8909 7.98811Z'
      fill='url(#paint14_linear_1039_41168)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.75 21.6622L18.4454 23.7383L18.9676 11.9814L9.08004 12.2625L7.75 21.6622Z'
      fill='url(#paint15_linear_1039_41168)'
    />
    <path
      opacity='0.3'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.2606 9.72031C11.1634 9.99455 11.2591 10.2827 11.4757 10.364C11.6916 10.4453 11.9453 10.2889 12.0432 10.0148C12.1404 9.74061 12.044 9.45241 11.8281 9.37113C11.6122 9.28978 11.3578 9.44614 11.2606 9.72031Z'
      fill='white'
    />
    <path
      opacity='0.89'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.2488 9.5905C11.1516 9.86467 11.248 10.1529 11.4639 10.2341C11.6798 10.3155 11.9342 10.1591 12.0314 9.88497C12.1286 9.61072 12.0329 9.32253 11.8163 9.24125C11.6004 9.1599 11.3467 9.31625 11.2488 9.5905Z'
      fill='black'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20.5216 7.79613L19.4126 6.65656C19.3696 6.62268 19.3147 6.60016 19.2717 6.58887L18.4453 23.7389L20.891 20.5345L20.5216 7.79613Z'
      fill='url(#paint16_linear_1039_41168)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18.9988 6.59993L9.78188 9.556C9.78188 9.556 9.39095 9.66888 9.29304 9.79297C9.28191 9.80426 9.28187 9.81556 9.27148 9.82685L18.5641 7.16406C18.6405 7.14147 18.8252 7.07378 18.8037 7.62663L18.2385 23.7161L18.4343 23.75L19.2599 6.59993C19.1516 6.56604 19.0315 6.58863 18.9988 6.59993Z'
      fill='url(#paint17_linear_1039_41168)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18.9988 6.59993L9.78188 9.556C9.78188 9.556 9.39095 9.66888 9.29304 9.79297C9.28191 9.80426 9.28187 9.81556 9.27148 9.82685L11.4235 9.20624L18.8252 6.8256C18.8579 6.8143 18.9773 6.79171 19.0968 6.8143L18.2815 23.7161L18.4343 23.75L19.2599 6.59993C19.1516 6.56604 19.0315 6.58863 18.9988 6.59993Z'
      fill='url(#paint18_linear_1039_41168)'
    />
    <path
      opacity='0.32'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M21.3682 20.8162L20.8786 20.5342L18.4336 23.7385L18.5634 23.7046C18.5634 23.7046 20.7161 20.8275 20.9112 20.7373C21.0529 20.6809 21.3682 20.8162 21.3682 20.8162Z'
      fill='url(#paint19_linear_1039_41168)'
    />
    <path
      opacity='0.57'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18.4453 23.7385L20.891 20.5342C20.8799 20.5455 19.337 22.2943 18.4453 23.7385Z'
      fill='url(#paint20_linear_1039_41168)'
    />
    <path
      opacity='0.46'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M24.2498 22.4415L20.8909 20.5459C20.8797 20.5459 21.2714 20.6136 24.2498 22.4415Z'
      fill='url(#paint21_linear_1039_41168)'
    />
    <path
      opacity='0.3'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.2297 8.59528C16.1318 8.86952 16.2282 9.15772 16.4441 9.23907C16.6607 9.32042 16.9144 9.16407 17.0116 8.8899C17.1095 8.61565 17.0131 8.32746 16.7972 8.24611C16.5813 8.16483 16.3269 8.32111 16.2297 8.59528Z'
      fill='white'
    />
    <path
      opacity='0.89'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.2175 8.46591C16.1204 8.74015 16.2168 9.02835 16.4327 9.1097C16.6485 9.19098 16.903 9.0347 17.0001 8.76045C17.0973 8.48628 17.0016 8.19809 16.7857 8.11674C16.5691 8.03539 16.3154 8.19174 16.2175 8.46591Z'
      fill='black'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.642 10.1426C11.6309 10.1426 11.6093 10.1426 11.5982 10.1426C11.4246 10.1201 11.3052 9.95079 11.3267 9.759C11.3482 9.57844 11.9676 5.35862 14.5113 4.39962C15.1522 4.16265 15.6959 4.20776 16.1091 4.5576C16.6091 4.97505 16.8806 5.80996 16.9244 7.02852C16.957 7.88602 16.8591 8.63065 16.8591 8.66454C16.8376 8.84503 16.6744 8.98049 16.5001 8.94661C16.3265 8.92402 16.1959 8.75482 16.2286 8.57426C16.3265 7.80704 16.4348 5.69717 15.7071 5.08785C15.4786 4.89606 15.1634 4.87347 14.7398 5.03145C12.5552 5.85507 11.9787 9.8154 11.9787 9.84921C11.935 10.0185 11.8052 10.1426 11.642 10.1426Z'
      fill='#595961'
    />
    <path
      opacity='0.46'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.9773 4.58041C15.5967 4.26454 15.0968 4.21943 14.4989 4.43381C13.4663 4.82867 12.5968 5.86667 11.9989 7.43499C11.5539 8.59715 11.4011 9.64644 11.4011 9.69161C11.3907 9.74801 11.4122 9.80441 11.4449 9.84959C11.4775 9.8947 11.5212 9.92858 11.5754 9.92858C11.5858 9.92858 11.5969 9.92858 11.608 9.92858C11.7059 9.92858 11.7927 9.84959 11.8038 9.74801C11.8142 9.70291 12.3906 5.67488 14.6405 4.82867C15.0968 4.6594 15.4662 4.68199 15.7273 4.90766C16.4987 5.55079 16.3905 7.72835 16.2925 8.50687C16.2814 8.61974 16.3578 8.73253 16.4661 8.74383C16.5752 8.75512 16.6835 8.67614 16.6946 8.56334C16.7057 8.43917 17.0863 5.50568 15.9773 4.58041Z'
      fill='#B2B2C2'
    />
    <path
      opacity='0.81'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.5977 9.80446C11.5866 9.80446 11.5866 9.80446 11.5762 9.80446C11.5109 9.79317 11.4672 9.72547 11.4783 9.65778C11.4894 9.6126 11.6304 8.5859 12.0762 7.42374C12.6741 5.87801 13.522 4.85124 14.5323 4.46759C15.1087 4.25322 15.576 4.2984 15.9343 4.59176C16.9996 5.48307 16.6302 8.37153 16.6086 8.49562C16.5975 8.56331 16.5434 8.60842 16.467 8.5972C16.4024 8.5859 16.3587 8.5295 16.3587 8.45052C16.3587 8.41663 16.7281 5.58465 15.7719 4.77225C15.4893 4.55787 15.0976 4.53536 14.6199 4.71585C12.3262 5.58465 11.7283 9.65778 11.7283 9.70288C11.7172 9.75928 11.663 9.80446 11.5977 9.80446Z'
      fill='#B2B2C2'
    />
    <path
      opacity='0.42'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.0332 6.57755C13.1526 6.40836 13.2617 6.23909 13.37 6.05859C13.3269 6.11499 13.0117 6.70172 12.3596 6.61144C12.3485 6.61144 12.729 6.73553 13.0332 6.57755Z'
      fill='#595961'
    />
    <path
      opacity='0.42'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.6632 7.29943C12.7611 7.11886 12.859 6.92707 12.9347 6.74658C12.902 6.81428 12.6847 7.42352 12 7.42352C12 7.42352 12.3806 7.50251 12.6632 7.29943Z'
      fill='#595961'
    />
    <path
      opacity='0.42'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.3805 8.04418C12.4673 7.85232 12.5326 7.66054 12.5979 7.46875C12.5653 7.53644 12.4458 8.15698 11.7285 8.23597C11.7285 8.22467 12.1194 8.26985 12.3805 8.04418Z'
      fill='#595961'
    />
    <path
      opacity='0.62'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.7269 5.84411C16.6727 5.64096 16.6185 5.44917 16.5421 5.24609C16.5636 5.31379 16.781 5.95691 16.3359 6.41947C16.3359 6.41947 16.6616 6.19388 16.7269 5.84411Z'
      fill='#595961'
    />
    <path
      opacity='0.62'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.3046 4.82803C16.1526 4.68135 15.9997 4.54597 15.8477 4.42188C15.9025 4.47827 16.4129 4.89573 16.272 5.52756C16.2609 5.52756 16.4241 5.15521 16.3046 4.82803Z'
      fill='#595961'
    />
    <path
      opacity='0.62'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.8372 6.88184C16.8261 6.67876 16.7935 6.46439 16.7608 6.26123C16.7608 6.34022 16.8699 7.00593 16.3477 7.36699C16.3477 7.36699 16.7067 7.20901 16.8372 6.88184Z'
      fill='#595961'
    />
    <path
      opacity='0.62'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.8914 7.9428C16.9026 7.73972 16.9026 7.52535 16.8914 7.32227C16.8914 7.40125 16.9025 8.06697 16.3477 8.37155C16.3477 8.36033 16.7282 8.24746 16.8914 7.9428Z'
      fill='#595961'
    />
    <path
      opacity='0.42'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.1305 8.86755C12.1958 8.66447 12.2396 8.46139 12.2826 8.26953C12.2611 8.33722 12.1632 8.98035 11.5 9.13833C11.5111 9.13833 11.902 9.12703 12.1305 8.86755Z'
      fill='#595961'
    />
    <path
      opacity='0.42'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.4451 5.95665C13.5971 5.82126 13.7388 5.67458 13.8693 5.5166C13.8145 5.56171 13.3798 6.02434 12.7715 5.85507C12.7819 5.85507 13.1187 6.05822 13.4451 5.95665Z'
      fill='#595961'
    />
    <path
      opacity='0.42'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.9339 5.43765C14.1082 5.32486 14.2714 5.21198 14.4339 5.08789C14.3693 5.12177 13.8694 5.49405 13.293 5.22328C13.293 5.22328 13.5971 5.48276 13.9339 5.43765Z'
      fill='#595961'
    />
    <path
      opacity='0.62'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.5984 5.06535C14.7943 5.00888 14.979 4.94119 15.1637 4.87349C15.0984 4.89608 14.5117 5.09916 14.0332 4.67041C14.0332 4.67041 14.2617 5.00888 14.5984 5.06535Z'
      fill='#595961'
    />
    <path
      opacity='0.62'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.1524 4.86247C15.3052 4.88506 15.4573 4.89636 15.6094 4.90765C15.5552 4.89636 15.0878 4.86247 14.8809 4.41113C14.892 4.41113 14.9462 4.71579 15.1524 4.86247Z'
      fill='#595961'
    />
    <path
      opacity='0.62'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.7399 5.11034C15.8378 5.23443 15.935 5.35853 16.0329 5.4714C16.0003 5.42622 15.6961 5.05394 15.8482 4.59131C15.8593 4.59131 15.6961 4.85086 15.7399 5.11034Z'
      fill='#595961'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.4894 8.43891C16.4998 8.31482 16.87 5.46024 15.8374 4.59145C15.6416 4.42225 15.4027 4.34326 15.1416 4.34326C14.9458 4.34326 14.7284 4.38837 14.4999 4.47865C13.5 4.851 12.6632 5.85518 12.0764 7.38962C11.6306 8.54049 11.4896 9.56726 11.4785 9.61236C11.4785 9.64617 11.5001 9.68006 11.5327 9.68006H11.5438C11.5764 9.68006 11.598 9.65747 11.598 9.62366C11.6091 9.57848 12.1958 5.46024 14.5325 4.58015C15.0325 4.38837 15.4568 4.42225 15.761 4.68173C16.7498 5.50535 16.3804 8.38251 16.37 8.41639C16.37 8.4502 16.3915 8.48409 16.4242 8.48409C16.4242 8.48409 16.4242 8.48409 16.4346 8.48409C16.4672 8.49538 16.4894 8.47279 16.4894 8.43891Z'
      fill='url(#paint22_linear_1039_41168)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.9232 7.02867C16.8794 5.81011 16.6079 4.98642 16.1079 4.55767C15.8364 4.33207 15.51 4.23049 15.1406 4.25308C15.4233 4.2756 15.6836 4.37718 15.9017 4.55767C16.4017 4.9752 16.6732 5.81011 16.7162 7.02867C16.7488 7.88617 16.6517 8.6308 16.6517 8.66468C16.6294 8.80007 16.5426 8.90165 16.4336 8.93546C16.4558 8.94675 16.4662 8.94675 16.4885 8.94675C16.662 8.96934 16.8253 8.84517 16.8468 8.66468C16.8579 8.6308 16.9558 7.89746 16.9232 7.02867Z'
      fill='url(#paint23_linear_1039_41168)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.5213 5.03172C12.3367 5.85534 11.7603 9.81567 11.7603 9.86078C11.7388 9.99617 11.6513 10.0977 11.543 10.1316C11.5645 10.1428 11.5756 10.1428 11.5971 10.1428C11.6082 10.1428 11.6298 10.1428 11.6409 10.1428C11.8041 10.1428 11.9339 10.0188 11.9562 9.86078C11.9665 9.81567 12.5318 5.86664 14.7164 5.04294C14.8692 4.98655 14.9991 4.95274 15.1193 4.94144C14.9561 4.91885 14.7491 4.95273 14.5213 5.03172Z'
      fill='url(#paint24_linear_1039_41168)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_1039_41168'
        x1='14.2088'
        y1='4.95564'
        x2='13.8679'
        y2='9.59678'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' stopOpacity='0.65' />
        <stop offset='1' stopColor='white' stopOpacity='0.01' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_1039_41168'
        x1='16.6998'
        y1='7.61219'
        x2='19.0998'
        y2='9.71429'
        gradientUnits='userSpaceOnUse'>
        <stop stopOpacity='0.01' />
        <stop offset='1' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_1039_41168'
        x1='15.7359'
        y1='10.0438'
        x2='18.2762'
        y2='7.67759'
        gradientUnits='userSpaceOnUse'>
        <stop stopOpacity='0.01' />
        <stop offset='1' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_1039_41168'
        x1='12.5035'
        y1='3.13898'
        x2='2.63664'
        y2='14.5078'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#B8D26E' />
        <stop offset='1' stopColor='#7FB525' />
      </linearGradient>
      <linearGradient
        id='paint4_linear_1039_41168'
        x1='25.9992'
        y1='5.98531'
        x2='20.5841'
        y2='6.08587'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#B4E034' />
        <stop offset='1' stopColor='#60A927' />
      </linearGradient>
      <linearGradient
        id='paint5_linear_1039_41168'
        x1='9.89449'
        y1='13.5658'
        x2='5.4548'
        y2='24.3773'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='#CECEEB' />
      </linearGradient>
      <linearGradient
        id='paint6_linear_1039_41168'
        x1='16.2592'
        y1='40.1914'
        x2='23.2908'
        y2='40.1772'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#1D1D1B' stopOpacity='0.5' />
        <stop offset='0.038033' stopColor='#1D1D1B' stopOpacity='0.4837' />
        <stop offset='0.4243' stopColor='#1D1D1B' stopOpacity='0.3185' />
        <stop offset='1' stopColor='#1D1D1B' stopOpacity='0.01' />
      </linearGradient>
      <linearGradient
        id='paint7_linear_1039_41168'
        x1='17.0769'
        y1='6.35066'
        x2='15.9103'
        y2='6.97849'
        gradientUnits='userSpaceOnUse'>
        <stop stopOpacity='0.01' />
        <stop offset='1' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint8_linear_1039_41168'
        x1='12.1852'
        y1='8.21254'
        x2='11.3652'
        y2='8.91727'
        gradientUnits='userSpaceOnUse'>
        <stop stopOpacity='0.01' />
        <stop offset='1' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint9_linear_1039_41168'
        x1='20.1841'
        y1='22.4499'
        x2='20.2671'
        y2='23.5443'
        gradientUnits='userSpaceOnUse'>
        <stop stopOpacity='0.01' />
        <stop offset='1' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint10_linear_1039_41168'
        x1='18.2458'
        y1='20.8478'
        x2='18.4382'
        y2='23.6931'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' stopOpacity='0.5' />
        <stop offset='0.0896271' stopColor='white' stopOpacity='0.4552' />
        <stop offset='1' stopColor='white' stopOpacity='0.01' />
      </linearGradient>
      <linearGradient
        id='paint11_linear_1039_41168'
        x1='17.8756'
        y1='21.2903'
        x2='18.218'
        y2='24.3297'
        gradientUnits='userSpaceOnUse'>
        <stop stopOpacity='0.01' />
        <stop offset='1' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint12_linear_1039_41168'
        x1='16.5315'
        y1='3.80303'
        x2='7.75056'
        y2='8.88156'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' stopOpacity='0.5' />
        <stop offset='1' stopColor='white' stopOpacity='0.01' />
      </linearGradient>
      <linearGradient
        id='paint13_linear_1039_41168'
        x1='18.2257'
        y1='30.3451'
        x2='25.9761'
        y2='30.3607'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#1D1D1B' stopOpacity='0.5' />
        <stop offset='0.0896271' stopColor='#1D1D1B' stopOpacity='0.4552' />
        <stop offset='1' stopColor='#1D1D1B' stopOpacity='0.01' />
      </linearGradient>
      <linearGradient
        id='paint14_linear_1039_41168'
        x1='23.7765'
        y1='7.38005'
        x2='22.6756'
        y2='7.64982'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' stopOpacity='0.4' />
        <stop offset='1' stopColor='white' stopOpacity='0.01' />
      </linearGradient>
      <linearGradient
        id='paint15_linear_1039_41168'
        x1='13.8988'
        y1='23.8639'
        x2='14.4713'
        y2='21.1038'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#1D1D1B' stopOpacity='0.5' />
        <stop offset='0.0896271' stopColor='#1D1D1B' stopOpacity='0.4552' />
        <stop offset='1' stopColor='#1D1D1B' stopOpacity='0.01' />
      </linearGradient>
      <linearGradient
        id='paint16_linear_1039_41168'
        x1='17.2087'
        y1='39.8402'
        x2='24.2655'
        y2='39.8463'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#1D1D1B' stopOpacity='0.5' />
        <stop offset='1' stopColor='#1D1D1B' stopOpacity='0.01' />
      </linearGradient>
      <linearGradient
        id='paint17_linear_1039_41168'
        x1='10.7596'
        y1='5.60564'
        x2='7.33702'
        y2='18.7549'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' stopOpacity='0.5' />
        <stop offset='1' stopColor='white' stopOpacity='0.01' />
      </linearGradient>
      <linearGradient
        id='paint18_linear_1039_41168'
        x1='10.7596'
        y1='5.60564'
        x2='7.33702'
        y2='18.7549'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' stopOpacity='0.5' />
        <stop offset='1' stopColor='white' stopOpacity='0.01' />
      </linearGradient>
      <linearGradient
        id='paint19_linear_1039_41168'
        x1='19.0649'
        y1='19.3895'
        x2='16.3597'
        y2='23.1129'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' stopOpacity='0.5' />
        <stop offset='0.0896271' stopColor='white' stopOpacity='0.4552' />
        <stop offset='1' stopColor='white' stopOpacity='0.01' />
      </linearGradient>
      <linearGradient
        id='paint20_linear_1039_41168'
        x1='19.8822'
        y1='20.2455'
        x2='19.6144'
        y2='20.8459'
        gradientUnits='userSpaceOnUse'>
        <stop stopOpacity='0.01' />
        <stop offset='1' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint21_linear_1039_41168'
        x1='22.5384'
        y1='21.0399'
        x2='22.5252'
        y2='21.2013'
        gradientUnits='userSpaceOnUse'>
        <stop stopOpacity='0.01' />
        <stop offset='1' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint22_linear_1039_41168'
        x1='12.7975'
        y1='3.96345'
        x2='11.628'
        y2='8.58344'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' stopOpacity='0.65' />
        <stop offset='1' stopColor='white' stopOpacity='0.01' />
      </linearGradient>
      <linearGradient
        id='paint23_linear_1039_41168'
        x1='15.4136'
        y1='6.62863'
        x2='17.448'
        y2='8.69691'
        gradientUnits='userSpaceOnUse'>
        <stop stopOpacity='0.01' />
        <stop offset='1' stopOpacity='0.4' />
      </linearGradient>
      <linearGradient
        id='paint24_linear_1039_41168'
        x1='14.1134'
        y1='9.67453'
        x2='16.9241'
        y2='6.78788'
        gradientUnits='userSpaceOnUse'>
        <stop stopOpacity='0.01' />
        <stop offset='1' stopOpacity='0.4' />
      </linearGradient>
    </defs>
  </svg>
);

export const BigCommerce = (
  <svg width='90' height='40' viewBox='0 0 406 88' fill='none'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M118.783 52.3658C117.192 50.2877 114.488 48.5915 111.213 48.5915C105.15 48.5915 100.776 53.0492 100.776 59.084C100.776 65.1189 105.15 69.5766 111.213 69.5766C114.044 69.5766 116.694 68.4131 118.08 67.2531C118.175 67.176 118.226 67.0639 118.226 66.9447V63.6715C118.226 63.4682 118.055 63.3 117.84 63.3H110.041C109.732 63.3 109.481 63.0547 109.481 62.7603V57.8995C109.481 57.6016 109.736 57.3563 110.041 57.3563H124.023V50.144L119.51 52.5271C119.27 52.6532 118.95 52.5761 118.79 52.3658H118.783ZM53.143 55.7793H61.5131C63.8967 55.7793 65.3888 54.4826 65.3888 52.4254C65.3888 50.4629 63.9331 49.0716 61.5131 49.0716H53.143C53.0749 49.0706 53.0072 49.0829 52.9441 49.1075C52.8809 49.1322 52.8236 49.1688 52.7754 49.2152C52.7272 49.2616 52.6892 49.3169 52.6636 49.3777C52.638 49.4385 52.6253 49.5036 52.6262 49.5692V55.2816C52.6253 55.3472 52.638 55.4124 52.6636 55.4732C52.6892 55.534 52.7272 55.5892 52.7754 55.6356C52.8236 55.682 52.8809 55.7186 52.9441 55.7433C53.0072 55.768 53.0749 55.7802 53.143 55.7793ZM87.0054 74.5986C87.0054 74.844 86.798 75.0437 86.5432 75.0437H80.4112C80.1565 75.0437 79.9491 74.844 79.9491 74.5986V43.5309C79.9491 43.2856 80.1565 43.0858 80.4112 43.0858H86.5469C86.8016 43.0858 87.0091 43.2856 87.0091 43.5309L87.0054 74.5986ZM122.258 0.211299L61.4366 43.0788H63.0015C69.3118 43.0788 72.5434 46.9583 72.5434 51.2234C72.5434 54.5422 70.7456 56.9918 68.3329 58.0747C67.9689 58.257 67.9471 58.8037 68.3547 58.9649C71.1678 60.0758 73.1948 62.9776 73.1948 66.3665C73.1948 71.2027 69.9195 75.0402 63.551 75.0402H46.0794C46.0112 75.0412 45.9436 75.0289 45.8805 75.0043C45.8173 74.9796 45.76 74.943 45.7118 74.8966C45.6636 74.8502 45.6256 74.7949 45.6 74.7341C45.5743 74.6733 45.5616 74.6082 45.5626 74.5426V54.2688L0.455174 86.0725C-0.407308 86.6823 0.0366703 88 1.11022 88H122.913C123.524 88 124.019 87.5234 124.019 86.9311V70.8102C120.759 73.74 116.475 75.5764 111.209 75.5764C101.471 75.5764 93.5232 69.107 93.5232 59.0455C93.5232 48.9349 101.475 42.5146 111.209 42.5146C117.334 42.5146 121.399 45.1886 124.019 48.4583V1.06991C124.019 0.193776 122.989 -0.307374 122.258 0.207793V0.211299ZM53.1394 69.0474H61.7642C64.3989 69.0474 65.9856 67.7052 65.9856 65.4027C65.9856 63.3911 64.5299 61.758 61.7642 61.758H53.1394C53.0712 61.7571 53.0036 61.7693 52.9404 61.794C52.8773 61.8186 52.8199 61.8553 52.7718 61.9017C52.7236 61.9481 52.6856 62.0033 52.6599 62.0641C52.6343 62.1249 52.6216 62.19 52.6226 62.2557V68.5428C52.6216 68.6084 52.6343 68.6735 52.6599 68.7344C52.6856 68.7952 52.7236 68.8504 52.7718 68.8968C52.8199 68.9432 52.8773 68.9798 52.9404 69.0045C53.0036 69.0292 53.0712 69.0414 53.1394 69.0404V69.0474ZM159.33 68.0767L155.527 66.1772C155.406 66.1201 155.267 66.1082 155.138 66.1438C155.008 66.1794 154.897 66.26 154.825 66.37C153.216 68.7986 150.25 70.6035 147.03 70.6035C140.698 70.6035 136.003 65.7146 136.003 59.056C136.003 52.2993 140.734 47.5086 147.03 47.5086C150.25 47.5086 153.216 49.2678 154.825 51.7315C154.897 51.8427 155.01 51.9237 155.142 51.9587C155.273 51.9937 155.413 51.9802 155.535 51.9208L159.308 49.9407C159.599 49.79 159.698 49.4501 159.519 49.1767C157.132 45.5565 153.18 42.5251 147.03 42.5251C137.586 42.5251 130.29 49.1837 130.29 59.056C130.29 68.8792 137.623 75.5869 147.03 75.5869C153.173 75.5869 157.081 72.4784 159.549 68.8582C159.73 68.5778 159.632 68.2344 159.33 68.0872V68.0767ZM179.145 70.6C172.668 70.6 168.541 65.6165 168.541 59.0525C168.574 52.4114 172.704 47.5051 179.182 47.5051C185.612 47.5051 189.786 52.4114 189.786 59.0525C189.786 65.6165 185.612 70.6 179.182 70.6H179.145ZM174.615 43.0893C167.489 44.9257 162.787 51.1498 162.787 59.063C162.787 68.5954 169.556 75.5939 179.149 75.5939C187.323 75.5939 193.487 70.4703 195.1 62.9776C197.72 50.8344 186.664 39.9528 174.618 43.0543L174.615 43.0893ZM235.316 43.0543H228.038C227.88 43.0521 227.725 43.097 227.594 43.183C227.464 43.269 227.365 43.3918 227.31 43.5344L218.51 65.4658L209.667 43.5344C209.547 43.247 209.26 43.0543 208.939 43.0543H201.661C201.443 43.0543 201.272 43.2225 201.272 43.4293V74.6372C201.272 74.8475 201.446 75.0122 201.661 75.0122H206.698C206.916 75.0122 207.087 74.844 207.087 74.6372V50.3367L217.204 74.844C217.247 74.9491 217.349 75.0122 217.459 75.0122H219.562C219.671 75.0122 219.78 74.9421 219.817 74.844L229.886 50.3367V74.6372C229.886 74.8475 230.061 75.0122 230.276 75.0122H235.389C235.607 75.0122 235.778 74.844 235.778 74.6372V43.4293C235.778 43.219 235.603 43.0543 235.389 43.0543H235.316ZM309.675 43.0543H288.157C287.793 43.0543 287.556 43.3136 287.556 43.6325V74.4725C287.556 74.8229 287.825 75.0507 288.157 75.0507H309.671C310.035 75.0507 310.272 74.7914 310.272 74.4725V70.6946C310.272 70.3441 310.002 70.1163 309.671 70.1163H293.979C293.615 70.1163 293.379 69.857 293.379 69.5381V61.779C293.379 61.4286 293.648 61.2008 293.979 61.2008H309.329C309.693 61.2008 309.93 60.9415 309.93 60.6225V56.8446C309.93 56.4942 309.66 56.2664 309.329 56.2664H293.979C293.615 56.2664 293.379 56.0071 293.379 55.6881V48.602C293.379 48.2515 293.648 48.0237 293.979 48.0237H309.679C310.043 48.0237 310.279 47.7644 310.279 47.4455V43.6676C310.279 43.3171 310.01 43.0893 309.679 43.0893L309.675 43.0543ZM332.354 58.1483H324.985C324.621 58.1483 324.392 57.889 324.392 57.5771V48.5564C324.392 48.206 324.657 47.9852 324.985 47.9852H332.391C335.666 47.9852 338.057 49.9477 338.057 53.0177C338.057 56.1718 335.669 58.1448 332.391 58.1448L332.354 58.1483ZM336.921 62.2942C340.633 61.3935 343.981 58.3341 343.981 53.0668C343.981 47.1266 339.658 43.0543 333.064 43.0543H319.126C318.762 43.0543 318.533 43.3101 318.533 43.6255V74.4409C318.533 74.7914 318.798 75.0157 319.126 75.0157H323.748C324.112 75.0157 324.341 74.7563 324.341 74.4409V63.654C324.341 63.3035 324.606 63.0827 324.934 63.0827H329.81C330.022 63.0827 330.174 63.1879 330.32 63.3631L337.285 74.7353C337.394 74.9105 337.587 75.0157 337.795 75.0157H343.144C343.61 75.0157 343.898 74.525 343.654 74.1395L336.521 63.1493C336.303 62.8129 336.506 62.3888 336.907 62.2907L336.921 62.2942ZM389.689 47.9887H405.418C405.494 47.9887 405.571 47.9741 405.641 47.9457C405.712 47.9173 405.777 47.8756 405.831 47.8232C405.885 47.7708 405.928 47.7085 405.957 47.6401C405.986 47.5717 406 47.4984 406 47.4244V43.6501C406 43.2996 405.738 43.0893 405.418 43.0893H383.874C383.719 43.0893 383.571 43.1484 383.462 43.2536C383.353 43.3587 383.292 43.5013 383.292 43.6501V74.483C383.292 74.8335 383.554 75.0437 383.874 75.0437H405.418C405.494 75.0437 405.571 75.0291 405.641 75.0007C405.712 74.9723 405.777 74.9307 405.831 74.8782C405.885 74.8258 405.928 74.7636 405.957 74.6951C405.986 74.6267 406 74.5534 406 74.4795V70.6701C406 70.5961 405.986 70.5228 405.957 70.4544C405.928 70.386 405.885 70.3237 405.831 70.2713C405.777 70.2189 405.712 70.1772 405.641 70.1488C405.571 70.1204 405.494 70.1058 405.418 70.1058H389.733C389.578 70.1058 389.43 70.0467 389.321 69.9416C389.212 69.8364 389.151 69.6938 389.151 69.5451V61.758C389.151 61.4076 389.413 61.1973 389.733 61.1973H405.112C405.189 61.1978 405.266 61.1835 405.337 61.1553C405.408 61.1271 405.473 61.0856 405.527 61.0331C405.582 60.9806 405.625 60.9182 405.654 60.8495C405.684 60.7809 405.698 60.7073 405.698 60.633V56.7921C405.698 56.4416 405.436 56.2314 405.116 56.2314H389.689C389.612 56.2318 389.536 56.2175 389.464 56.1894C389.393 56.1612 389.328 56.1196 389.274 56.0671C389.219 56.0146 389.176 55.9523 389.147 55.8836C389.118 55.8149 389.103 55.7414 389.103 55.6671V48.5564C389.103 48.4822 389.118 48.4086 389.147 48.3399C389.176 48.2713 389.219 48.2089 389.274 48.1564C389.328 48.1039 389.393 48.0624 389.464 48.0342C389.536 48.006 389.612 47.9882 389.689 47.9887ZM377.316 67.947L373.513 66.0476C373.269 65.9249 372.96 66.0125 372.811 66.2403C371.202 68.669 368.236 70.4738 365.016 70.4738C358.684 70.4738 353.989 65.585 353.989 58.9263C353.989 52.1696 358.72 47.3789 365.016 47.3789C368.236 47.3789 371.202 49.1382 372.811 51.6019C372.956 51.8332 373.273 51.9523 373.52 51.7911L377.294 49.811C377.585 49.6603 377.684 49.3134 377.505 49.0471C375.118 45.4269 371.166 42.3954 365.016 42.3954C355.572 42.3954 348.276 49.0541 348.276 58.9263C348.276 68.7496 355.608 75.4573 365.016 75.4573C371.159 75.4573 375.067 72.3487 377.534 68.7285C377.579 68.6657 377.608 68.5944 377.621 68.5195C377.634 68.4446 377.63 68.3679 377.61 68.2946C377.589 68.2213 377.552 68.1533 377.501 68.0951C377.451 68.0369 377.387 67.99 377.316 67.9575V67.947ZM278.284 43.0543H271.005C270.847 43.0521 270.692 43.097 270.562 43.183C270.432 43.269 270.332 43.3918 270.277 43.5344L261.478 65.4658L252.635 43.5344C252.515 43.247 252.227 43.0543 251.907 43.0543H244.629C244.41 43.0543 244.239 43.2225 244.239 43.4293V74.6372C244.239 74.8475 244.414 75.0122 244.629 75.0122H249.665C249.883 75.0122 250.055 74.844 250.055 74.6372V50.3367L260.135 74.8405C260.179 74.9456 260.281 75.0087 260.39 75.0087H262.493C262.602 75.0087 262.712 74.9386 262.748 74.8405L272.817 50.3332V74.6337C272.817 74.844 272.992 75.0087 273.207 75.0087H278.24C278.458 75.0087 278.629 74.8405 278.629 74.6337V43.4258C278.629 43.2155 278.455 43.0508 278.24 43.0508L278.284 43.0543Z'
      fill='#34313F'
    />
  </svg>
);

export const WooCommerce = (
  <svg
    width='32'
    height='32'
    fill='none'
    preserveAspectRatio='xMidYMid'
    version='1.1'
    viewBox='0 0 256 153'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='m23.759 0h208.38c13.187 0 23.863 10.675 23.863 23.863v79.542c0 13.187-10.675 23.863-23.863 23.863h-74.727l10.257 25.118-45.109-25.118h-98.695c-13.187 0-23.863-10.675-23.863-23.863v-79.542c-0.10466-13.083 10.571-23.863 23.758-23.863z'
      fill='#7f54b3'
    />
    <path
      d='m14.578 21.75c1.4569-1.9772 3.6423-3.0179 6.5561-3.226 5.3073-0.41626 8.3252 2.0813 9.0537 7.4927 3.226 21.75 6.7642 40.169 10.511 55.259l22.79-43.395c2.0813-3.9545 4.6829-6.0358 7.8049-6.2439 4.5789-0.3122 7.3886 2.6016 8.5333 8.7415 2.6016 13.841 5.9317 25.6 9.8862 35.59 2.7057-26.433 7.2846-45.476 13.737-57.236 1.561-2.9138 3.8504-4.3707 6.8683-4.5789 2.3935-0.20813 4.5789 0.52033 6.5561 2.0813 1.9772 1.561 3.0179 3.5382 3.226 5.9317 0.10406 1.8732-0.20813 3.4341-1.0407 4.9951-4.0585 7.4927-7.3886 20.085-10.094 37.567-2.6016 16.963-3.5382 30.179-2.9138 39.649 0.20813 2.6016-0.20813 4.8911-1.2488 6.8683-1.2488 2.2894-3.122 3.5382-5.5154 3.7463-2.7057 0.20813-5.5154-1.0406-8.2211-3.8504-9.678-9.8862-17.379-24.663-22.998-44.332-6.7642 13.32-11.759 23.311-14.985 29.971-6.1398 11.759-11.343 17.795-15.714 18.107-2.8098 0.20813-5.2033-2.1854-7.2846-7.1805-5.3073-13.633-11.031-39.961-17.171-78.985-0.41626-2.7057 0.20813-5.0992 1.665-6.9724zm223.64 16.338c-3.7463-6.5561-9.2618-10.511-16.65-12.072-1.9772-0.41626-3.8504-0.62439-5.6195-0.62439-9.9902 0-18.107 5.2033-24.455 15.61-5.4114 8.8455-8.1171 18.628-8.1171 29.346 0 8.013 1.665 14.881 4.9951 20.605 3.7463 6.5561 9.2618 10.511 16.65 12.072 1.9772 0.41626 3.8504 0.62439 5.6195 0.62439 10.094 0 18.211-5.2033 24.455-15.61 5.4114-8.9496 8.1171-18.732 8.1171-29.45 0.10406-8.1171-1.665-14.881-4.9951-20.501zm-13.112 28.826c-1.4569 6.8683-4.0585 11.967-7.9089 15.402-3.0179 2.7057-5.8276 3.8504-8.4293 3.3301-2.4976-0.52033-4.5789-2.7057-6.1398-6.7642-1.2488-3.226-1.8732-6.452-1.8732-9.4699 0-2.6016 0.20813-5.2033 0.72846-7.5967 0.93659-4.2667 2.7057-8.4293 5.5154-12.384 3.4341-5.0992 7.0764-7.1805 10.823-6.452 2.4976 0.52033 4.5789 2.7057 6.1398 6.7642 1.2488 3.226 1.8732 6.452 1.8732 9.4699 0 2.7057-0.20813 5.3073-0.72846 7.7008zm-52.033-28.826c-3.7463-6.5561-9.3659-10.511-16.65-12.072-1.9772-0.41626-3.8504-0.62439-5.6195-0.62439-9.9902 0-18.107 5.2033-24.455 15.61-5.4114 8.8455-8.1171 18.628-8.1171 29.346 0 8.013 1.665 14.881 4.9951 20.605 3.7463 6.5561 9.2618 10.511 16.65 12.072 1.9772 0.41626 3.8504 0.62439 5.6195 0.62439 10.094 0 18.211-5.2033 24.455-15.61 5.4114-8.9496 8.1171-18.732 8.1171-29.45 0-8.1171-1.665-14.881-4.9951-20.501zm-13.216 28.826c-1.4569 6.8683-4.0585 11.967-7.9089 15.402-3.0179 2.7057-5.8276 3.8504-8.4293 3.3301-2.4976-0.52033-4.5789-2.7057-6.1398-6.7642-1.2488-3.226-1.8732-6.452-1.8732-9.4699 0-2.6016 0.20813-5.2033 0.72846-7.5967 0.93658-4.2667 2.7057-8.4293 5.5154-12.384 3.4341-5.0992 7.0764-7.1805 10.823-6.452 2.4976 0.52033 4.5789 2.7057 6.1398 6.7642 1.2488 3.226 1.8732 6.452 1.8732 9.4699 0.10406 2.7057-0.20813 5.3073-0.72846 7.7008z'
      fill='#fff'
    />
  </svg>
);

export const MagentoNative = (
  <svg viewBox='0 0 43 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_4554_9419)'>
      <path
        d='M21.43 0L0 12.37V37.09L6.12 40.62L6.08 15.91L21.39 7.06L36.7 15.91V40.61L42.82 37.09V12.35L21.43 0Z'
        fill='#F26322'
      />
      <path
        d='M24.4697 40.6199L21.4097 42.3899L18.3397 40.6299V15.9099L12.2197 19.4399L12.2297 44.1499L21.4097 49.4499L30.5897 44.1499V19.4399L24.4697 15.9099V40.6199Z'
        fill='#F26322'
      />
    </g>
    <defs>
      <clipPath id='clip0_4554_9419'>
        <rect width='43' height='50' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const TikTokCedLogo = (
  <svg
    width='190'
    height='36'
    viewBox='0 0 190 36'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M11.8787 14.3872V12.9806C11.4099 12.9153 10.938 12.8797 10.4662 12.8767C4.68858 12.8827 0.00593491 17.5683 0 23.3459C0 26.7615 1.66771 29.9604 4.46899 31.9159C4.42151 31.8625 4.37106 31.8091 4.32358 31.7557C2.67071 29.904 1.72112 27.4618 1.72112 24.7881C1.70332 19.1351 6.22275 14.5059 11.8787 14.3872Z'
      fill='#69C4D0'></path>
    <path
      d='M12.1248 29.6101C14.7094 29.5923 16.8252 27.5507 16.938 24.969L16.9498 2.22055L21.0805 2.22648L21.0716 2.17603C20.9826 1.70124 20.9381 1.21755 20.9381 0.733856H15.2495L15.2406 23.5269C15.1456 26.0937 13.0387 28.1264 10.4689 28.1294C9.67068 28.1294 8.91398 27.9306 8.24927 27.5804C9.11873 28.7852 10.5283 29.6101 12.1248 29.6101ZM28.8493 10.0042V8.64805C27.2617 8.64805 25.781 8.17623 24.5406 7.36611C25.6445 8.63321 27.146 9.63918 28.8493 10.0042Z'
      fill='#69C4D0'></path>
    <path
      d='M24.5378 7.36323C23.2826 5.92698 22.5912 4.08419 22.5912 2.17612H21.0273C21.4309 4.34236 22.7573 6.20295 24.5378 7.36323ZM10.4662 18.5238C7.81028 18.5446 5.66482 20.693 5.64404 23.3459C5.64404 25.1828 6.73013 26.7763 8.24947 27.5775C7.66191 26.7674 7.34439 25.7911 7.34439 24.7911C7.34736 22.15 9.48689 20.0135 12.125 20.0105C12.6146 20.0105 13.0894 20.0936 13.5345 20.2331V14.4287C13.0686 14.3634 12.5968 14.3278 12.125 14.3249C12.0419 14.3249 11.9617 14.3308 11.8787 14.3308L11.8401 14.3367L11.8371 18.7226C11.392 18.5832 10.9291 18.5179 10.4662 18.5238Z'
      fill='#E83658'></path>
    <path
      d='M28.8496 9.91518L28.8199 9.90924L28.808 14.2892C25.9711 14.2862 23.2055 13.3901 20.9057 11.7283L20.8997 23.3518C20.9086 29.1027 16.2527 33.7705 10.5048 33.7794C10.4929 33.7794 10.484 33.7794 10.4721 33.7794C8.32961 33.7972 6.23162 33.1474 4.47192 31.9248C6.44825 34.0554 9.22282 35.2661 12.1309 35.2661C17.9086 35.2602 22.5942 30.5776 22.6001 24.797V13.2387C24.9058 14.8975 27.6744 15.7878 30.5143 15.7818V10.0903C29.9386 10.0903 29.3837 10.0279 28.8496 9.91518Z'
      fill='#E83658'></path>
    <path
      d='M20.935 23.3489V11.7877C23.2407 13.4465 26.0094 14.3367 28.8492 14.3308V9.91227C27.1756 9.55024 25.6622 8.65704 24.5405 7.36323C22.7244 6.18218 21.4692 4.30675 21.0715 2.17612H16.9052L16.8963 24.9691C16.8014 27.536 14.6945 29.5687 12.1247 29.5717C10.5875 29.5687 9.14533 28.8268 8.24916 27.5775C5.91378 26.346 5.01464 23.4557 6.24613 21.1174C7.07108 19.5506 8.69725 18.5683 10.4688 18.5624C10.9614 18.5624 11.4362 18.6425 11.8813 18.782V14.3249C6.20162 14.4643 1.66735 19.1054 1.65845 24.7851C1.65845 27.536 2.7297 30.0435 4.46863 31.9159C6.22536 33.1504 8.32038 33.8121 10.4688 33.8121C16.2494 33.8062 20.9321 29.1236 20.938 23.343V23.3489H20.935Z'
      fill='black'></path>
    <line
      x1='41.4628'
      y1='0.482513'
      x2='41.4628'
      y2='35.5175'
      stroke='#D7D9DB'
      strokeWidth='0.875877'></line>
    <path
      d='M71.5206 17.4145L79.2583 9.88064L69.6059 0.482513L57.9281 11.8219L51.5354 18.0154L69.4635 35.4713L79.7805 25.4261L71.5206 17.4145ZM55.4438 18.0462L69.6059 4.30339L75.3499 9.89604L69.5743 15.5195L67.3115 13.3163L65.3494 15.2268L67.6122 17.4299L62.6435 22.2677L64.6057 24.1781L69.5743 19.3404L75.8562 25.4569L69.4477 31.6966L55.4438 18.0462Z'
      fill='url(#paint0_linear_1497_2098)'></path>
    <path
      d='M133.051 17.4916V0.482513H88.5393V17.2297V35.5021L190 35.5175V17.4762H133.051V17.4916ZM89.6153 1.54558H131.959V17.4916H89.6153V1.54558ZM188.924 34.4698H89.6153V18.5546H131.975V22.8685V29.7862H133.241V25.2566L135.567 28.985H136.152L138.494 25.195L138.51 29.7862H139.76L139.744 22.8685H138.653L135.883 27.4597L133.067 22.8685V18.5546H188.94V34.4698H188.924Z'
      fill='#0A0A0A'></path>
    <path
      d='M95.9929 7.01489C96.3727 6.8146 96.8157 6.70675 97.3063 6.70675C98.05 6.70675 98.6829 6.98408 99.2051 7.52331L100.06 6.73757C99.7273 6.36781 99.3159 6.07508 98.8412 5.87479C98.3664 5.6745 97.8284 5.58206 97.243 5.58206C96.5309 5.58206 95.8821 5.73613 95.2967 6.04426C94.7112 6.3524 94.2681 6.76838 93.9358 7.30762C93.6035 7.84685 93.4453 8.46312 93.4453 9.14102C93.4453 9.81892 93.6035 10.4352 93.9358 10.9744C94.2681 11.5137 94.7112 11.9451 95.2967 12.2378C95.8821 12.5459 96.5309 12.7 97.243 12.7C97.8284 12.7 98.3506 12.6075 98.8412 12.4073C99.3317 12.207 99.7273 11.9296 100.06 11.5445L99.2051 10.7587C98.6829 11.298 98.0658 11.5753 97.3063 11.5753C96.8157 11.5753 96.3885 11.4674 95.9929 11.2672C95.6131 11.0669 95.3125 10.7741 95.091 10.4044C94.8694 10.0346 94.7587 9.61863 94.7587 9.15643C94.7587 8.69423 94.8694 8.27824 95.091 7.90848C95.2967 7.50791 95.5973 7.21518 95.9929 7.01489Z'
      fill='#0A0A0A'></path>
    <path
      d='M108.129 9.60322H111.563V8.54016H108.129V6.75297H111.99V5.6745H106.816V12.5921H112.132V11.5137H108.129V9.60322Z'
      fill='#0A0A0A'></path>
    <path
      d='M124.032 6.10601C123.446 5.81328 122.766 5.67462 122.006 5.67462H118.905V12.5923H122.006C122.766 12.5923 123.43 12.4536 124.032 12.1609C124.617 11.8681 125.076 11.4676 125.408 10.9437C125.741 10.4199 125.899 9.81904 125.899 9.12574C125.899 8.44784 125.741 7.83157 125.408 7.30774C125.076 6.78391 124.617 6.38333 124.032 6.10601ZM124.237 10.3737C124.032 10.728 123.715 11.0054 123.32 11.2056C122.924 11.4059 122.465 11.4984 121.943 11.4984H120.218V6.75309H121.943C122.465 6.75309 122.924 6.84554 123.32 7.04582C123.715 7.24611 124.016 7.52343 124.237 7.87779C124.443 8.23214 124.554 8.64813 124.554 9.12574C124.554 9.60334 124.459 10.0193 124.237 10.3737Z'
      fill='#0A0A0A'></path>
    <path
      d='M95.9929 24.2089C96.3727 24.0086 96.8157 23.9007 97.3063 23.9007C98.05 23.9007 98.6829 24.178 99.2051 24.7173L100.06 23.9315C99.7273 23.5618 99.3159 23.269 98.8412 23.0688C98.3664 22.8685 97.8284 22.776 97.243 22.776C96.5309 22.776 95.8821 22.9301 95.2967 23.2382C94.7112 23.5464 94.2681 23.9624 93.9358 24.5016C93.6035 25.0408 93.4453 25.6571 93.4453 26.335C93.4453 27.0129 93.6035 27.6292 93.9358 28.1684C94.2681 28.7076 94.7112 29.139 95.2967 29.4317C95.8821 29.7399 96.5309 29.894 97.243 29.894C97.8284 29.894 98.3506 29.8015 98.8412 29.6012C99.3317 29.4009 99.7273 29.1236 100.06 28.7384L99.2051 27.9527C98.6829 28.4919 98.0658 28.7693 97.3063 28.7693C96.8157 28.7693 96.3885 28.6614 95.9929 28.4611C95.6131 28.2608 95.3125 27.9681 95.091 27.5983C94.8694 27.2286 94.7587 26.8126 94.7587 26.3504C94.7587 25.8882 94.8694 25.4722 95.091 25.1025C95.2967 24.7019 95.5973 24.4091 95.9929 24.2089Z'
      fill='#0A0A0A'></path>
    <path
      d='M111.326 23.2228C110.74 22.9147 110.091 22.7606 109.363 22.7606C108.636 22.7606 107.987 22.9147 107.401 23.2228C106.816 23.5309 106.357 23.9469 106.025 24.5016C105.692 25.0408 105.534 25.6571 105.534 26.3196C105.534 26.9974 105.692 27.5983 106.025 28.1375C106.357 28.6768 106.816 29.1082 107.401 29.4163C107.987 29.7244 108.636 29.8785 109.363 29.8785C110.091 29.8785 110.74 29.7244 111.326 29.4163C111.911 29.1082 112.37 28.6922 112.702 28.153C113.035 27.6137 113.193 26.9974 113.193 26.3196C113.193 25.6417 113.035 25.0254 112.702 24.4861C112.37 23.9623 111.911 23.5309 111.326 23.2228ZM111.547 27.5675C111.326 27.9373 111.025 28.23 110.661 28.4303C110.281 28.6306 109.854 28.7384 109.379 28.7384C108.905 28.7384 108.477 28.6306 108.098 28.4303C107.718 28.23 107.417 27.9373 107.211 27.5675C106.99 27.1977 106.879 26.7818 106.879 26.3196C106.879 25.8573 106.99 25.4414 107.211 25.0716C107.433 24.7018 107.718 24.4091 108.098 24.2088C108.477 24.0085 108.905 23.9007 109.379 23.9007C109.854 23.9007 110.281 24.0085 110.661 24.2088C111.041 24.4091 111.341 24.7018 111.547 25.0716C111.769 25.4414 111.879 25.8573 111.879 26.3196C111.864 26.7818 111.753 27.1977 111.547 27.5675Z'
      fill='#0A0A0A'></path>
    <path
      d='M125.377 22.8685L122.592 27.4443L119.775 22.8685H118.699V29.7861H119.95V25.2565L122.291 29.0004H122.877L125.203 25.1949L125.219 29.7861H126.469L126.453 22.8685H125.377Z'
      fill='#0A0A0A'></path>
    <path
      d='M150.567 28.7076H146.548V26.7972H149.982V25.7495H146.548V23.9469H150.425V22.8685H145.235V29.7861H150.567V28.7076Z'
      fill='#0A0A0A'></path>
    <path
      d='M157.371 27.7678H158.969C159.096 27.7678 159.175 27.7678 159.238 27.7524L160.694 29.7707H162.118L160.488 27.5059C160.979 27.321 161.343 27.0437 161.612 26.6585C161.865 26.2888 162.008 25.842 162.008 25.3181C162.008 24.8097 161.881 24.3783 161.644 24.0086C161.406 23.6388 161.042 23.3615 160.599 23.1612C160.14 22.9609 159.602 22.8685 158.985 22.8685H156.058V29.7861H157.371V27.7678ZM157.371 23.9469H158.906C159.476 23.9469 159.919 24.0702 160.219 24.3013C160.52 24.5324 160.663 24.8713 160.663 25.3181C160.663 25.7649 160.52 26.1039 160.219 26.335C159.919 26.5815 159.492 26.6893 158.906 26.6893H157.371V23.9469Z'
      fill='#0A0A0A'></path>
    <path
      d='M169.477 29.4163C170.063 29.7244 170.712 29.8785 171.424 29.8785C172.009 29.8785 172.531 29.786 173.022 29.5857C173.512 29.3854 173.908 29.1081 174.24 28.723L173.386 27.9372C172.864 28.4764 172.246 28.7538 171.487 28.7538C170.996 28.7538 170.569 28.6459 170.174 28.4456C169.794 28.2453 169.493 27.9526 169.272 27.5829C169.05 27.2131 168.939 26.7971 168.939 26.3349C168.939 25.8727 169.05 25.4567 169.272 25.087C169.493 24.7172 169.794 24.4245 170.174 24.2242C170.553 24.0239 170.996 23.916 171.487 23.916C172.231 23.916 172.864 24.1934 173.386 24.7326L174.24 23.9469C173.908 23.5771 173.497 23.2844 173.022 23.0841C172.547 22.8838 172.009 22.7914 171.424 22.7914C170.712 22.7914 170.063 22.9454 169.477 23.2536C168.892 23.5617 168.449 23.9777 168.117 24.5169C167.784 25.0561 167.626 25.6724 167.626 26.3503C167.626 27.0282 167.784 27.6445 168.117 28.1837C168.449 28.6921 168.892 29.1235 169.477 29.4163Z'
      fill='#0A0A0A'></path>
    <path
      d='M185.063 28.7075H181.059V26.7971H184.493V25.7494H181.059V23.9468H184.92V22.8683H179.73V29.786H185.063V28.7075Z'
      fill='#0A0A0A'></path>
    <defs>
      <linearGradient
        id='paint0_linear_1497_2098'
        x1='51.5219'
        y1='17.9922'
        x2='79.7588'
        y2='17.9922'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC'></stop>
        <stop offset='0.47' stopColor='#383365'></stop>
        <stop offset='1' stopColor='#0A0A0A'></stop>
      </linearGradient>
    </defs>
  </svg>
);
export const TiktokCircle = (
  <svg
    width='33'
    height='32'
    viewBox='0 0 33 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <circle cx='16.7246' cy='16' r='15.5' fill='white' stroke='#E0E1E3' />
    <path
      d='M25.3916 11.7665V14.8666C25.2249 14.8666 25.0249 14.9 24.8249 14.9C23.3248 14.9 21.9248 14.3333 20.8581 13.4332V20.0335C20.8581 21.3669 20.4247 22.6336 19.658 23.6336C18.5913 25.067 16.8579 26.0337 14.8912 26.0337C12.7578 26.0337 10.891 24.9003 9.85767 23.2336C10.9244 24.2336 12.3578 24.867 13.9245 24.867C15.8579 24.867 17.5913 23.9336 18.658 22.4669C19.3914 21.4669 19.858 20.2335 19.858 18.8668V12.2332C20.9247 13.1666 22.2915 13.6999 23.8249 13.6999C24.0249 13.6999 24.1915 13.6999 24.3915 13.6666V11.6665C24.6916 11.7332 24.9582 11.7665 25.2582 11.7665H25.3916Z'
      fill='#FF004F'
    />
    <path
      d='M15.7245 14.0667V17.5001C15.4912 17.4335 15.2245 17.4001 14.9911 17.4001C13.5244 17.4001 12.3244 18.6335 12.3244 20.1336C12.3244 20.4669 12.391 20.7669 12.491 21.0669C11.8244 20.5669 11.3577 19.7669 11.3577 18.8668C11.3577 17.3668 12.5577 16.1334 14.0244 16.1334C14.2911 16.1334 14.5245 16.1667 14.7578 16.2334V14.0333C14.8245 14.0333 14.8911 14.0333 14.9578 14.0333C15.2245 14.0333 15.4912 14.0333 15.7245 14.0667Z'
      fill='#FF004F'
    />
    <path
      d='M21.358 9.29977C20.758 8.76641 20.3247 8.03305 20.0913 7.26636H20.8913C20.8913 7.43303 20.8913 7.56637 20.8913 7.73304C20.958 8.2664 21.1247 8.79975 21.358 9.29977Z'
      fill='#FF004F'
    />
    <path
      d='M24.4249 11.6999V13.6999C24.2582 13.7333 24.0582 13.7333 23.8582 13.7333C22.3581 13.7333 20.9581 13.1666 19.8914 12.2665V18.8668C19.8914 20.2002 19.458 21.4669 18.6913 22.4669C17.5913 23.9337 15.8912 24.867 13.9578 24.867C12.3911 24.867 10.9577 24.2337 9.891 23.2336C9.32431 22.3003 8.99097 21.2335 8.99097 20.0668C8.99097 16.8334 11.5577 14.2 14.7578 14.0999V16.3C14.5245 16.2334 14.2578 16.2 14.0245 16.2C12.5578 16.2 11.3577 17.4334 11.3577 18.9335C11.3577 19.8335 11.7911 20.6669 12.4911 21.1335C12.8578 22.1669 13.8578 22.9336 14.9912 22.9336C16.4579 22.9336 17.658 21.7002 17.658 20.2002V7.26636H20.0914C20.3247 8.06639 20.7581 8.76641 21.3581 9.29977C21.9581 10.4998 23.0915 11.3998 24.4249 11.6999Z'
      fill='black'
    />
    <path
      d='M14.7579 12.8999V14.0333C11.5577 14.1333 8.99099 16.7667 8.99099 20.0002C8.99099 21.1669 9.32433 22.2336 9.89102 23.167C8.75764 22.0669 8.05762 20.5335 8.05762 18.8001C8.05762 15.5 10.7244 12.8333 13.9912 12.8333C14.2578 12.8333 14.5245 12.8666 14.7579 12.8999Z'
      fill='#00F7EF'
    />
    <path
      d='M20.0913 7.26636H17.6578V20.1335C17.6578 21.6336 16.4578 22.8669 14.9911 22.8669C13.8244 22.8669 12.8576 22.1336 12.491 21.0669C12.9243 21.3669 13.4577 21.5669 14.0244 21.5669C15.4911 21.5669 16.6911 20.3668 16.6911 18.8668V5.96631H19.9246V6.03298C19.9246 6.16632 19.9246 6.29965 19.9579 6.43299C19.9579 6.69967 20.0246 6.99968 20.0913 7.26636Z'
      fill='#00F7EF'
    />
    <path
      d='M24.4248 10.4665V11.6666C23.0914 11.3999 21.9581 10.4998 21.3247 9.2998C22.1581 10.0665 23.2248 10.4998 24.4248 10.4665Z'
      fill='#00F7EF'
    />
  </svg>
);

export const TikTok = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='119'
    height='22'
    viewBox='0 0 119 22'
    fill='none'>
    <path
      d='M82.6311 13.7075C82.6491 14.2658 82.9013 14.7915 83.4072 15.2418C83.9116 15.6937 84.5453 15.9099 85.3035 15.9099C86.8034 15.9099 87.6533 15.1157 87.8137 14.0857C87.9038 12.8576 86.9999 12.1535 85.7014 11.8636L84.0933 11.4657C82.071 10.9417 81.0607 9.85771 81.0607 8.21531C81.0607 7.18532 81.4586 6.35348 82.2528 5.70503C83.047 5.03694 83.9869 4.71271 85.0889 4.71271C86.245 4.71271 87.2013 5.05495 87.9595 5.72304C88.7193 6.39114 89.0975 7.25901 89.0975 8.35941H87.4175C87.4175 7.13129 86.4432 6.31909 85.0693 6.31909C84.4372 6.31909 83.8952 6.50085 83.4269 6.84309C82.9749 7.18532 82.7408 7.63727 82.7408 8.19566C82.7408 9.06189 83.3368 9.64156 84.5109 9.92976L86.1353 10.3277C88.4998 10.9237 89.6936 12.2779 89.4594 14.2282C89.3497 15.1665 88.9158 15.9443 88.1773 16.5567C87.4355 17.1708 86.4792 17.4786 85.3051 17.4786C84.059 17.4786 83.029 17.0987 82.1988 16.3586C81.3686 15.6004 80.9526 14.7162 80.9526 13.7042L82.6311 13.7075ZM92.5837 17.2985H90.9413V4.27878H92.5854V10.1312C92.8195 9.66121 93.1994 9.30097 93.7415 9.0668C94.3015 8.81299 94.8435 8.6869 95.3675 8.6869C97.4799 8.6869 98.798 10.0591 98.78 12.4253V17.3018H97.136V12.5334C97.136 11.1612 96.3238 10.2949 95.1497 10.2949C94.4816 10.2949 93.8856 10.4931 93.3616 10.909C92.8376 11.3069 92.5854 11.921 92.5854 12.7512V17.3001L92.5837 17.2985ZM101.258 9.89537C102.106 9.08154 103.154 8.68527 104.4 8.68527C105.646 8.68527 106.694 9.08318 107.542 9.89537C108.39 10.7076 108.824 11.7556 108.824 13.0557C108.824 14.3575 108.39 15.4219 107.523 16.2521C106.674 17.066 105.626 17.4802 104.398 17.4802C103.17 17.4802 102.122 17.0643 101.274 16.2521C100.426 15.4399 99.9918 14.3739 99.9918 13.0557C99.9934 11.7556 100.409 10.7076 101.258 9.89537ZM106.37 11.0514C105.844 10.5455 105.178 10.2917 104.402 10.2917C103.625 10.2917 102.957 10.5455 102.415 11.0514C101.893 11.5558 101.621 12.2255 101.621 13.0557C101.621 13.904 101.893 14.5917 102.415 15.1141C102.957 15.6381 103.625 15.8902 104.402 15.8902C105.178 15.8902 105.846 15.6364 106.37 15.1141C106.912 14.5901 107.182 13.904 107.182 13.0557C107.182 12.2255 106.912 11.5574 106.37 11.0514ZM111.829 8.86539V10.1836C112.389 9.24365 113.563 8.68527 114.773 8.68527C115.947 8.68527 116.958 9.10119 117.772 9.91338C118.584 10.7256 119 11.7916 119 13.1098C119 14.4116 118.584 15.4579 117.772 16.2701C116.958 17.084 115.965 17.4802 114.773 17.4802C113.545 17.4802 112.353 16.9759 111.829 16.036V21.3988H110.187V8.86703L111.829 8.86539ZM112.677 15.1501C113.208 15.6266 113.897 15.8837 114.61 15.8739C116.18 15.8739 117.336 14.7718 117.336 13.1278C117.336 12.2976 117.064 11.6098 116.542 11.0875C116.02 10.5635 115.386 10.2933 114.61 10.2933C113.833 10.2933 113.183 10.5471 112.641 11.0695C112.119 11.5738 111.847 12.2615 111.847 13.1278C111.847 13.9776 112.117 14.6638 112.677 15.1501Z'
      fill='black'
    />
    <path
      d='M6.55488 7.53408V6.75791C6.29616 6.72188 6.0358 6.70223 5.77544 6.70059C2.58724 6.70387 0.00327498 9.28947 0 12.4777C0 14.3624 0.920272 16.1276 2.46606 17.2067C2.43986 17.1773 2.41203 17.1478 2.38583 17.1183C1.47374 16.0965 0.949746 14.7489 0.949746 13.2735C0.939921 10.1541 3.43382 7.59957 6.55488 7.53408Z'
      fill='#69C4D0'
    />
    <path
      d='M6.69081 15.9344C8.11707 15.9246 9.2846 14.798 9.34682 13.3734L9.35337 0.820383L11.6328 0.823658L11.6278 0.795819C11.5787 0.53382 11.5542 0.266911 11.5542 0H8.41509L8.41018 12.5776C8.35778 13.994 7.19516 15.1157 5.77709 15.1173C5.3366 15.1173 4.91904 15.0076 4.55225 14.8144C5.03203 15.4792 5.80984 15.9344 6.69081 15.9344ZM15.9197 5.11552V4.36719C15.0437 4.36719 14.2265 4.10683 13.5421 3.65979C14.1512 4.359 14.9798 4.91411 15.9197 5.11552Z'
      fill='#69C4D0'
    />
    <path
      d='M13.5402 3.65814C12.8475 2.8656 12.466 1.84871 12.466 0.795807H11.603C11.8257 1.99118 12.5577 3.01789 13.5402 3.65814ZM5.77518 9.81675C4.30963 9.82821 3.12572 11.0138 3.11426 12.4777C3.11426 13.4913 3.71358 14.3706 4.55198 14.8127C4.22775 14.3657 4.05254 13.827 4.05254 13.2751C4.05418 11.8178 5.23481 10.6388 6.69054 10.6371C6.96073 10.6371 7.22272 10.683 7.46835 10.7599V7.55701C7.21126 7.52099 6.9509 7.50134 6.69054 7.4997C6.64469 7.4997 6.60048 7.50298 6.55463 7.50298L6.53334 7.50625L6.5317 9.92647C6.28608 9.8495 6.03063 9.81348 5.77518 9.81675Z'
      fill='#E83658'
    />
    <path
      d='M15.9198 5.06642L15.9034 5.06314L15.8968 7.48008C14.3314 7.47844 12.8053 6.98392 11.5362 6.06692L11.5329 12.481C11.5378 15.6544 8.96862 18.2302 5.7968 18.2351C5.79025 18.2351 5.78533 18.2351 5.77878 18.2351C4.59651 18.245 3.43881 17.8863 2.46777 17.2117C3.55834 18.3874 5.0894 19.0555 6.69414 19.0555C9.88234 19.0522 12.4679 16.4683 12.4712 13.2784V6.90041C13.7435 7.81577 15.2713 8.30701 16.8384 8.30374V5.16303C16.5207 5.16303 16.2145 5.12864 15.9198 5.06642Z'
      fill='#E83658'
    />
    <path
      d='M11.5527 12.4793V6.09965C12.825 7.01501 14.3528 7.50625 15.9199 7.50298V5.06475C14.9963 4.86498 14.1612 4.37209 13.5422 3.65815C12.5401 3.00642 11.8474 1.97153 11.628 0.795807H9.32896L9.32405 13.3734C9.27165 14.7898 8.10903 15.9115 6.69096 15.9131C5.84274 15.9115 5.04692 15.5021 4.5524 14.8127C3.26369 14.1332 2.76753 12.5383 3.44709 11.2479C3.90231 10.3833 4.79966 9.84132 5.77724 9.83804C6.04907 9.83804 6.31106 9.88226 6.55669 9.95922V7.4997C3.42253 7.57666 0.92044 10.1377 0.915527 13.2719C0.915527 14.7898 1.50666 16.1735 2.46623 17.2068C3.43563 17.888 4.5917 18.2531 5.77724 18.2531C8.96708 18.2498 11.551 15.6659 11.5543 12.476V12.4793H11.5527ZM19.7778 4.81094H29.0722L28.2191 7.47023L25.8087 7.46859V17.2985H22.8039V7.46859L19.7811 7.4735L19.7778 4.81094ZM44.2976 4.81094H53.8082L52.9534 7.47023L50.3334 7.46859V17.2985H47.3237V7.46859L44.3009 7.4735L44.2976 4.81094ZM29.6388 8.7835H32.619L32.6157 17.3017H29.6568L29.6388 8.7835ZM33.7996 4.77492H36.7766V10.5929L39.7257 7.69784H43.2791L39.5472 11.32L43.7278 17.3017H40.4479L37.6592 13.154L36.7766 14.012V17.3034H33.8013L33.7996 4.77492ZM65.341 4.77492H68.3163V10.5929L71.2671 7.69784H74.8205L71.0886 11.32L75.2675 17.3017H71.9876L69.199 13.154L68.3163 14.012V17.3034H65.341V4.77492ZM31.1273 7.81082C31.9558 7.81082 32.6272 7.13945 32.6272 6.31252C32.6272 5.48395 31.9558 4.81258 31.1289 4.81258H31.1273C30.2987 4.81258 29.629 5.48395 29.629 6.31252C29.629 7.13945 30.3003 7.80919 31.1273 7.81082Z'
      fill='black'
    />
    <path
      d='M53.4265 12.2026C53.4265 9.54168 55.4734 7.32779 58.1261 7.11983C57.9771 7.10836 57.8281 7.10345 57.6791 7.10345C54.8626 7.10345 52.5815 9.38611 52.5815 12.201C52.5815 15.0174 54.8642 17.2985 57.6791 17.2985C57.815 17.2985 57.9935 17.2919 58.1261 17.2821C55.4734 17.0758 53.4265 14.8619 53.4265 12.2026Z'
      fill='#69C4D0'
    />
    <path
      d='M59.2838 7.10345C59.1479 7.10345 58.9678 7.11164 58.8335 7.11983C61.6402 7.34416 63.7329 9.8004 63.5085 12.6071C63.3088 15.1026 61.3274 17.0823 58.8335 17.2821C58.9661 17.2936 59.1479 17.2985 59.2838 17.2985C62.1003 17.2985 64.3813 15.0158 64.3813 12.201C64.3813 9.38611 62.0987 7.10345 59.2838 7.10345Z'
      fill='#E83658'
    />
    <path
      d='M58.4782 7.10346C55.6617 7.10182 53.3791 9.38448 53.3774 12.1993C53.3758 15.0158 55.6585 17.2985 58.4733 17.3001C58.475 17.3001 58.4766 17.3001 58.4766 17.3001C61.2931 17.3001 63.5741 15.0175 63.5741 12.2026C63.5774 9.38612 61.2947 7.10346 58.4782 7.10346ZM58.4782 14.6801C57.1093 14.6801 55.9991 13.5699 55.9991 12.201C55.9991 10.832 57.1093 9.7218 58.4782 9.7218C59.8472 9.7218 60.9574 10.832 60.9574 12.201C60.9574 13.5699 59.8472 14.6801 58.4782 14.6801Z'
      fill='black'
    />
  </svg>
);

export const IconSuccess = (
  <svg
    width='90'
    height='90'
    viewBox='0 0 90 90'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <circle cx='45' cy='45' r='44.5' fill='#1B875A' fillOpacity='0.25' />
    <ellipse cx='44.82' cy='44.82' rx='34.32' ry='34.32' fill='#1B875A' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M55.8011 34.8464C56.8602 35.6585 57.0623 37.1745 56.253 38.2357L44.2426 53.9829C43.8191 54.5382 43.1773 54.8832 42.4816 54.9295C41.786 54.9758 41.1042 54.7189 40.6113 54.2246L32.9883 46.5815C32.0455 45.6363 32.0455 44.1064 32.9883 43.1612C33.9345 42.2124 35.4713 42.2124 36.4176 43.1612L42.0783 48.8368L52.4031 35.2994C53.2154 34.2344 54.7381 34.0314 55.8011 34.8464Z'
      fill='white'
    />
  </svg>
);

export const IconError = (
  <svg
    className='animate__animated animate__bounceIn '
    width='160'
    height='150'
    viewBox='0 0 160 150'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      className='rotate_animation'
      d='M93.8699 16.1748C97.4786 14.3503 101.934 15.7184 103.791 19.2216L109.391 29.7814C110.471 31.8183 112.503 33.2255 114.845 33.5594L126.989 35.2905C131.018 35.8647 133.791 39.5031 133.163 43.3927L131.273 55.1175C130.908 57.3792 131.696 59.6719 133.388 61.2731L142.16 69.5737C145.07 72.3275 145.101 76.8464 142.228 79.6367L133.57 88.048C131.9 89.6704 131.143 91.9731 131.538 94.2299L133.588 105.93C134.268 109.811 131.545 113.484 127.525 114.11L115.405 115.995C113.067 116.359 111.055 117.791 110.003 119.842L104.547 130.472C102.737 133.998 98.3006 135.423 94.668 133.644L83.7172 128.283C81.6044 127.249 79.1056 127.264 77.007 128.325L66.13 133.825C62.5215 135.65 58.0663 134.282 56.2086 130.778L50.6089 120.219C49.5287 118.182 47.4973 116.774 45.1547 116.441L33.0107 114.71C28.9821 114.135 26.2096 110.497 26.8368 106.607L28.7273 94.8824C29.092 92.6208 28.3041 90.328 26.612 88.7269L17.8399 80.4261C14.9298 77.6723 14.8991 73.1538 17.7715 70.3631L26.4301 61.9519C28.1004 60.3294 28.8571 58.0269 28.4617 55.77L26.4121 44.0702C25.7321 40.1889 28.4549 36.5157 32.4754 35.8903L44.5949 34.0053C46.9327 33.6417 48.9449 32.2088 49.9973 30.1583L55.453 19.5284C57.263 16.0019 61.6992 14.5774 65.332 16.3559L76.2832 21.7172C78.3955 22.7514 80.8948 22.7356 82.9929 21.6746L93.8699 16.1748Z'
      fill='#A64A44'
    />
    <path
      d='M63.1256 56.856L98.1256 91.856M98.1256 56.856L63.1256 91.856'
      stroke='#F8F7FA'
      strokeWidth='12'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const UserIcon = (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <rect width='40' height='40' rx='20' fill='#F0EDFA' />
    <path
      d='M26.6667 27.5V25.8333C26.6667 24.9493 26.3155 24.1014 25.6904 23.4763C25.0653 22.8512 24.2174 22.5 23.3334 22.5H16.6667C15.7827 22.5 14.9348 22.8512 14.3097 23.4763C13.6846 24.1014 13.3334 24.9493 13.3334 25.8333V27.5'
      stroke='#3B424F'
      strokeWidth='1.66667'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M20 19.1667C21.8409 19.1667 23.3333 17.6743 23.3333 15.8333C23.3333 13.9924 21.8409 12.5 20 12.5C18.159 12.5 16.6666 13.9924 16.6666 15.8333C16.6666 17.6743 18.159 19.1667 20 19.1667Z'
      stroke='#3B424F'
      strokeWidth='1.66667'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const CedTikTokLogodesk = (
  <svg
    width='190'
    height='36'
    viewBox='0 0 190 36'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M11.8787 14.3872V12.9806C11.4099 12.9153 10.938 12.8797 10.4662 12.8767C4.68858 12.8827 0.00593491 17.5683 0 23.3459C0 26.7615 1.66771 29.9604 4.46899 31.9159C4.42151 31.8625 4.37106 31.8091 4.32358 31.7557C2.67071 29.904 1.72112 27.4618 1.72112 24.7881C1.70332 19.1351 6.22275 14.5059 11.8787 14.3872Z'
      fill='#69C4D0'
    />
    <path
      d='M12.1248 29.6101C14.7094 29.5923 16.8252 27.5507 16.938 24.969L16.9498 2.22055L21.0805 2.22648L21.0716 2.17603C20.9826 1.70124 20.9381 1.21755 20.9381 0.733856H15.2495L15.2406 23.5269C15.1456 26.0937 13.0387 28.1264 10.4689 28.1294C9.67068 28.1294 8.91398 27.9306 8.24927 27.5804C9.11873 28.7852 10.5283 29.6101 12.1248 29.6101ZM28.8493 10.0042V8.64805C27.2617 8.64805 25.781 8.17623 24.5406 7.36611C25.6445 8.63321 27.146 9.63918 28.8493 10.0042Z'
      fill='#69C4D0'
    />
    <path
      d='M24.5378 7.36323C23.2826 5.92698 22.5912 4.08419 22.5912 2.17612H21.0273C21.4309 4.34236 22.7573 6.20295 24.5378 7.36323ZM10.4662 18.5238C7.81028 18.5446 5.66482 20.693 5.64404 23.3459C5.64404 25.1828 6.73013 26.7763 8.24947 27.5775C7.66191 26.7674 7.34439 25.7911 7.34439 24.7911C7.34736 22.15 9.48689 20.0135 12.125 20.0105C12.6146 20.0105 13.0894 20.0936 13.5345 20.2331V14.4287C13.0686 14.3634 12.5968 14.3278 12.125 14.3249C12.0419 14.3249 11.9617 14.3308 11.8787 14.3308L11.8401 14.3367L11.8371 18.7226C11.392 18.5832 10.9291 18.5179 10.4662 18.5238Z'
      fill='#E83658'
    />
    <path
      d='M28.8496 9.91518L28.8199 9.90924L28.808 14.2892C25.9711 14.2862 23.2055 13.3901 20.9057 11.7283L20.8997 23.3518C20.9086 29.1027 16.2527 33.7705 10.5048 33.7794C10.4929 33.7794 10.484 33.7794 10.4721 33.7794C8.32961 33.7972 6.23162 33.1474 4.47192 31.9248C6.44825 34.0554 9.22282 35.2661 12.1309 35.2661C17.9086 35.2602 22.5942 30.5776 22.6001 24.797V13.2387C24.9058 14.8975 27.6744 15.7878 30.5143 15.7818V10.0903C29.9386 10.0903 29.3837 10.0279 28.8496 9.91518Z'
      fill='#E83658'
    />
    <path
      d='M20.935 23.3489V11.7877C23.2407 13.4465 26.0094 14.3367 28.8492 14.3308V9.91227C27.1756 9.55024 25.6622 8.65704 24.5405 7.36323C22.7244 6.18218 21.4692 4.30675 21.0715 2.17612H16.9052L16.8963 24.9691C16.8014 27.536 14.6945 29.5687 12.1247 29.5717C10.5875 29.5687 9.14533 28.8268 8.24916 27.5775C5.91378 26.346 5.01464 23.4557 6.24613 21.1174C7.07108 19.5506 8.69725 18.5683 10.4688 18.5624C10.9614 18.5624 11.4362 18.6425 11.8813 18.782V14.3249C6.20162 14.4643 1.66735 19.1054 1.65845 24.7851C1.65845 27.536 2.7297 30.0435 4.46863 31.9159C6.22536 33.1504 8.32038 33.8121 10.4688 33.8121C16.2494 33.8062 20.9321 29.1236 20.938 23.343V23.3489H20.935Z'
      fill='black'
    />
    <line
      x1='41.4628'
      y1='0.482513'
      x2='41.4628'
      y2='35.5175'
      stroke='#D7D9DB'
      strokeWidth='0.875877'
    />
    <path
      d='M71.5206 17.4145L79.2583 9.88064L69.6059 0.482513L57.9281 11.8219L51.5354 18.0154L69.4635 35.4713L79.7805 25.4261L71.5206 17.4145ZM55.4438 18.0462L69.6059 4.30339L75.3499 9.89604L69.5743 15.5195L67.3115 13.3163L65.3494 15.2268L67.6122 17.4299L62.6435 22.2677L64.6057 24.1781L69.5743 19.3404L75.8562 25.4569L69.4477 31.6966L55.4438 18.0462Z'
      fill='url(#paint0_linear_1497_2098)'
    />
    <path
      d='M133.051 17.4916V0.482513H88.5393V17.2297V35.5021L190 35.5175V17.4762H133.051V17.4916ZM89.6153 1.54558H131.959V17.4916H89.6153V1.54558ZM188.924 34.4698H89.6153V18.5546H131.975V22.8685V29.7862H133.241V25.2566L135.567 28.985H136.152L138.494 25.195L138.51 29.7862H139.76L139.744 22.8685H138.653L135.883 27.4597L133.067 22.8685V18.5546H188.94V34.4698H188.924Z'
      fill='#0A0A0A'
    />
    <path
      d='M95.9929 7.01489C96.3727 6.8146 96.8157 6.70675 97.3063 6.70675C98.05 6.70675 98.6829 6.98408 99.2051 7.52331L100.06 6.73757C99.7273 6.36781 99.3159 6.07508 98.8412 5.87479C98.3664 5.6745 97.8284 5.58206 97.243 5.58206C96.5309 5.58206 95.8821 5.73613 95.2967 6.04426C94.7112 6.3524 94.2681 6.76838 93.9358 7.30762C93.6035 7.84685 93.4453 8.46312 93.4453 9.14102C93.4453 9.81892 93.6035 10.4352 93.9358 10.9744C94.2681 11.5137 94.7112 11.9451 95.2967 12.2378C95.8821 12.5459 96.5309 12.7 97.243 12.7C97.8284 12.7 98.3506 12.6075 98.8412 12.4073C99.3317 12.207 99.7273 11.9296 100.06 11.5445L99.2051 10.7587C98.6829 11.298 98.0658 11.5753 97.3063 11.5753C96.8157 11.5753 96.3885 11.4674 95.9929 11.2672C95.6131 11.0669 95.3125 10.7741 95.091 10.4044C94.8694 10.0346 94.7587 9.61863 94.7587 9.15643C94.7587 8.69423 94.8694 8.27824 95.091 7.90848C95.2967 7.50791 95.5973 7.21518 95.9929 7.01489Z'
      fill='#0A0A0A'
    />
    <path
      d='M108.129 9.60322H111.563V8.54016H108.129V6.75297H111.99V5.6745H106.816V12.5921H112.132V11.5137H108.129V9.60322Z'
      fill='#0A0A0A'
    />
    <path
      d='M124.032 6.10601C123.446 5.81328 122.766 5.67462 122.006 5.67462H118.905V12.5923H122.006C122.766 12.5923 123.43 12.4536 124.032 12.1609C124.617 11.8681 125.076 11.4676 125.408 10.9437C125.741 10.4199 125.899 9.81904 125.899 9.12574C125.899 8.44784 125.741 7.83157 125.408 7.30774C125.076 6.78391 124.617 6.38333 124.032 6.10601ZM124.237 10.3737C124.032 10.728 123.715 11.0054 123.32 11.2056C122.924 11.4059 122.465 11.4984 121.943 11.4984H120.218V6.75309H121.943C122.465 6.75309 122.924 6.84554 123.32 7.04582C123.715 7.24611 124.016 7.52343 124.237 7.87779C124.443 8.23214 124.554 8.64813 124.554 9.12574C124.554 9.60334 124.459 10.0193 124.237 10.3737Z'
      fill='#0A0A0A'
    />
    <path
      d='M95.9929 24.2089C96.3727 24.0086 96.8157 23.9007 97.3063 23.9007C98.05 23.9007 98.6829 24.178 99.2051 24.7173L100.06 23.9315C99.7273 23.5618 99.3159 23.269 98.8412 23.0688C98.3664 22.8685 97.8284 22.776 97.243 22.776C96.5309 22.776 95.8821 22.9301 95.2967 23.2382C94.7112 23.5464 94.2681 23.9624 93.9358 24.5016C93.6035 25.0408 93.4453 25.6571 93.4453 26.335C93.4453 27.0129 93.6035 27.6292 93.9358 28.1684C94.2681 28.7076 94.7112 29.139 95.2967 29.4317C95.8821 29.7399 96.5309 29.894 97.243 29.894C97.8284 29.894 98.3506 29.8015 98.8412 29.6012C99.3317 29.4009 99.7273 29.1236 100.06 28.7384L99.2051 27.9527C98.6829 28.4919 98.0658 28.7693 97.3063 28.7693C96.8157 28.7693 96.3885 28.6614 95.9929 28.4611C95.6131 28.2608 95.3125 27.9681 95.091 27.5983C94.8694 27.2286 94.7587 26.8126 94.7587 26.3504C94.7587 25.8882 94.8694 25.4722 95.091 25.1025C95.2967 24.7019 95.5973 24.4091 95.9929 24.2089Z'
      fill='#0A0A0A'
    />
    <path
      d='M111.326 23.2228C110.74 22.9147 110.091 22.7606 109.363 22.7606C108.636 22.7606 107.987 22.9147 107.401 23.2228C106.816 23.5309 106.357 23.9469 106.025 24.5016C105.692 25.0408 105.534 25.6571 105.534 26.3196C105.534 26.9974 105.692 27.5983 106.025 28.1375C106.357 28.6768 106.816 29.1082 107.401 29.4163C107.987 29.7244 108.636 29.8785 109.363 29.8785C110.091 29.8785 110.74 29.7244 111.326 29.4163C111.911 29.1082 112.37 28.6922 112.702 28.153C113.035 27.6137 113.193 26.9974 113.193 26.3196C113.193 25.6417 113.035 25.0254 112.702 24.4861C112.37 23.9623 111.911 23.5309 111.326 23.2228ZM111.547 27.5675C111.326 27.9373 111.025 28.23 110.661 28.4303C110.281 28.6306 109.854 28.7384 109.379 28.7384C108.905 28.7384 108.477 28.6306 108.098 28.4303C107.718 28.23 107.417 27.9373 107.211 27.5675C106.99 27.1977 106.879 26.7818 106.879 26.3196C106.879 25.8573 106.99 25.4414 107.211 25.0716C107.433 24.7018 107.718 24.4091 108.098 24.2088C108.477 24.0085 108.905 23.9007 109.379 23.9007C109.854 23.9007 110.281 24.0085 110.661 24.2088C111.041 24.4091 111.341 24.7018 111.547 25.0716C111.769 25.4414 111.879 25.8573 111.879 26.3196C111.864 26.7818 111.753 27.1977 111.547 27.5675Z'
      fill='#0A0A0A'
    />
    <path
      d='M125.377 22.8685L122.592 27.4443L119.775 22.8685H118.699V29.7861H119.95V25.2565L122.291 29.0004H122.877L125.203 25.1949L125.219 29.7861H126.469L126.453 22.8685H125.377Z'
      fill='#0A0A0A'
    />
    <path
      d='M150.567 28.7076H146.548V26.7972H149.982V25.7495H146.548V23.9469H150.425V22.8685H145.235V29.7861H150.567V28.7076Z'
      fill='#0A0A0A'
    />
    <path
      d='M157.371 27.7678H158.969C159.096 27.7678 159.175 27.7678 159.238 27.7524L160.694 29.7707H162.118L160.488 27.5059C160.979 27.321 161.343 27.0437 161.612 26.6585C161.865 26.2888 162.008 25.842 162.008 25.3181C162.008 24.8097 161.881 24.3783 161.644 24.0086C161.406 23.6388 161.042 23.3615 160.599 23.1612C160.14 22.9609 159.602 22.8685 158.985 22.8685H156.058V29.7861H157.371V27.7678ZM157.371 23.9469H158.906C159.476 23.9469 159.919 24.0702 160.219 24.3013C160.52 24.5324 160.663 24.8713 160.663 25.3181C160.663 25.7649 160.52 26.1039 160.219 26.335C159.919 26.5815 159.492 26.6893 158.906 26.6893H157.371V23.9469Z'
      fill='#0A0A0A'
    />
    <path
      d='M169.477 29.4163C170.063 29.7244 170.712 29.8785 171.424 29.8785C172.009 29.8785 172.531 29.786 173.022 29.5857C173.512 29.3854 173.908 29.1081 174.24 28.723L173.386 27.9372C172.864 28.4764 172.246 28.7538 171.487 28.7538C170.996 28.7538 170.569 28.6459 170.174 28.4456C169.794 28.2453 169.493 27.9526 169.272 27.5829C169.05 27.2131 168.939 26.7971 168.939 26.3349C168.939 25.8727 169.05 25.4567 169.272 25.087C169.493 24.7172 169.794 24.4245 170.174 24.2242C170.553 24.0239 170.996 23.916 171.487 23.916C172.231 23.916 172.864 24.1934 173.386 24.7326L174.24 23.9469C173.908 23.5771 173.497 23.2844 173.022 23.0841C172.547 22.8838 172.009 22.7914 171.424 22.7914C170.712 22.7914 170.063 22.9454 169.477 23.2536C168.892 23.5617 168.449 23.9777 168.117 24.5169C167.784 25.0561 167.626 25.6724 167.626 26.3503C167.626 27.0282 167.784 27.6445 168.117 28.1837C168.449 28.6921 168.892 29.1235 169.477 29.4163Z'
      fill='#0A0A0A'
    />
    <path
      d='M185.063 28.7075H181.059V26.7971H184.493V25.7494H181.059V23.9468H184.92V22.8683H179.73V29.786H185.063V28.7075Z'
      fill='#0A0A0A'
    />
    <defs>
      <linearGradient
        id='paint0_linear_1497_2098'
        x1='51.5219'
        y1='17.9922'
        x2='79.7588'
        y2='17.9922'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC' />
        <stop offset='0.47' stopColor='#383365' />
        <stop offset='1' stopColor='#0A0A0A' />
      </linearGradient>
    </defs>
  </svg>
);

export const Finished = (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <circle cx='20' cy='20' r='20' fill='#EEF6F3' />
    <path
      d='M20.8749 28.7587H12.992C12.0245 28.7587 11.2402 27.9745 11.2402 27.007V12.993C11.2402 12.0255 12.0245 11.2412 12.992 11.2412H25.2543C26.2217 11.2412 27.006 12.0255 27.006 12.993V16.4965'
      stroke='#1B875A'
      strokeWidth='1.5'
      strokeMiterlimit='16'
      strokeLinecap='round'
    />
    <path
      d='M22.6281 14.7446C22.6281 15.6738 22.259 16.5649 21.602 17.222C20.9449 17.879 20.0538 18.2481 19.1246 18.2481C18.1954 18.2481 17.3043 17.879 16.6472 17.222C15.9902 16.5649 15.6211 15.6738 15.6211 14.7446'
      stroke='#1B875A'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M20.623 23.0655C21.9029 21.9374 23.5504 21.3149 25.2564 21.3149C26.9625 21.3149 28.61 21.9374 29.8898 23.0655M22.1909 24.6202C23.0565 23.8992 24.1474 23.5044 25.2739 23.5044C26.4005 23.5044 27.4914 23.8992 28.357 24.6202M23.7368 26.1793C24.1814 25.8634 24.7132 25.6937 25.2586 25.6937C25.804 25.6937 26.3359 25.8634 26.7805 26.1793M25.2564 27.8829H25.2608'
      stroke='#1B875A'
      strokeWidth='1.4014'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const Error = (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <rect width='40' height='40' rx='20' fill='#FFEBEA' />
    <path
      d='M18.3633 10.7571L10.2565 24.8168C10.0894 25.1175 10.0009 25.4585 10 25.8057C9.99907 26.1529 10.0857 26.4944 10.2512 26.7961C10.4167 27.0977 10.6554 27.3491 10.9435 27.5252C11.2315 27.7013 11.559 27.796 11.8932 27.7998H28.1068C28.441 27.796 28.7685 27.7013 29.0565 27.5252C29.3446 27.3491 29.5833 27.0977 29.7488 26.7961C29.9143 26.4944 30.0009 26.1529 30 25.8057C29.9991 25.4585 29.9106 25.1175 29.7435 24.8168L21.6367 10.7571C21.466 10.4649 21.2258 10.2233 20.9391 10.0556C20.6524 9.88789 20.329 9.7998 20 9.7998C19.671 9.7998 19.3476 9.88789 19.0609 10.0556C18.7742 10.2233 18.534 10.4649 18.3633 10.7571Z'
      stroke='#FC372D'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M20 16.0409V19.2409'
      stroke='#FC372D'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M20 23.2979H20.0096'
      stroke='#FC372D'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
export const Warning = (
  <svg
    width='41'
    height='40'
    viewBox='0 0 41 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <circle cx='20.6665' cy='20' r='20' fill='#FFF1F0' />
    <path
      d='M28.1665 22.5V25.8333C28.1665 26.2754 27.9909 26.6993 27.6783 27.0118C27.3658 27.3244 26.9419 27.5 26.4998 27.5H14.8332C14.3911 27.5 13.9672 27.3244 13.6547 27.0118C13.3421 26.6993 13.1665 26.2754 13.1665 25.8333V22.5M24.8332 16.6667L20.6665 12.5M20.6665 12.5L16.4998 16.6667M20.6665 12.5V22.5'
      stroke='#F85E1B'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M14.3203 10.9932L29.5981 27.1459'
      stroke='#FFFAED'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M13.7476 12.1841L29.0253 28.3368'
      stroke='#F85E1B'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const Inactive = (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <circle cx='20' cy='20' r='20' fill='#F1F2F2' />
    <path
      d='M15.86 10H24.14L30 15.86V24.14L24.14 30H15.86L10 24.14V15.86L15.86 10Z'
      stroke='#1C2433'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M17 17L20 20M20 20L23 23M20 20L23 17M20 20L17 23'
      stroke='#1C2433'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const Delievered = (
  <svg
    width='41'
    height='40'
    viewBox='0 0 41 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <rect x='0.666504' width='40' height='40' rx='20' fill='#F5FAFF' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18.6665 8C18.1407 8 17.6242 8.13818 17.1686 8.40069L10.1704 12.3997L10.1704 12.3997L10.1665 12.4019C9.7965 12.6155 9.4774 12.9051 9.22954 13.2504C9.16921 13.3107 9.11567 13.3799 9.07092 13.4572C9.03237 13.5239 9.00237 13.5931 8.98057 13.6637C8.77485 14.0772 8.66698 14.5334 8.6665 14.9969V14.9979V22.998V22.999C8.66704 23.5251 8.80592 24.0418 9.0692 24.4972C9.33247 24.9527 9.7109 25.3309 10.1665 25.594L10.1704 25.5962L17.1665 29.594L17.1687 29.5953C17.4858 29.778 17.8325 29.9005 18.1912 29.958C18.3326 30.0345 18.4945 30.078 18.6665 30.078C18.8385 30.078 19.0004 30.0345 19.1418 29.958C19.5005 29.9004 19.8472 29.778 20.1643 29.5952L20.1665 29.594L22.7341 28.1268C22.2539 27.657 21.8513 27.1082 21.5473 26.5015L19.6665 27.5762V19.5848L26.6665 15.5355V17.7145C26.7715 17.7091 26.8771 17.7064 26.9834 17.7064C27.5673 17.7064 28.132 17.7888 28.6665 17.9425V14.9979V14.9969C28.666 14.5335 28.5582 14.0773 28.3525 13.6639C28.3307 13.5932 28.3007 13.5239 28.2621 13.4572C28.2173 13.3798 28.1638 13.3106 28.1034 13.2502C27.8555 12.9051 27.5365 12.6155 27.1665 12.4019L27.1626 12.3997L20.1665 8.40192L20.1644 8.40072C19.7089 8.1382 19.1923 8 18.6665 8ZM10.6665 22.9974V15.5355L17.6665 19.5847V27.5762L11.1665 23.8619L11.1649 23.861C11.0138 23.7734 10.8882 23.6476 10.8007 23.4963C10.713 23.3446 10.6668 23.1726 10.6665 22.9974ZM19.1704 10.1362L25.6275 13.826L18.6665 17.8527L11.7055 13.826L18.1626 10.1362L18.1626 10.1362L18.1665 10.134C18.3185 10.0462 18.491 10 18.6665 10C18.842 10 19.0145 10.0462 19.1665 10.134L19.1665 10.134L19.1704 10.1362Z'
      fill='#2E90FA'
    />
    <path
      d='M31.9839 23.3229V23.7829C31.9833 24.8611 31.6341 25.9102 30.9886 26.7738C30.343 27.6374 29.4355 28.2691 28.4016 28.5748C27.3676 28.8806 26.2625 28.8438 25.2511 28.4702C24.2397 28.0965 23.3762 27.4059 22.7894 26.5014C22.2025 25.5969 21.9238 24.5269 21.9947 23.451C22.0657 22.3752 22.4825 21.3511 23.183 20.5314C23.8836 19.7118 24.8303 19.1406 25.882 18.903C26.9337 18.6653 28.034 18.7741 29.0189 19.2129M31.9839 19.7829L26.9839 24.7879L25.4839 23.2879'
      stroke='#2E90FA'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const CAncelledNetutral = (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <rect width='40' height='40' rx='20' fill='#F1F2F2' />
    <path
      d='M20 30C25.5228 30 30 25.5228 30 20C30 14.4772 25.5228 10 20 10C14.4772 10 10 14.4772 10 20C10 25.5228 14.4772 30 20 30Z'
      stroke='#1C2433'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M23 17L17 23M17 17L23 23'
      stroke='#1C2433'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const NoCookies = (
  <svg
    width='170'
    height='170'
    viewBox='0 0 233 220'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M122.39 220C183.355 220 232.78 170.846 232.78 110C232.78 49.1535 183.137 0 122.39 0C61.4251 0 12 49.1535 12 110C12 170.846 61.4251 220 122.39 220Z'
      fill='#F0F2FA'
    />
    <path
      d='M216.636 174.301C220.801 174.301 224.177 170.924 224.177 166.759C224.177 162.594 220.801 159.217 216.636 159.217C212.47 159.217 209.094 162.594 209.094 166.759C209.094 170.924 212.47 174.301 216.636 174.301Z'
      fill='white'
    />
    <path
      d='M197.672 19.8694C200.517 19.8694 202.822 17.5634 202.822 14.7189C202.822 11.8743 200.517 9.56836 197.672 9.56836C194.827 9.56836 192.521 11.8743 192.521 14.7189C192.521 17.5634 194.827 19.8694 197.672 19.8694Z'
      fill='#2764FF'
    />
    <path
      d='M17.8906 183.215C20.3759 183.215 22.3906 181.201 22.3906 178.715C22.3906 176.23 20.3759 174.215 17.8906 174.215C15.4053 174.215 13.3906 176.23 13.3906 178.715C13.3906 181.201 15.4053 183.215 17.8906 183.215Z'
      fill='#2764FF'
    />
    <circle cx='122.5' cy='109.5' r='86.5' fill='white' />
    <path
      d='M5.1505 79.1169C7.99504 79.1169 10.301 76.811 10.301 73.9664C10.301 71.1219 7.99504 68.8159 5.1505 68.8159C2.30596 68.8159 0 71.1219 0 73.9664C0 76.811 2.30596 79.1169 5.1505 79.1169Z'
      fill='white'
    />
    <path
      d='M156.122 55.3644L156.857 44.9712'
      stroke='url(#paint0_linear_2339_29302)'
      strokeWidth='8.03162'
      strokeLinecap='round'
    />
    <path
      d='M170.947 61.3189L184.91 44.3252'
      stroke='url(#paint1_linear_2339_29302)'
      strokeWidth='8.03162'
      strokeLinecap='round'
    />
    <path
      d='M179.087 73.3363L198.575 63.1396'
      stroke='url(#paint2_linear_2339_29302)'
      strokeWidth='8.03162'
      strokeLinecap='round'
    />
    <g filter='url(#filter0_i_2339_29302)'>
      <path
        d='M64 110.351C63.9971 101.383 66.0281 92.5311 69.94 84.4617C73.852 76.3924 79.543 69.316 86.5844 63.7656C93.6259 58.2151 101.834 54.3352 110.592 52.4179C119.349 50.5007 128.427 50.5961 137.142 52.6969C137.789 52.8504 138.382 53.1752 138.86 53.6371C139.338 54.0989 139.683 54.6809 139.859 55.3221C140.035 55.9632 140.035 56.6398 139.859 57.281C139.684 57.9222 139.339 58.5043 138.861 58.9663C136.948 60.8285 135.573 63.1729 134.882 65.752C134.19 68.331 134.208 71.049 134.932 73.619C135.657 76.189 137.061 78.5156 138.998 80.3531C140.935 82.1906 143.331 83.4708 145.935 84.0586C146.858 84.2656 147.682 84.7805 148.273 85.5185C148.864 86.2566 149.186 87.1739 149.187 88.1196C149.186 91.1334 150.104 94.0757 151.817 96.5544C153.531 99.033 155.959 100.93 158.778 101.993C161.597 103.056 164.673 103.233 167.596 102.502C170.518 101.771 173.148 100.166 175.136 97.9017C175.595 97.3775 176.192 96.9935 176.86 96.7937C177.527 96.5939 178.237 96.5864 178.909 96.7721C179.58 96.9578 180.186 97.3292 180.655 97.8436C181.125 98.358 181.441 98.9946 181.566 99.6802C183.037 107.779 182.807 116.095 180.889 124.1C178.972 132.105 175.409 139.622 170.428 146.174C165.447 152.725 159.157 158.167 151.958 162.153C144.759 166.139 136.81 168.582 128.615 169.326C120.421 170.07 112.162 169.098 104.363 166.473C96.565 163.849 89.3985 159.628 83.3201 154.08C77.2417 148.533 72.3847 141.779 69.0584 134.251C65.7321 126.722 64.0094 118.583 64 110.351ZM101.038 95.5303C101.038 93.5648 100.257 91.6799 98.8682 90.2902C97.479 88.9004 95.5949 88.1196 93.6303 88.1196C91.6657 88.1196 89.7815 88.9004 88.3924 90.2902C87.0032 91.6799 86.2227 93.5648 86.2227 95.5303C86.2227 97.4957 87.0032 99.3806 88.3924 100.77C89.7815 102.16 91.6657 102.941 93.6303 102.941C95.5949 102.941 97.479 102.16 98.8682 100.77C100.257 99.3806 101.038 97.4957 101.038 95.5303ZM123.261 117.762C125.225 117.762 127.109 116.981 128.499 115.592C129.888 114.202 130.668 112.317 130.668 110.351C130.668 108.386 129.888 106.501 128.499 105.111C127.109 103.722 125.225 102.941 123.261 102.941C121.296 102.941 119.412 103.722 118.023 105.111C116.633 106.501 115.853 108.386 115.853 110.351C115.853 112.317 116.633 114.202 118.023 115.592C119.412 116.981 121.296 117.762 123.261 117.762ZM145.483 139.994C145.483 138.029 144.703 136.144 143.314 134.754C141.924 133.364 140.04 132.583 138.076 132.583C136.111 132.583 134.227 133.364 132.838 134.754C131.449 136.144 130.668 138.029 130.668 139.994C130.668 141.959 131.449 143.844 132.838 145.234C134.227 146.624 136.111 147.405 138.076 147.405C140.04 147.405 141.924 146.624 143.314 145.234C144.703 143.844 145.483 141.959 145.483 139.994ZM101.038 139.994C103.002 139.994 104.887 139.213 106.276 137.823C107.665 136.434 108.445 134.549 108.445 132.583C108.445 130.618 107.665 128.733 106.276 127.343C104.887 125.953 103.002 125.173 101.038 125.173C99.0733 125.173 97.1891 125.953 95.7999 127.343C94.4107 128.733 93.6303 130.618 93.6303 132.583C93.6303 134.549 94.4107 136.434 95.7999 137.823C97.1891 139.213 99.0733 139.994 101.038 139.994Z'
        fill='url(#paint3_linear_2339_29302)'
      />
    </g>
    <g filter='url(#filter1_i_2339_29302)'>
      <circle cx='39.5' cy='27.5' r='27.5' fill='#D92D20' />
    </g>
    <path
      d='M35.5771 11.7881H43.3121L41.2494 33.274H37.6398L35.5771 11.7881Z'
      fill='white'
    />
    <ellipse cx='39.4446' cy='40.1492' rx='3.86746' ry='3.43774' fill='white' />
    <defs>
      <filter
        id='filter0_i_2339_29302'
        x='64'
        y='38.0474'
        width='148.521'
        height='131.521'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='30' dy='-13' />
        <feGaussianBlur stdDeviation='15' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_2339_29302'
        />
      </filter>
      <filter
        id='filter1_i_2339_29302'
        x='12'
        y='-5'
        width='60'
        height='60'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='8' dy='-7' />
        <feGaussianBlur stdDeviation='2.5' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.596078 0 0 0 0 0.121569 0 0 0 0 0.0862745 0 0 0 0.28 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_2339_29302'
        />
      </filter>
      <linearGradient
        id='paint0_linear_2339_29302'
        x1='159.14'
        y1='46.7318'
        x2='153.839'
        y2='53.6038'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_2339_29302'
        x1='186.758'
        y1='49.888'
        x2='169.098'
        y2='55.7561'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_2339_29302'
        x1='198.106'
        y1='68.9827'
        x2='179.556'
        y2='67.4933'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_2339_29302'
        x1='123.261'
        y1='51.0474'
        x2='180.052'
        y2='169.568'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#413BBC' />
        <stop offset='1' stopColor='#A9A6E2' />
      </linearGradient>
    </defs>
  </svg>
);

export const customMagentoLogo = (
  <svg
    width='25'
    height='25'
    viewBox='0 0 36 42'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M20.1258 12.5979V36.5224L17.7732 37.9602L15.4193 36.5141V12.6163L9.3228 16.3699V36.8297L17.7732 42L26.2954 36.7929V16.357L20.1258 12.5979ZM17.7732 0L0 10.768V31.2311L4.61585 33.9503V13.4859L17.7769 5.48316L30.9499 13.4739L31.0042 13.5043L30.9978 33.9186L35.569 31.2297V10.768L17.7732 0Z'
      fill='#F37B20'
    />
    <path
      d='M35.569 10.768L17.7732 0L0 10.768L4.61585 13.4859L17.7769 5.48316L31.0042 13.5043L35.569 10.768ZM20.1258 12.5979V20.1414L26.2954 16.357L20.1258 12.5979ZM9.32234 16.3712L15.4175 20.094V12.6162L9.32234 16.3712Z'
      fill='#FAB37C'
    />
  </svg>
);

export const ComingSoonIcon = () => (
  <svg
    width='253'
    height='223'
    viewBox='0 0 253 223'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M122.999 223C183.964 223 233.39 173.846 233.39 113C233.39 52.1535 183.747 3 122.999 3C62.0345 3 12.6094 52.1535 12.6094 113C12.6094 173.846 62.0345 223 122.999 223Z'
      fill='#F3F3F3'
    />
    <path
      d='M77.0156 75.1471L122.606 24.1763L168.763 75.1471'
      stroke='#BDC8D6'
      strokeWidth='5.66343'
    />
    <rect
      x='23.7777'
      y='68.1683'
      width='198.663'
      height='121.663'
      rx='12.8317'
      fill='white'
      stroke='#2764FF'
      strokeWidth='5.66343'
    />
    <path
      d='M209.609 71C215.132 71 219.609 75.4772 219.609 81V177C219.609 182.523 215.132 187 209.609 187V71Z'
      fill='#F3F3F3'
      fillOpacity='0.8'
    />
    <path
      d='M36.6094 71C31.0865 71 26.6094 75.4772 26.6094 81V177C26.6094 182.523 31.0865 187 36.6094 187V71Z'
      fill='#F3F3F3'
    />
    <path
      d='M77.4077 107.221H71.6392C71.5623 106.628 71.4046 106.094 71.1661 105.617C70.9277 105.14 70.6124 104.733 70.2201 104.394C69.8279 104.056 69.3625 103.798 68.8241 103.621C68.2934 103.437 67.705 103.344 67.059 103.344C65.913 103.344 64.9246 103.625 64.0939 104.186C63.271 104.748 62.6364 105.559 62.1903 106.621C61.7519 107.682 61.5327 108.967 61.5327 110.474C61.5327 112.043 61.7558 113.358 62.2019 114.42C62.6557 115.474 63.2902 116.27 64.1055 116.808C64.9285 117.339 65.9014 117.604 67.0244 117.604C67.655 117.604 68.2281 117.523 68.7434 117.362C69.2664 117.2 69.724 116.966 70.1163 116.658C70.5162 116.343 70.8431 115.962 71.0969 115.516C71.3584 115.062 71.5392 114.551 71.6392 113.981L77.4077 114.016C77.3077 115.062 77.0039 116.093 76.4963 117.108C75.9963 118.123 75.3079 119.05 74.4311 119.888C73.5543 120.719 72.4852 121.381 71.2238 121.873C69.9701 122.365 68.5319 122.611 66.909 122.611C64.7708 122.611 62.8556 122.142 61.1635 121.204C59.4791 120.258 58.1485 118.881 57.1717 117.073C56.1949 115.266 55.7065 113.066 55.7065 110.474C55.7065 107.874 56.2026 105.671 57.1948 103.863C58.187 102.056 59.5291 100.683 61.2212 99.7447C62.9133 98.8064 64.8092 98.3372 66.909 98.3372C68.3396 98.3372 69.6625 98.5372 70.8777 98.9371C72.093 99.3294 73.1621 99.9062 74.085 100.668C75.008 101.421 75.7579 102.348 76.3347 103.448C76.9116 104.548 77.2692 105.805 77.4077 107.221ZM102.977 110.474C102.977 113.074 102.477 115.277 101.477 117.085C100.477 118.892 99.1233 120.265 97.4158 121.204C95.716 122.142 93.8086 122.611 91.6934 122.611C89.5706 122.611 87.6593 122.138 85.9595 121.192C84.2597 120.246 82.9099 118.873 81.91 117.073C80.9178 115.266 80.4217 113.066 80.4217 110.474C80.4217 107.874 80.9178 105.671 81.91 103.863C82.9099 102.056 84.2597 100.683 85.9595 99.7447C87.6593 98.8064 89.5706 98.3372 91.6934 98.3372C93.8086 98.3372 95.716 98.8064 97.4158 99.7447C99.1233 100.683 100.477 102.056 101.477 103.863C102.477 105.671 102.977 107.874 102.977 110.474ZM97.1389 110.474C97.1389 108.936 96.9197 107.636 96.4813 106.575C96.0506 105.513 95.4276 104.709 94.6123 104.163C93.8047 103.617 92.8318 103.344 91.6934 103.344C90.5628 103.344 89.5898 103.617 88.7746 104.163C87.9593 104.709 87.3324 105.513 86.894 106.575C86.4633 107.636 86.2479 108.936 86.2479 110.474C86.2479 112.012 86.4633 113.312 86.894 114.374C87.3324 115.435 87.9593 116.239 88.7746 116.785C89.5898 117.331 90.5628 117.604 91.6934 117.604C92.8318 117.604 93.8047 117.331 94.6123 116.785C95.4276 116.239 96.0506 115.435 96.4813 114.374C96.9197 113.312 97.1389 112.012 97.1389 110.474ZM106.311 98.6602H113.383L119.382 113.289H119.659L125.658 98.6602H132.731V122.288H127.17V107.774H126.974L121.297 122.138H117.744L112.068 107.694H111.872V122.288H106.311V98.6602ZM142.004 98.6602V122.288H136.293V98.6602H142.004ZM165.698 98.6602V122.288H160.852L151.45 108.651H151.3V122.288H145.589V98.6602H150.503L159.802 112.274H159.998V98.6602H165.698ZM184.794 106.379C184.664 105.894 184.471 105.467 184.218 105.098C183.964 104.721 183.652 104.402 183.283 104.14C182.914 103.879 182.491 103.683 182.014 103.552C181.537 103.413 181.014 103.344 180.445 103.344C179.299 103.344 178.307 103.621 177.468 104.175C176.638 104.729 175.996 105.536 175.542 106.598C175.088 107.651 174.861 108.932 174.861 110.44C174.861 111.955 175.08 113.247 175.519 114.316C175.957 115.385 176.592 116.2 177.422 116.762C178.253 117.323 179.261 117.604 180.445 117.604C181.491 117.604 182.376 117.435 183.099 117.096C183.829 116.75 184.383 116.262 184.76 115.631C185.137 115.001 185.325 114.258 185.325 113.405L186.387 113.531H180.641V109.367H190.828V112.493C190.828 114.608 190.378 116.42 189.479 117.927C188.586 119.435 187.356 120.592 185.787 121.4C184.225 122.207 182.429 122.611 180.399 122.611C178.145 122.611 176.165 122.123 174.457 121.146C172.75 120.169 171.419 118.777 170.465 116.97C169.512 115.154 169.035 113.001 169.035 110.509C169.035 108.571 169.323 106.852 169.9 105.352C170.477 103.844 171.281 102.567 172.311 101.521C173.35 100.475 174.55 99.6832 175.911 99.1448C177.28 98.6064 178.753 98.3372 180.33 98.3372C181.699 98.3372 182.972 98.5333 184.148 98.9256C185.333 99.3178 186.379 99.8716 187.286 100.587C188.202 101.302 188.944 102.152 189.513 103.137C190.082 104.121 190.436 105.202 190.575 106.379H184.794Z'
      fill='#FC6973'
    />
    <path
      d='M89.7023 142.496C89.6254 141.65 89.2832 140.993 88.6755 140.524C88.0756 140.047 87.218 139.808 86.1028 139.808C85.3644 139.808 84.7491 139.904 84.2569 140.097C83.7646 140.289 83.3954 140.554 83.1493 140.893C82.9032 141.223 82.7763 141.604 82.7686 142.035C82.7532 142.389 82.8224 142.7 82.9762 142.969C83.1378 143.239 83.3685 143.477 83.6685 143.685C83.9761 143.885 84.3453 144.062 84.776 144.215C85.2067 144.369 85.6913 144.504 86.2297 144.619L88.2602 145.081C89.4293 145.335 90.4599 145.673 91.3521 146.096C92.252 146.519 93.0058 147.023 93.6134 147.607C94.2287 148.192 94.694 148.865 95.0094 149.626C95.3247 150.388 95.4862 151.241 95.4939 152.188C95.4862 153.68 95.1094 154.96 94.3633 156.029C93.6172 157.098 92.5443 157.918 91.1445 158.487C89.7523 159.056 88.0718 159.34 86.1028 159.34C84.1261 159.34 82.4032 159.044 80.9342 158.452C79.4651 157.86 78.323 156.96 77.5077 155.752C76.6924 154.545 76.2732 153.018 76.2501 151.172H81.7187C81.7649 151.934 81.9687 152.568 82.3302 153.076C82.6917 153.584 83.1878 153.968 83.8184 154.23C84.4568 154.491 85.1952 154.622 86.0336 154.622C86.8027 154.622 87.4565 154.518 87.9949 154.31C88.5409 154.103 88.9601 153.814 89.2524 153.445C89.5447 153.076 89.6946 152.653 89.7023 152.176C89.6946 151.73 89.5562 151.349 89.287 151.034C89.0178 150.711 88.6025 150.434 88.041 150.203C87.4872 149.965 86.7796 149.746 85.9182 149.546L83.4493 148.969C81.4034 148.5 79.792 147.742 78.6152 146.696C77.4385 145.642 76.8539 144.219 76.8616 142.427C76.8539 140.966 77.2462 139.685 78.0384 138.585C78.8306 137.485 79.9266 136.628 81.3264 136.013C82.7263 135.397 84.3222 135.09 86.1143 135.09C87.9449 135.09 89.5331 135.401 90.8791 136.024C92.2328 136.639 93.2827 137.505 94.0287 138.62C94.7748 139.735 95.1555 141.027 95.1709 142.496H89.7023ZM120.679 147.227C120.679 149.826 120.179 152.03 119.179 153.837C118.18 155.645 116.826 157.018 115.118 157.956C113.419 158.894 111.511 159.364 109.396 159.364C107.273 159.364 105.362 158.891 103.662 157.945C101.962 156.998 100.613 155.626 99.6127 153.826C98.6205 152.018 98.1244 149.819 98.1244 147.227C98.1244 144.627 98.6205 142.423 99.6127 140.616C100.613 138.808 101.962 137.435 103.662 136.497C105.362 135.559 107.273 135.09 109.396 135.09C111.511 135.09 113.419 135.559 115.118 136.497C116.826 137.435 118.18 138.808 119.179 140.616C120.179 142.423 120.679 144.627 120.679 147.227ZM114.842 147.227C114.842 145.688 114.622 144.388 114.184 143.327C113.753 142.266 113.13 141.462 112.315 140.916C111.507 140.37 110.534 140.097 109.396 140.097C108.265 140.097 107.292 140.37 106.477 140.916C105.662 141.462 105.035 142.266 104.597 143.327C104.166 144.388 103.951 145.688 103.951 147.227C103.951 148.765 104.166 150.065 104.597 151.126C105.035 152.188 105.662 152.991 106.477 153.537C107.292 154.083 108.265 154.356 109.396 154.356C110.534 154.356 111.507 154.083 112.315 153.537C113.13 152.991 113.753 152.188 114.184 151.126C114.622 150.065 114.842 148.765 114.842 147.227ZM146.315 147.227C146.315 149.826 145.815 152.03 144.815 153.837C143.815 155.645 142.461 157.018 140.754 157.956C139.054 158.894 137.146 159.364 135.031 159.364C132.909 159.364 130.997 158.891 129.297 157.945C127.598 156.998 126.248 155.626 125.248 153.826C124.256 152.018 123.76 149.819 123.76 147.227C123.76 144.627 124.256 142.423 125.248 140.616C126.248 138.808 127.598 137.435 129.297 136.497C130.997 135.559 132.909 135.09 135.031 135.09C137.146 135.09 139.054 135.559 140.754 136.497C142.461 137.435 143.815 138.808 144.815 140.616C145.815 142.423 146.315 144.627 146.315 147.227ZM140.477 147.227C140.477 145.688 140.258 144.388 139.819 143.327C139.389 142.266 138.766 141.462 137.95 140.916C137.143 140.37 136.17 140.097 135.031 140.097C133.901 140.097 132.928 140.37 132.113 140.916C131.297 141.462 130.67 142.266 130.232 143.327C129.801 144.388 129.586 145.688 129.586 147.227C129.586 148.765 129.801 150.065 130.232 151.126C130.67 152.188 131.297 152.991 132.113 153.537C132.928 154.083 133.901 154.356 135.031 154.356C136.17 154.356 137.143 154.083 137.95 153.537C138.766 152.991 139.389 152.188 139.819 151.126C140.258 150.065 140.477 148.765 140.477 147.227ZM169.758 135.413V159.041H164.912L155.51 145.404H155.36V159.041H149.649V135.413H154.564L163.862 149.026H164.059V135.413H169.758Z'
      fill='#FC6973'
    />
    <circle
      cx='122.606'
      cy='24.1764'
      r='9.34466'
      fill='white'
      stroke='#2764FF'
      strokeWidth='5.66343'
    />
    <circle
      cx='36.6094'
      cy='81'
      r='3.5'
      fill='white'
      stroke='#BDC8D6'
      strokeWidth='3'
    />
    <circle
      cx='209.609'
      cy='81'
      r='3.5'
      fill='white'
      stroke='#BDC8D6'
      strokeWidth='3'
    />
    <circle
      cx='36.6094'
      cy='177'
      r='3.5'
      fill='white'
      stroke='#BDC8D6'
      strokeWidth='3'
    />
    <circle
      cx='209.609'
      cy='177'
      r='3.5'
      fill='white'
      stroke='#BDC8D6'
      strokeWidth='3'
    />
    <path
      d='M245.245 145.301C249.41 145.301 252.787 141.924 252.787 137.759C252.787 133.594 249.41 130.217 245.245 130.217C241.08 130.217 237.703 133.594 237.703 137.759C237.703 141.924 241.08 145.301 245.245 145.301Z'
      fill='white'
    />
    <path
      d='M176.283 10.8694C179.128 10.8694 181.434 8.5634 181.434 5.71886C181.434 2.87432 179.128 0.568359 176.283 0.568359C173.439 0.568359 171.133 2.87432 171.133 5.71886C171.133 8.5634 173.439 10.8694 176.283 10.8694Z'
      fill='#2764FF'
    />
    <path
      d='M5.75987 82.1164C8.60442 82.1164 10.9104 79.8105 10.9104 76.9659C10.9104 74.1214 8.60442 71.8154 5.75987 71.8154C2.91533 71.8154 0.609375 74.1214 0.609375 76.9659C0.609375 79.8105 2.91533 82.1164 5.75987 82.1164Z'
      fill='white'
    />
    <path
      d='M58.3074 221.448C63.5901 221.448 67.8726 217.165 67.8726 211.883C67.8726 206.6 63.5901 202.317 58.3074 202.317C53.0247 202.317 48.7422 206.6 48.7422 211.883C48.7422 217.165 53.0247 221.448 58.3074 221.448Z'
      fill='#2764FF'
    />
  </svg>
);

export const LikedAnnouncement = (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M9.33165 6.00006V3.33352C9.33165 2.80312 9.12095 2.29443 8.7459 1.91938C8.37084 1.54432 7.86216 1.33362 7.33175 1.33362L4.66521 7.33334V14.6663H12.1849C12.5064 14.67 12.8184 14.5573 13.0634 14.349C13.3084 14.1408 13.4699 13.851 13.5181 13.533L14.4381 7.53333C14.4671 7.34224 14.4542 7.14713 14.4003 6.96152C14.3464 6.77591 14.2528 6.60423 14.126 6.45839C13.9992 6.31254 13.8422 6.19601 13.6658 6.11687C13.4895 6.03773 13.2981 5.99788 13.1048 6.00006H9.33165ZM4.66521 14.6663H2.6653C2.3117 14.6663 1.97257 14.5259 1.72254 14.2758C1.4725 14.0258 1.33203 13.6867 1.33203 13.3331V8.66661C1.33203 8.313 1.4725 7.97388 1.72254 7.72384C1.97257 7.4738 2.3117 7.33334 2.6653 7.33334H4.66521'
      fill='#BBADE7'
    />
    <path
      d='M4.66521 14.6663H2.6653C2.3117 14.6663 1.97257 14.5259 1.72254 14.2758C1.4725 14.0258 1.33203 13.6867 1.33203 13.3331V8.66661C1.33203 8.313 1.4725 7.97388 1.72254 7.72384C1.97257 7.47381 2.3117 7.33334 2.6653 7.33334H4.66521M9.33165 6.00007V3.33352C9.33165 2.80312 9.12095 2.29443 8.7459 1.91938C8.37084 1.54432 7.86216 1.33362 7.33175 1.33362L4.66521 7.33334V14.6663H12.1849C12.5064 14.67 12.8184 14.5573 13.0634 14.349C13.3084 14.1408 13.4699 13.851 13.5181 13.533L14.4381 7.53333C14.4671 7.34224 14.4542 7.14713 14.4003 6.96152C14.3464 6.77591 14.2528 6.60423 14.126 6.45839C13.9992 6.31254 13.8422 6.19601 13.6658 6.11687C13.4895 6.03773 13.2981 5.99788 13.1048 6.00007H9.33165Z'
      stroke='#413BBC'
      strokeWidth='1.33327'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const DislikedAnnouncement = (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M6.66835 9.99994L6.66835 12.6665C6.66835 13.1969 6.87905 13.7056 7.2541 14.0806C7.62916 14.4557 8.13784 14.6664 8.66825 14.6664L11.3348 8.66666L11.3348 1.33368L3.81515 1.33368C3.49361 1.33004 3.18159 1.44273 2.93658 1.65099C2.69158 1.85925 2.53009 2.14903 2.48188 2.46696L1.56192 8.46667C1.53292 8.65776 1.5458 8.85287 1.59969 9.03848C1.65358 9.22409 1.74718 9.39577 1.874 9.54161C2.00082 9.68746 2.15784 9.80399 2.33417 9.88313C2.5105 9.96227 2.70193 10.0021 2.89519 9.99994L6.66835 9.99994ZM11.3348 1.33368H13.3347C13.6883 1.33368 14.0274 1.47415 14.2775 1.72418C14.5275 1.97422 14.668 2.31334 14.668 2.66695V7.33339C14.668 7.687 14.5275 8.02612 14.2775 8.27616C14.0274 8.5262 13.6883 8.66666 13.3347 8.66666H11.3348'
      fill='#A9ACB2'
    />
    <path
      d='M11.3348 1.33368H13.3347C13.6883 1.33368 14.0274 1.47415 14.2775 1.72418C14.5275 1.97422 14.668 2.31334 14.668 2.66695V7.33339C14.668 7.687 14.5275 8.02612 14.2775 8.27616C14.0274 8.52619 13.6883 8.66666 13.3347 8.66666H11.3348M6.66835 9.99993L6.66835 12.6665C6.66835 13.1969 6.87905 13.7056 7.2541 14.0806C7.62916 14.4557 8.13784 14.6664 8.66825 14.6664L11.3348 8.66666L11.3348 1.33368L3.81515 1.33368C3.49361 1.33004 3.18159 1.44273 2.93658 1.65099C2.69158 1.85925 2.53009 2.14903 2.48188 2.46696L1.56192 8.46667C1.53292 8.65776 1.5458 8.85287 1.59969 9.03848C1.65358 9.22409 1.74718 9.39577 1.874 9.54161C2.00082 9.68746 2.15784 9.80399 2.33417 9.88313C2.5105 9.96227 2.70193 10.0021 2.89519 9.99993L6.66835 9.99993Z'
      stroke='#4E4F52'
      strokeWidth='1.33327'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

// Promotion svg
export const PromotionalDiscountBanner = (
  <svg
    width='210'
    height='150'
    viewBox='0 0 210 150'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <rect
      x='0.337109'
      y='0.3'
      width='209.338'
      height='149.4'
      rx='3.7'
      fill='#8E76D7'
      stroke='#8E76D7'
      strokeWidth='0.6'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M183.537 32.7681C183.531 32.7681 183.526 32.7667 183.52 32.7639C183.474 32.7598 183.437 32.718 183.432 32.668L182.961 24.7572L176.848 29.8057C176.811 29.8349 176.757 29.8391 176.719 29.8099C176.681 29.7765 176.669 29.7264 176.686 29.6806L179.944 22.4582L172.188 24.0854C172.138 24.0979 172.092 24.0729 172.071 24.027C172.05 23.9853 172.063 23.931 172.1 23.9018L178.342 19.016L170.719 16.8547C170.669 16.8422 170.64 16.7963 170.64 16.7504C170.644 16.7003 170.677 16.6628 170.728 16.6503L178.521 15.2275L172.776 9.77002C172.743 9.73664 172.734 9.6824 172.759 9.64068C172.784 9.59895 172.835 9.57809 172.88 9.59478L180.445 11.9563L177.891 4.45443C177.875 4.40853 177.896 4.35429 177.937 4.32925C177.975 4.30422 178.029 4.31256 178.067 4.34594L183.666 9.9536L184.893 2.12207C184.901 2.07618 184.939 2.03863 184.989 2.03445C185.039 2.03028 185.08 2.05949 185.097 2.10538L187.45 9.67406L192.173 3.3112C192.203 3.27365 192.257 3.26113 192.299 3.27782C192.345 3.29868 192.37 3.34458 192.361 3.39464L190.93 11.1886L198.069 7.75059C198.115 7.72973 198.165 7.74225 198.198 7.7798C198.228 7.81735 198.228 7.87159 198.198 7.90914L193.304 14.1427L201.228 14.418C201.278 14.4222 201.315 14.4556 201.328 14.5015C201.336 14.5516 201.311 14.5974 201.265 14.6183L194.039 17.8686L200.923 21.7906C200.965 21.8156 200.986 21.8657 200.973 21.9116C200.956 21.9575 200.915 21.9867 200.865 21.9867L192.954 21.5027L197.23 28.1785C197.255 28.2202 197.251 28.2703 197.218 28.3078C197.18 28.3412 197.13 28.3496 197.089 28.3245L190.308 24.2189L190.989 32.1172C190.993 32.1631 190.963 32.209 190.918 32.2257C190.872 32.2382 190.822 32.2215 190.797 32.1798L186.699 25.3955L183.633 32.7013C183.616 32.7431 183.578 32.7681 183.537 32.7681ZM183.053 24.4442C183.067 24.4442 183.08 24.447 183.094 24.4526C183.128 24.4651 183.153 24.5026 183.157 24.5402L183.616 32.209L186.587 25.1243C186.599 25.0868 186.637 25.0617 186.674 25.0617C186.712 25.0576 186.749 25.0784 186.77 25.1118L190.742 31.6875L190.079 24.0312C190.079 23.9936 190.096 23.9561 190.129 23.9352C190.162 23.9143 190.204 23.9143 190.237 23.9352L196.813 27.9115L192.67 21.4443C192.649 21.4109 192.645 21.3692 192.666 21.3358C192.687 21.2983 192.724 21.2816 192.762 21.2816L200.431 21.7489L193.755 17.9479C193.721 17.927 193.701 17.8894 193.705 17.8519C193.705 17.8102 193.73 17.7768 193.763 17.7601L200.773 14.61L193.096 14.3471C193.054 14.3429 193.02 14.3221 193.004 14.2845C192.987 14.2511 192.991 14.2094 193.016 14.176L197.756 8.13028L190.834 11.464C190.801 11.4807 190.759 11.4765 190.726 11.4557C190.696 11.4306 190.68 11.3931 190.688 11.3513L192.073 3.79519L187.496 9.96612C187.471 9.99533 187.434 10.012 187.392 10.0037C187.354 9.9995 187.325 9.97029 187.313 9.93274L185.03 2.59772L183.841 10.1873C183.833 10.2248 183.808 10.2582 183.77 10.2707C183.733 10.2832 183.691 10.2749 183.662 10.2457L178.234 4.80908L180.708 12.0815C180.72 12.1191 180.712 12.1608 180.683 12.19C180.658 12.2192 180.616 12.2275 180.578 12.215L173.243 9.92857L178.818 15.2191C178.843 15.2442 178.855 15.2859 178.843 15.3234C178.834 15.361 178.801 15.3902 178.763 15.3944L171.207 16.7754L178.597 18.87C178.634 18.8825 178.663 18.9117 178.672 18.9534C178.68 18.9909 178.663 19.0285 178.634 19.0535L172.584 23.7892L180.103 22.2078C180.14 22.2037 180.178 22.2162 180.203 22.2454C180.228 22.2788 180.232 22.3205 180.22 22.3539L177.061 29.3593L182.986 24.4651C183.003 24.4526 183.028 24.4442 183.053 24.4442Z'
      fill='#F0EDFA'
    />
    <path
      d='M209.962 46.7681C200.583 46.1631 190.327 43.3342 179.483 38.3607C170.809 34.3845 161.738 29.0355 152.525 22.4599C144.327 16.6144 137.534 10.8565 133.274 7.05964C128.664 2.94569 125.952 0.175239 125.927 0.146033L126.073 0C126.102 0.0292066 128.81 2.79549 133.416 6.90527C137.672 10.7021 144.46 16.4516 152.651 22.293C167.108 32.6112 188.787 45.1951 209.975 46.5594L209.962 46.7681Z'
      fill='#F0EDFA'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M32.7681 123.467C32.7681 123.462 32.7667 123.456 32.7639 123.451C32.7598 123.405 32.718 123.367 32.668 123.363L24.7572 122.891L29.8057 116.779C29.8349 116.741 29.8391 116.687 29.8099 116.65C29.7765 116.612 29.7264 116.6 29.6806 116.616L22.4582 119.875L24.0854 112.118C24.0979 112.068 24.0729 112.022 24.027 112.002C23.9853 111.981 23.931 111.993 23.9018 112.031L19.016 118.273L16.8547 110.65C16.8422 110.6 16.7963 110.57 16.7504 110.57C16.7003 110.575 16.6628 110.608 16.6503 110.658L15.2275 118.452L9.77002 112.707C9.73664 112.673 9.6824 112.665 9.64068 112.69C9.59895 112.715 9.57809 112.765 9.59478 112.811L11.9563 120.376L4.45443 117.822C4.40853 117.805 4.35429 117.826 4.32925 117.868C4.30422 117.906 4.31256 117.96 4.34594 117.997L9.9536 123.597L2.12207 124.823C2.07618 124.832 2.03862 124.869 2.03445 124.919C2.03028 124.969 2.05949 125.011 2.10538 125.028L9.67405 127.381L3.3112 132.104C3.27364 132.133 3.26113 132.188 3.27782 132.229C3.29868 132.275 3.34457 132.3 3.39464 132.292L11.1886 130.861L7.75059 138C7.72973 138.046 7.74225 138.096 7.7798 138.129C7.81735 138.158 7.87159 138.158 7.90914 138.129L14.1427 133.235L14.418 141.158C14.4222 141.208 14.4556 141.246 14.5015 141.258C14.5516 141.267 14.5974 141.242 14.6183 141.196L17.8686 133.969L21.7906 140.854C21.8156 140.895 21.8657 140.916 21.9116 140.904C21.9575 140.887 21.9867 140.845 21.9867 140.795L21.5027 132.884L28.1785 137.161C28.2202 137.186 28.2703 137.182 28.3078 137.148C28.3412 137.111 28.3496 137.061 28.3245 137.019L24.2189 130.239L32.1172 130.919C32.1631 130.923 32.209 130.894 32.2257 130.848C32.2382 130.802 32.2215 130.752 32.1798 130.727L25.3955 126.63L32.7013 123.563C32.7431 123.547 32.7681 123.509 32.7681 123.467ZM24.4442 122.983C24.4442 122.997 24.447 123.011 24.4526 123.025C24.4651 123.058 24.5026 123.083 24.5402 123.088L32.209 123.547L25.1243 126.517C25.0868 126.53 25.0617 126.567 25.0617 126.605C25.0576 126.642 25.0784 126.68 25.1118 126.701L31.6875 130.673L24.0312 130.01C23.9936 130.01 23.9561 130.026 23.9352 130.06C23.9143 130.093 23.9143 130.135 23.9352 130.168L27.9115 136.744L21.4443 132.601C21.4109 132.58 21.3692 132.576 21.3358 132.596C21.2983 132.617 21.2816 132.655 21.2816 132.692L21.7489 140.361L17.9479 133.685C17.927 133.652 17.8894 133.631 17.8519 133.635C17.8102 133.635 17.7768 133.66 17.7601 133.694L14.61 140.703L14.3471 133.026C14.3429 132.984 14.3221 132.951 14.2845 132.934C14.2511 132.918 14.2094 132.922 14.176 132.947L8.13028 137.687L11.464 130.765C11.4807 130.731 11.4765 130.69 11.4557 130.656C11.4306 130.627 11.3931 130.61 11.3513 130.619L3.79519 132.004L9.96612 127.427C9.99533 127.402 10.012 127.364 10.0037 127.323C9.9995 127.285 9.97029 127.256 9.93274 127.243L2.59772 124.961L10.1873 123.772C10.2248 123.764 10.2582 123.738 10.2707 123.701C10.2832 123.663 10.2749 123.622 10.2457 123.592L4.80908 118.164L12.0815 120.638C12.1191 120.651 12.1608 120.643 12.19 120.613C12.2192 120.588 12.2275 120.547 12.215 120.509L9.92857 113.174L15.2191 118.748C15.2442 118.773 15.2859 118.786 15.3234 118.773C15.361 118.765 15.3902 118.732 15.3944 118.694L16.7754 111.138L18.87 118.527C18.8825 118.565 18.9117 118.594 18.9534 118.602C18.9909 118.611 19.0285 118.594 19.0535 118.565L23.7892 112.515L22.2078 120.033C22.2037 120.071 22.2162 120.109 22.2454 120.134C22.2788 120.159 22.3205 120.163 22.3539 120.15L29.3593 116.992L24.4651 122.917C24.4526 122.933 24.4442 122.958 24.4442 122.983Z'
      fill='#F0EDFA'
    />
    <path
      d='M46.7681 149.893C46.1631 140.513 43.3342 130.258 38.3607 119.414C34.3845 110.739 29.0355 101.669 22.4598 92.456C16.6144 84.2573 10.8565 77.4646 7.05964 73.2047C2.94569 68.5942 0.175239 65.8822 0.146033 65.8571L-6.3833e-09 66.0031C0.0292066 66.0324 2.79549 68.7402 6.90527 73.3465C10.7021 77.6023 16.4516 84.3908 22.293 92.5811C32.6112 107.038 45.1951 128.718 46.5594 149.905L46.7681 149.893Z'
      fill='#F0EDFA'
    />
    <path
      d='M122.477 57.7321C122.477 57.7321 107.648 99.373 95.6878 98.6478C83.7233 97.9225 91.1994 79.2984 95.6878 71.7994C100.172 64.3005 106.074 54.0648 122.477 57.7321Z'
      fill='#F9F9F9'
    />
    <path
      d='M85.7577 56.4095C85.7577 56.1966 85.7546 55.9898 85.7485 55.7891C85.7212 54.4116 85.6391 53.3579 85.6391 53.3579L83.1029 51.3965L80.8633 49.6723C80.7052 49.5841 80.544 49.5081 80.3798 49.4442C79.9191 48.3221 79.4173 47.3323 79.0205 47.0906C77.9987 46.4657 74.523 42.5246 74.0121 42.5611C73.4967 42.5976 72.9584 43.6011 74.0121 45.0836C75.0703 46.566 76.7216 47.2958 75.7774 47.7018C74.8331 48.1032 72.2742 47.2456 72.2742 47.2456C72.2742 47.2456 69.104 43.3639 68.4107 43.3548C68.137 43.3502 67.9135 43.5281 67.7767 43.8109C67.1928 42.9488 66.4767 42.2646 65.9111 42.6979C65.6739 42.8804 66.4448 44.6958 66.9876 46.4155C67.7448 48.8193 69.136 49.9049 69.136 49.9049C69.136 49.9049 69.1132 48.3404 68.9262 46.9172C69.8795 48.0439 71.1977 49.4442 71.8272 50.1056L71.4577 52.4867C71.4577 52.4867 74.1216 54.0421 76.0602 55.0091C76.1788 55.1779 76.311 55.3421 76.4661 55.4926L76.53 55.5565C77.5654 56.5919 79.504 58.4165 81.2191 59.8944C82.6559 61.1305 83.9331 62.1203 84.4075 62.2116C85.5843 62.4351 85.7805 59.0551 85.7577 56.4095Z'
      fill='#F9F9F9'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M84.5169 62.3346C84.4743 62.3346 84.4302 62.3316 84.3846 62.3255C83.9421 62.2388 82.852 61.4497 81.146 59.9809C79.4218 58.4939 77.5015 56.6876 76.4478 55.6385L76.3839 55.5746C76.238 55.4287 76.1057 55.269 75.9825 55.0957C74.0622 54.1378 71.4257 52.6006 71.3983 52.5869C71.3573 52.5641 71.339 52.514 71.3436 52.4683L71.7085 50.1466C71.0745 49.4806 69.9752 48.3084 69.0857 47.2775C69.2271 48.582 69.2499 49.8912 69.2499 49.9048C69.2499 49.9505 69.2271 49.9915 69.1861 50.0098C69.1496 50.028 69.0994 50.0234 69.0675 49.9961C69.0082 49.9505 67.6352 48.8603 66.878 46.4519C66.7092 45.9182 66.5176 45.3663 66.3443 44.8782C65.8015 43.3273 65.6327 42.7663 65.8426 42.6066C66.0159 42.4743 66.2075 42.4242 66.4127 42.4607C66.8187 42.5245 67.2748 42.9077 67.7675 43.601C67.9317 43.3684 68.1552 43.2407 68.4152 43.2407C68.6204 43.2452 69.0812 43.4505 70.6868 45.2249C71.4804 46.1006 72.2103 46.9856 72.3425 47.1452C72.6345 47.241 74.8924 47.9526 75.7317 47.5968C75.8229 47.5603 75.9324 47.4964 75.9415 47.4234C75.9734 47.2501 75.6176 46.9217 75.2436 46.575C74.8376 46.201 74.3359 45.7312 73.9208 45.1519C73.0724 43.9614 73.2867 43.1905 73.4145 42.9122C73.5422 42.6386 73.7657 42.4652 74.0029 42.447C74.2994 42.4242 75.0429 43.1357 76.6667 44.755C77.6292 45.7175 78.6236 46.7119 79.0797 46.9901C79.4446 47.2136 79.9008 47.9891 80.4664 49.3575C80.6215 49.4213 80.7766 49.4898 80.9225 49.5719C80.9256 49.5749 80.9301 49.5779 80.9362 49.581L85.712 53.2666C85.7348 53.2848 85.753 53.3168 85.753 53.3487C85.7576 53.3578 85.8351 54.4206 85.8625 55.789C85.8671 55.9852 85.8716 56.195 85.8716 56.4048C85.899 59.6936 85.5888 61.6367 84.9411 62.175C84.8134 62.2814 84.672 62.3346 84.5169 62.3346ZM71.5808 52.4273C72.0096 52.6736 74.3678 54.0375 76.1103 54.9041C76.1255 54.9132 76.1391 54.9254 76.1513 54.9406C76.2699 55.1094 76.4022 55.269 76.5436 55.4104L76.6074 55.4743C77.6566 56.5234 79.5723 58.3252 81.2965 59.8076C83.4951 61.7006 84.2021 62.0564 84.4257 62.0974C84.5625 62.1248 84.6857 62.0929 84.7951 61.9971C85.3699 61.5181 85.6709 59.5339 85.6436 56.4094C85.6436 56.1996 85.639 55.9897 85.6344 55.7936C85.6116 54.5985 85.5478 53.6406 85.5295 53.4171L80.8039 49.768C80.6534 49.6859 80.4983 49.6129 80.3387 49.5536C80.3113 49.5399 80.2885 49.5171 80.2748 49.4898C79.5906 47.8294 79.1846 47.3231 78.9611 47.1863C78.4822 46.8943 77.5197 45.9319 76.5025 44.9192C75.946 44.3582 75.3667 43.7789 74.906 43.3547C74.2218 42.7252 74.0531 42.675 74.0166 42.675C73.866 42.6887 73.7155 42.8164 73.6197 43.0126C73.5331 43.1996 73.3096 43.8975 74.1078 45.0196C74.5046 45.5806 75.0018 46.0368 75.3987 46.4063C75.8913 46.867 76.2197 47.168 76.1695 47.4599C76.1422 47.6059 76.0281 47.7154 75.8229 47.8066C74.8467 48.2217 72.3425 47.387 72.2376 47.355C72.2163 47.3459 72.1996 47.3337 72.1875 47.3185C72.1783 47.3094 71.3846 46.3378 70.518 45.3799C68.958 43.6603 68.5247 43.4687 68.4106 43.4687C68.1141 43.4642 67.9499 43.715 67.8769 43.861C67.8633 43.8975 67.8268 43.9249 67.7857 43.9249C67.7447 43.9294 67.7036 43.9112 67.6808 43.8792C67.1927 43.1585 66.7412 42.7435 66.3762 42.6842C66.2348 42.6614 66.1071 42.6933 65.9885 42.7845C65.9155 42.9533 66.2713 43.9796 66.5633 44.8007C66.732 45.2933 66.9282 45.8452 67.0969 46.3834C67.6671 48.1943 68.6113 49.2571 69.0173 49.6448C68.999 49.1385 68.9534 47.9891 68.8166 46.9354C68.8075 46.8852 68.8348 46.835 68.8805 46.8122C68.9306 46.794 68.9808 46.8077 69.0173 46.8442C69.9478 47.948 71.2296 49.3119 71.9092 50.028C71.9366 50.0554 71.9457 50.0873 71.9411 50.1238L71.5808 52.4273Z'
      fill='#101828'
    />
    <path
      d='M71.6493 51.132C71.6493 51.132 68.8805 50.1103 68.6069 49.5264C68.3377 48.938 67.2156 43.9478 67.4437 43.6331C67.6718 43.3138 68.8441 44.0299 69.2227 45.3162C69.7427 47.0678 71.0563 48.6689 71.0563 48.6689L71.6493 51.132Z'
      fill='#F9F9F9'
    />
    <path
      d='M71.6128 51.2414C71.3254 51.1365 68.7893 50.1831 68.5065 49.5719C68.3514 49.2435 67.9911 47.7519 67.7265 46.5021C67.1655 43.8246 67.3023 43.6284 67.3479 43.5646C67.3935 43.5053 67.4939 43.414 67.7083 43.4505C68.1872 43.5326 69.0174 44.2168 69.3321 45.2842C69.8384 46.9902 71.1293 48.5821 71.143 48.6003L70.9651 48.7417C70.9514 48.7281 69.6332 47.0996 69.1132 45.3481C68.8167 44.3491 68.0321 43.7379 67.6718 43.6786C67.6398 43.6695 67.5669 43.6649 67.5395 43.6968C67.4802 43.8382 67.5897 44.7596 67.9591 46.5067C68.2511 47.8751 68.5886 49.207 68.7118 49.4761C68.8988 49.873 70.5956 50.621 71.6903 51.027L71.6128 51.2414Z'
      fill='#101828'
    />
    <path
      d='M77.8574 51.8069C77.8574 51.8069 76.3019 50.0508 72.9767 50.5115C72.9767 50.5115 71.4623 46.2238 70.8693 45.7585C70.2809 45.2933 69.7655 45.8543 69.8385 46.7028C69.916 47.5557 71.1932 52.1171 71.4578 52.4866L77.8574 51.8069Z'
      fill='#F9F9F9'
    />
    <path
      d='M71.3665 52.555C71.0882 52.1673 69.8019 47.5831 69.7244 46.7164C69.6788 46.1782 69.8521 45.7175 70.1714 45.5487C70.4086 45.421 70.6823 45.462 70.9423 45.6673C71.5124 46.1189 72.7988 49.6631 73.0542 50.3838C74.751 50.1694 75.978 50.5343 76.7124 50.8855C77.5289 51.2687 77.9257 51.7111 77.944 51.7294L77.7752 51.8799C77.7707 51.8799 77.3829 51.4511 76.6075 51.0862C75.8868 50.7441 74.678 50.3929 72.9949 50.621L72.9037 50.6346L72.8717 50.548C72.4521 49.3666 71.2661 46.2147 70.8009 45.8497C70.6686 45.7448 70.4724 45.6445 70.2809 45.7494C70.0437 45.8725 69.916 46.2557 69.9524 46.6936C70.0254 47.5101 71.2935 52.0624 71.5489 52.4227L71.3665 52.555Z'
      fill='#101828'
    />
    <path
      d='M85.7577 56.4094C85.4019 57.1802 83.9468 58.2522 82.3412 59.3332C81.9946 59.5658 81.616 59.7483 81.2191 59.8943C79.5041 58.4164 77.5655 56.5918 76.53 55.5564C79.2258 55.2051 82.2318 52.2995 83.103 51.3964L85.6391 53.3578C85.6391 53.3578 85.7212 54.4115 85.7486 55.789C85.8718 55.9623 85.8672 56.1722 85.7577 56.4094Z'
      fill='#101828'
    />
    <path
      d='M86.6882 52.3315L76.2745 55.9806L89.2243 98.657L105.851 84.3205L86.6882 52.3315Z'
      fill='#FBFAFE'
    />
    <path
      d='M77.0636 58.6992C77.0135 58.6992 76.9679 58.6673 76.9542 58.6171C76.9405 58.5533 76.977 58.494 77.0363 58.4757L88.5948 55.447C88.6541 55.4333 88.718 55.4698 88.7362 55.5291C88.7499 55.5929 88.7134 55.6522 88.6541 55.6705L77.0956 58.6947C77.0834 58.6977 77.0728 58.6992 77.0636 58.6992Z'
      fill='#101828'
    />
    <path
      d='M101.248 76.7532C101.212 76.7532 101.171 76.7349 101.152 76.6985L93.4345 63.8125C93.4026 63.7578 93.4209 63.6848 93.4756 63.6529C93.5258 63.621 93.5987 63.6392 93.6307 63.6939L101.349 76.5799C101.38 76.6346 101.362 76.7076 101.307 76.7395C101.289 76.7486 101.269 76.7532 101.248 76.7532Z'
      fill='#101828'
    />
    <path
      d='M132.238 62.3118C132.211 61.988 133 49.6448 132.963 48.5912C132.927 47.542 122.823 51.5515 122.823 51.5515C122.823 51.5515 121.213 62.4213 121.811 62.6448C122.404 62.8729 132.238 62.3118 132.238 62.3118Z'
      fill='#F9F9F9'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M122.842 62.8135C122.272 62.8135 121.879 62.7952 121.77 62.7542C121.624 62.6994 121.496 62.5033 121.601 60.811C121.66 59.8805 121.788 58.5988 121.98 57.0023C122.303 54.2883 122.709 51.5651 122.709 51.5377C122.719 51.4967 122.746 51.4602 122.782 51.4465C122.805 51.4374 125.109 50.5251 127.49 49.6904C132.361 47.9935 132.808 48.2855 132.959 48.3813C133.032 48.4314 133.073 48.5044 133.077 48.5865C133.1 49.2205 132.831 53.8412 132.612 57.5588C132.471 59.9261 132.343 62.1658 132.352 62.3026C132.352 62.3345 132.343 62.3619 132.325 62.3847C132.302 62.4075 132.275 62.4258 132.243 62.4258C131.422 62.4714 125.373 62.8135 122.842 62.8135ZM121.861 62.5444C122.363 62.6949 128.215 62.4258 132.124 62.2023C132.138 61.7598 132.229 60.1451 132.384 57.5451C132.603 53.8321 132.872 49.216 132.849 48.5956C132.849 48.5911 132.849 48.582 132.831 48.5728C132.681 48.477 131.864 48.4086 127.567 49.9093C125.405 50.6619 123.307 51.483 122.928 51.6335C122.865 52.0577 122.518 54.4525 122.226 56.8791C121.642 61.7233 121.793 62.4395 121.861 62.5444Z'
      fill='#101828'
    />
    <path
      d='M129.269 47.2592C129.269 47.2592 126.614 53.8413 122.413 54.3932L122.878 51.141L129.269 47.2592Z'
      fill='#101828'
    />
    <path
      d='M133.324 34.8476C133.242 34.799 133.16 34.7518 133.077 34.7062C128.046 31.9192 125.784 32.5031 122.354 37.1192C121.838 37.8171 121.373 38.4602 120.953 39.0578C120.456 39.4181 119.279 40.116 118.221 40.5813C117.628 40.8413 117.829 41.5437 118.121 42.3328C118.235 42.6567 118.367 42.976 118.481 43.2086C117.97 44.3307 117.605 45.4574 117.304 46.7848C116.629 49.7588 118.508 51.2914 121.241 51.8935C124.032 52.5093 130.801 50.484 132.722 48.249C134.642 46.0093 139.924 38.6974 133.324 34.8476Z'
      fill='#F9F9F9'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M122.431 52.117C121.97 52.117 121.56 52.0805 121.213 52.0075C119.457 51.6198 118.239 50.9037 117.587 49.8728C117.049 49.0244 116.916 47.9798 117.195 46.7619C117.496 45.4255 117.865 44.2942 118.358 43.2086C118.226 42.9441 118.098 42.6111 118.011 42.3739C117.769 41.7079 117.436 40.8002 118.175 40.4763C119.261 39.9974 120.415 39.3041 120.871 38.9756C121.263 38.4146 121.72 37.7851 122.262 37.0507C125.761 32.3434 128.096 31.8188 133.132 34.6058C133.217 34.6545 133.301 34.7016 133.383 34.7472C135.208 35.8146 136.284 37.2378 136.576 38.9711C137.224 42.8255 133.853 47.0995 132.808 48.3219C131.905 49.371 129.862 50.4658 127.339 51.2503C125.528 51.8114 123.763 52.117 122.431 52.117ZM128.137 33.1371C127.791 33.1371 127.458 33.1736 127.139 33.2511C125.642 33.5932 124.238 34.7746 122.445 37.1876C121.898 37.9265 121.441 38.5606 121.045 39.1216C121.038 39.1338 121.031 39.1429 121.022 39.149C120.483 39.5413 119.275 40.2392 118.267 40.6862C117.811 40.8869 117.902 41.4069 118.226 42.2963C118.317 42.5427 118.454 42.8939 118.586 43.1584C118.6 43.1858 118.6 43.2223 118.586 43.2542C118.093 44.3398 117.719 45.4711 117.414 46.8121C117.154 47.9661 117.277 48.956 117.779 49.7542C118.399 50.7258 119.571 51.41 121.263 51.784C123.905 52.3633 130.683 50.443 132.635 48.1714C133.666 46.9718 136.982 42.7616 136.353 39.0076C136.07 37.3427 135.034 35.9743 133.269 34.9479C133.187 34.8993 133.105 34.8522 133.023 34.8065C130.966 33.6662 129.437 33.1371 128.137 33.1371Z'
      fill='#101828'
    />
    <path
      d='M121.747 39.6736C121.592 40.0066 121.642 40.3624 121.856 40.4627C122.075 40.5676 122.381 40.376 122.536 40.0431C122.691 39.7055 122.646 39.3497 122.427 39.2494C122.208 39.149 121.902 39.336 121.747 39.6736Z'
      fill='#101828'
    />
    <path
      d='M119.891 46.1918C119.115 45.8543 119.498 44.682 120.328 44.8371C120.899 44.9466 121.66 45.0104 122.249 44.7824C123.334 44.3627 122.746 46.3652 121.282 46.429C120.775 46.4518 120.278 46.3606 119.891 46.1918Z'
      fill='#F9F9F9'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M121.131 46.5476C120.675 46.5476 120.224 46.4609 119.845 46.2921C119.389 46.096 119.288 45.6398 119.393 45.3069C119.503 44.9602 119.845 44.6318 120.347 44.7276C120.88 44.8279 121.633 44.9009 122.208 44.6774C122.536 44.5497 122.714 44.6318 122.801 44.7184C122.947 44.8644 122.96 45.129 122.846 45.4254C122.646 45.9409 122.071 46.5111 121.286 46.543C121.235 46.546 121.183 46.5476 121.131 46.5476ZM120.178 44.9374C119.881 44.9374 119.681 45.1426 119.612 45.3707C119.535 45.6216 119.603 45.9409 119.936 46.0868C120.324 46.2556 120.803 46.3377 121.277 46.3149C121.961 46.2875 122.459 45.7904 122.632 45.3433C122.714 45.1381 122.714 44.9556 122.641 44.8826C122.582 44.8233 122.459 44.8233 122.29 44.8872C121.665 45.1335 120.867 45.056 120.306 44.9511C120.26 44.9419 120.217 44.9374 120.178 44.9374Z'
      fill='#101828'
    />
    <path
      d='M140.7 45.9273C141.37 44.349 141.644 42.6111 141.438 40.8915C141.001 37.2561 138.505 34.1634 135.139 32.8042C134.044 32.3617 132.772 32.3252 131.723 31.8463C131.007 31.5224 130.363 30.8792 129.798 30.3501C129.437 30.0126 125.852 26.5915 126.016 26.3133L125.579 27.0659C124.808 28.375 124.493 29.8985 124.68 31.4084L122.573 29.6705C122.271 30.0126 121.961 30.5828 121.774 31.2578C121.346 32.8087 121.501 35.1031 124.169 36.1978C127.043 37.3747 129.177 37.1785 129.177 37.1785C129.177 37.1785 126.591 42.4789 129.588 45.868C129.588 45.868 130.564 53.823 133.337 54.2335C133.552 54.2609 134.647 52.8743 134.797 52.7192C135.951 51.556 137.164 50.475 138.346 49.3437C139.358 48.3767 140.157 47.2044 140.7 45.9273Z'
      fill='#101828'
    />
    <path
      d='M127.221 42.2644C127.221 42.2644 130.003 41.0283 131.007 43.4184C132.416 46.7756 128.297 48.7142 126.5 47.5283C124.707 46.3469 127.221 42.2644 127.221 42.2644Z'
      fill='#F9F9F9'
    />
    <path
      d='M129.52 46.534C129.492 46.534 129.465 46.5248 129.447 46.5066C129.396 46.461 129.396 46.388 129.438 46.3424C130.085 45.6399 130.359 44.9785 130.259 44.3856C130.14 43.6694 129.501 43.227 129.127 43.0263C128.557 42.7161 127.891 42.9989 127.882 42.9989C127.827 43.0263 127.759 42.9989 127.736 42.9396C127.709 42.8849 127.736 42.8164 127.795 42.7891C127.823 42.7754 128.566 42.4652 129.237 42.8256C129.643 43.0445 130.345 43.5326 130.482 44.3491C130.596 45.015 130.3 45.7403 129.606 46.4975C129.583 46.5203 129.552 46.534 129.52 46.534Z'
      fill='#101828'
    />
    <path
      d='M130.176 45.6079C130.173 45.6079 130.172 45.6079 130.172 45.6079L128.014 45.5531C127.95 45.5531 127.9 45.4984 127.9 45.4391C127.905 45.3752 127.959 45.3251 128.019 45.3251L130.176 45.3798C130.24 45.3844 130.29 45.4345 130.29 45.4984C130.286 45.5623 130.236 45.6079 130.176 45.6079Z'
      fill='#101828'
    />
    <mask
      id='mask0_11026_107898'
      style={{ maskType: 'luminance' }}
      maskUnits='userSpaceOnUse'
      x='128'
      y='22'
      width='20'
      height='20'>
      <path
        d='M142.599 41.4038L128.479 28.4513L147.058 22.0644L142.599 41.4038Z'
        fill='white'
      />
    </mask>
    <g mask='url(#mask0_11026_107898)'>
      <path
        d='M142.597 41.4023L128.48 28.4525L153.558 14.6407L142.597 41.4023Z'
        fill='#101828'
      />
      <path
        d='M122.81 26.7101L150.091 37.3153L149.704 38.8525L122.144 27.376L122.81 26.7101Z'
        fill='#F9F9F9'
      />
      <path
        d='M144.403 42.3419C143.97 41.6441 133.789 25.2139 133.31 24.3153L133.515 24.2059C133.99 25.0999 144.49 42.05 144.595 42.2234L144.403 42.3419Z'
        fill='#F9F9F9'
      />
      <path
        d='M139.377 23.8182C139.997 24.4933 146.041 34.8294 146.041 34.8294L146.721 34.2273L140.065 22.4817L139.377 23.8182Z'
        fill='#F9F9F9'
      />
    </g>
    <path
      d='M148.007 23.7088C147.327 24.4203 146.2 24.4477 145.489 23.7681C144.777 23.0884 144.754 21.9618 145.43 21.2547C146.109 20.5432 147.236 20.5158 147.947 21.1954C148.659 21.8751 148.682 23.0018 148.007 23.7088Z'
      fill='#FBFAFE'
    />
    <path
      d='M129.697 27.6224C130.737 29.2052 135.176 35.4315 143.135 40.0704C143.354 40.1982 143.455 40.4536 143.386 40.6954C143.213 41.302 142.811 42.3466 142.109 42.2782C141.128 42.1915 131.691 36.1476 127.64 29.2463C127.139 28.3887 128.324 27.7228 129.009 27.4217C129.26 27.3122 129.547 27.3989 129.697 27.6224Z'
      fill='#FF004F'
    />
    <path
      d='M156.961 118.814C156.131 118.421 93.2838 110.307 93.2838 110.307L100.062 69.2862C100.961 61.208 108.04 55.2599 116.155 55.7571L120.734 56.0491L134.719 56.9385L139.025 57.2122C147.017 57.7049 153.266 64.3006 153.33 72.3059C153.476 90.3416 157.526 119.083 156.961 118.814Z'
      fill='#FBFAFE'
    />
    <path
      d='M168.629 129.314C168.559 129.314 168.487 129.311 168.414 129.305L71.7312 123.019C69.9295 122.901 68.5565 121.341 68.6751 119.534L71.1291 81.7707C71.2477 79.9644 72.8123 78.5915 74.614 78.7101L171.297 84.9956C172.168 85.0549 172.971 85.4472 173.546 86.1041C174.125 86.7655 174.413 87.6093 174.353 88.4805L171.899 126.249C171.785 127.978 170.339 129.314 168.629 129.314Z'
      fill='#101828'
    />
    <path
      d='M165.436 126.71L69.9386 120.501C67.8677 120.365 66.2986 118.577 66.4354 116.506L68.8119 79.928C68.9488 77.8571 70.7368 76.2834 72.8077 76.4202L168.305 82.6283C170.376 82.7651 171.945 84.5532 171.808 86.6241L169.432 123.202C169.295 125.277 167.507 126.846 165.436 126.71Z'
      fill='#F7F6FC'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M165.687 126.833C165.602 126.833 165.516 126.83 165.431 126.823L69.9341 120.615C68.9032 120.547 67.959 120.082 67.2748 119.306C66.5906 118.526 66.253 117.532 66.3214 116.501L68.6979 79.9187C68.7663 78.8879 69.2316 77.9437 70.007 77.2594C70.787 76.5798 71.7814 76.2377 72.8123 76.3061L168.31 82.5142C169.345 82.5826 170.289 83.0478 170.969 83.8233C171.653 84.6033 171.991 85.5977 171.922 86.6285L169.546 123.211C169.477 124.242 169.012 125.186 168.237 125.87C167.525 126.495 166.626 126.833 165.687 126.833ZM72.5568 76.5251C71.6719 76.5251 70.8281 76.8444 70.1576 77.4328C69.4277 78.0759 68.9898 78.9608 68.926 79.9324L66.5495 116.515C66.4856 117.486 66.8049 118.421 67.4481 119.156C68.0867 119.886 68.9762 120.323 69.9477 120.387L165.445 126.595C166.417 126.659 167.352 126.34 168.086 125.697C168.816 125.058 169.254 124.169 169.318 123.197L171.694 86.6148C171.758 85.6433 171.439 84.7082 170.8 83.9738C170.157 83.244 169.267 82.8061 168.296 82.7422L72.7986 76.5342C72.7195 76.5281 72.639 76.5251 72.5568 76.5251Z'
      fill='#101828'
    />
    <path
      d='M147.104 101.686C147.104 116.483 135.112 128.475 120.319 128.475C105.527 128.475 93.5302 116.483 93.5302 101.686C93.5302 86.893 105.527 74.9011 120.319 74.9011C135.112 74.9011 147.104 86.893 147.104 101.686Z'
      fill='#F9F9F9'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M120.319 128.589C116.688 128.589 113.162 127.877 109.846 126.472C106.644 125.118 103.766 123.179 101.298 120.707C98.8258 118.239 96.8872 115.361 95.5325 112.159C94.1276 108.842 93.416 105.317 93.416 101.686C93.416 98.0548 94.1276 94.5334 95.5325 91.2173C96.8872 88.0106 98.8258 85.137 101.298 82.6647C103.766 80.197 106.644 78.2538 109.846 76.8991C113.162 75.4987 116.688 74.7872 120.319 74.7872C123.95 74.7872 127.471 75.4987 130.787 76.8991C133.994 78.2538 136.868 80.197 139.34 82.6647C141.812 85.137 143.751 88.0106 145.106 91.2173C146.506 94.5334 147.218 98.0548 147.218 101.686C147.218 105.317 146.506 108.842 145.106 112.159C143.751 115.361 141.812 118.239 139.34 120.707C136.868 123.179 133.994 125.118 130.787 126.472C127.471 127.877 123.95 128.589 120.319 128.589ZM120.319 75.0152C105.613 75.0152 93.6441 86.9798 93.6441 101.686C93.6441 116.396 105.613 128.361 120.319 128.361C135.025 128.361 146.99 116.396 146.99 101.686C146.99 86.9798 135.025 75.0152 120.319 75.0152Z'
      fill='#101828'
    />
    <path
      d='M136.631 117.71L128.52 117.491C127.886 117.473 127.289 117.796 126.956 118.335L123.298 124.255C122.682 125.254 121.281 125.391 120.479 124.534L115.119 118.773C114.69 118.312 114.047 118.111 113.427 118.248L106.411 119.822C105.276 120.073 104.208 119.188 104.245 118.024L104.496 110.033C104.518 109.399 104.199 108.801 103.661 108.464L97.7128 104.737C96.7047 104.108 96.5861 102.689 97.471 101.9L102.999 96.9691C103.469 96.5449 103.684 95.9063 103.56 95.2905L102.083 87.8874C101.85 86.7288 102.79 85.6706 103.966 85.7618L111.018 86.3092C111.652 86.3548 112.264 86.0674 112.624 85.5474L117.126 79.0429C117.797 78.0713 119.211 78.012 119.963 78.9197L124.292 84.1608C124.698 84.6534 125.337 84.8906 125.961 84.7857L134.19 83.3944C135.308 83.2074 136.316 84.0969 136.266 85.2327L135.924 92.8365C135.896 93.4569 136.193 94.0453 136.708 94.3919L142.975 98.6158C143.929 99.2589 144.034 100.618 143.194 101.398L137.365 106.822C136.904 107.255 136.704 107.898 136.84 108.514L138.414 115.539C138.669 116.674 137.789 117.742 136.631 117.71Z'
      fill='#101828'
    />
    <path
      d='M121.779 125.213C121.254 125.213 120.757 124.999 120.397 124.611L115.037 118.85C114.636 118.421 114.029 118.23 113.454 118.362L106.439 119.931C105.864 120.059 105.271 119.917 104.815 119.543C104.363 119.165 104.113 118.613 104.131 118.02L104.382 110.028C104.4 109.435 104.103 108.874 103.602 108.564L97.649 104.833C97.1381 104.514 96.8188 103.989 96.7687 103.387C96.7185 102.789 96.9466 102.215 97.3936 101.813L102.922 96.8824C103.364 96.4901 103.565 95.888 103.451 95.3133L101.969 87.9056C101.85 87.3218 102.014 86.7288 102.411 86.2772C102.808 85.8302 103.378 85.6021 103.976 85.6477L111.028 86.1951C111.616 86.2407 112.191 85.967 112.528 85.479L117.03 78.9744C117.372 78.4863 117.911 78.1853 118.508 78.1625C119.106 78.1351 119.667 78.386 120.05 78.8467L124.379 84.0877C124.757 84.5484 125.359 84.7719 125.943 84.6716L134.172 83.2804C134.738 83.1846 135.312 83.3488 135.741 83.7319C136.175 84.1105 136.407 84.6625 136.38 85.2372L136.038 92.841C136.015 93.4203 136.293 93.9768 136.772 94.3007L143.039 98.5245C143.523 98.8484 143.824 99.3684 143.87 99.9477C143.915 100.527 143.696 101.088 143.272 101.48L137.443 106.904C137.014 107.305 136.822 107.916 136.954 108.491L138.528 115.516C138.656 116.09 138.514 116.679 138.14 117.135C137.766 117.587 137.214 117.837 136.626 117.824L128.516 117.605C127.923 117.587 127.362 117.892 127.052 118.394L123.398 124.315C123.083 124.821 122.563 125.145 121.97 125.204C121.906 125.21 121.843 125.213 121.779 125.213Z'
      fill='#00F7EF'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M121.779 125.327C121.218 125.327 120.698 125.099 120.315 124.689L114.955 118.928C114.581 118.526 114.015 118.353 113.477 118.472L106.462 120.041C105.855 120.178 105.226 120.032 104.742 119.63C104.263 119.233 103.994 118.645 104.017 118.02L104.268 110.024C104.286 109.477 104.008 108.952 103.542 108.66L97.5898 104.933C97.047 104.591 96.7095 104.035 96.6547 103.396C96.6 102.762 96.8417 102.155 97.3207 101.731L102.849 96.7959C103.26 96.431 103.447 95.8699 103.337 95.3317L101.859 87.9285C101.732 87.3082 101.905 86.6787 102.325 86.2043C102.744 85.7299 103.351 85.4836 103.985 85.5338L111.037 86.0812C111.589 86.1222 112.122 85.8668 112.437 85.4152L116.939 78.9107C117.3 78.3907 117.87 78.0759 118.504 78.0486C119.138 78.0212 119.735 78.2858 120.137 78.7738L124.47 84.0149C124.821 84.4436 125.378 84.6489 125.925 84.5577L134.154 83.171C134.751 83.0661 135.358 83.2394 135.819 83.6454C136.275 84.0513 136.521 84.6306 136.494 85.2419L136.152 92.8457C136.129 93.3839 136.389 93.9039 136.836 94.205L143.103 98.4288C143.614 98.7755 143.934 99.3229 143.984 99.9387C144.034 100.554 143.801 101.147 143.35 101.567L137.52 106.991C137.119 107.365 136.945 107.93 137.064 108.464L138.638 115.488C138.775 116.1 138.624 116.725 138.227 117.208C137.83 117.687 137.247 117.956 136.622 117.938L128.511 117.719C127.964 117.701 127.44 117.984 127.148 118.453L123.494 124.374C123.161 124.912 122.609 125.259 121.98 125.318C121.913 125.324 121.846 125.327 121.779 125.327ZM113.815 118.207C114.303 118.207 114.782 118.408 115.119 118.773L120.479 124.534C120.821 124.899 121.282 125.099 121.779 125.099C121.84 125.099 121.899 125.096 121.957 125.09C122.518 125.035 123.006 124.73 123.298 124.255L126.956 118.335C127.289 117.796 127.887 117.473 128.521 117.491L136.631 117.71C137.183 117.724 137.703 117.486 138.054 117.062C138.405 116.633 138.537 116.081 138.414 115.539L136.841 108.514C136.704 107.898 136.904 107.251 137.365 106.822L143.195 101.398C143.596 101.029 143.801 100.5 143.756 99.9569C143.715 99.4095 143.427 98.9215 142.976 98.6159L136.708 94.392C136.197 94.0499 135.896 93.4524 135.924 92.8366L136.266 85.2327C136.289 84.6899 136.07 84.1745 135.668 83.8187C135.262 83.4584 134.724 83.3033 134.19 83.3945L125.962 84.7857C125.337 84.8906 124.698 84.6489 124.292 84.1608L119.963 78.9198C119.603 78.4865 119.074 78.2538 118.513 78.2766C117.952 78.2994 117.446 78.5777 117.126 79.0429L112.624 85.5475C112.264 86.0629 111.648 86.3548 111.019 86.3092L103.967 85.7619C103.406 85.7163 102.867 85.9352 102.493 86.3548C102.124 86.7745 101.969 87.3355 102.083 87.8875L103.561 95.2906C103.684 95.9064 103.469 96.5496 103 96.9692L97.4712 101.9C97.047 102.274 96.8326 102.817 96.8828 103.378C96.9284 103.944 97.2295 104.436 97.713 104.737L103.661 108.464C104.199 108.801 104.519 109.399 104.496 110.033L104.245 118.025C104.227 118.581 104.459 119.101 104.888 119.457C105.317 119.808 105.873 119.94 106.412 119.822L113.427 118.248C113.555 118.221 113.684 118.207 113.815 118.207Z'
      fill='#101828'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M117.947 99.4324C117.947 103.487 115.817 105.499 113.331 105.499C110.936 105.499 108.866 103.574 108.834 99.6969C108.834 95.8517 110.936 93.6941 113.477 93.6941C116.173 93.6941 117.947 95.765 117.947 99.4324ZM110.904 99.6102C110.845 102.064 111.762 103.93 113.39 103.93C115.106 103.93 115.876 102.096 115.876 99.5509C115.876 97.2155 115.197 95.2632 113.39 95.2632C111.762 95.2632 110.904 97.1836 110.904 99.6102ZM113.153 113.573L124.456 93.6941H126.112L114.809 113.573H113.153ZM130.464 107.392C130.464 111.442 128.334 113.454 125.875 113.454C123.48 113.454 121.409 111.534 121.377 107.688C121.377 103.811 123.48 101.654 126.025 101.654C128.717 101.654 130.464 103.725 130.464 107.392ZM123.421 107.57C123.389 110.024 124.338 111.889 125.934 111.889C127.649 111.889 128.42 110.056 128.42 107.511C128.42 105.171 127.741 103.218 125.934 103.218C124.306 103.218 123.421 105.143 123.421 107.57Z'
      fill='#101828'
    />
    <path
      d='M151.191 64.5604C151.191 64.5604 165.737 90.7519 163.073 97.407C160.437 104.007 151.674 108.359 143.217 88.567C132.279 62.9685 139.472 60.8657 151.191 64.5604Z'
      fill='#FBFAFE'
    />
    <path
      d='M132.124 113.18C131.673 112.888 131.226 112.619 130.792 112.373C130.131 111.994 129.501 111.67 128.927 111.406C128.402 111.164 128.612 110.713 128.525 110.457C128.498 110.38 128.443 110.316 128.325 110.288C128.174 110.366 126.847 110.881 126.737 110.918C126.719 110.922 126.701 110.927 126.687 110.936C126.419 111.018 126.149 111.1 125.875 111.182C122.436 112.232 118.445 113.267 117.956 114.102C117.783 114.398 117.747 114.95 118.682 114.959C120.598 114.973 124.274 114.289 122.979 115.479C121.045 117.254 115.142 119.448 114.668 120.168C114.38 120.611 114.608 120.999 115.124 121.181C113.828 121.797 114.244 122.828 116.109 122.951C115.68 123.886 117.633 124.347 119.316 124.164C119.261 124.524 119.416 124.853 120.032 125.003C121.756 125.423 126.327 122.504 126.327 122.504V122.499C126.34 122.495 128.005 121.386 130.163 119.863C131.253 119.096 132.462 118.221 133.648 117.331L133.73 117.272C133.926 117.121 134.464 116.638 135.126 116.031C136.599 114.681 138.697 112.71 139.108 112.382C138.259 111.57 133.524 114.088 132.124 113.18Z'
      fill='#F9F9F9'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M120.41 125.158C120.265 125.158 120.128 125.145 120.005 125.113C119.352 124.953 119.193 124.602 119.193 124.292C117.975 124.397 116.501 124.187 116.059 123.576C115.945 123.416 115.908 123.238 115.954 123.051C115.001 122.964 114.362 122.613 114.271 122.13C114.207 121.792 114.421 121.455 114.864 121.19C114.663 121.076 114.522 120.921 114.462 120.743C114.394 120.542 114.43 120.323 114.572 120.104C114.786 119.781 115.781 119.293 117.523 118.453C119.434 117.536 121.815 116.391 122.901 115.397C123.156 115.16 123.138 115.069 123.129 115.05C123.115 115.014 123.01 114.9 122.308 114.891C121.815 114.886 121.163 114.932 120.529 114.982C119.881 115.028 119.211 115.078 118.682 115.073C118.239 115.069 117.947 114.95 117.815 114.717C117.692 114.494 117.756 114.22 117.861 114.042C118.285 113.313 120.958 112.523 124.05 111.611C124.643 111.433 125.255 111.255 125.843 111.073C126.089 111 126.354 110.918 126.65 110.827C126.66 110.824 126.669 110.821 126.678 110.817C126.684 110.814 126.69 110.811 126.696 110.808C126.699 110.808 126.701 110.808 126.701 110.808C126.801 110.776 128.124 110.261 128.274 110.188C128.297 110.174 128.324 110.17 128.352 110.179C128.498 110.211 128.594 110.297 128.635 110.421C128.667 110.512 128.667 110.612 128.667 110.717C128.667 110.954 128.667 111.16 128.972 111.301C129.57 111.575 130.199 111.899 130.847 112.273C131.294 112.528 131.746 112.802 132.183 113.084C132.881 113.536 134.551 113.062 136.029 112.642C137.479 112.227 138.738 111.871 139.185 112.3C139.208 112.323 139.222 112.355 139.222 112.387C139.217 112.419 139.203 112.45 139.176 112.473C138.911 112.683 137.908 113.614 136.841 114.599C136.284 115.119 135.709 115.653 135.203 116.113C134.437 116.82 133.976 117.226 133.798 117.359L133.716 117.422C132.662 118.216 131.49 119.069 130.231 119.959C128.165 121.414 126.55 122.49 126.4 122.59C126.397 122.593 126.393 122.597 126.39 122.6C126.213 122.709 122.363 125.158 120.41 125.158ZM119.316 124.05C119.348 124.05 119.375 124.064 119.398 124.087C119.421 124.109 119.434 124.146 119.43 124.182C119.375 124.543 119.58 124.775 120.059 124.889C121.679 125.291 126.026 122.558 126.258 122.413C126.261 122.409 126.263 122.408 126.263 122.408C126.336 122.358 127.978 121.268 130.099 119.771C131.358 118.882 132.526 118.034 133.579 117.24L133.661 117.181C133.835 117.048 134.286 116.647 135.048 115.944C135.554 115.484 136.129 114.95 136.686 114.435C137.634 113.554 138.533 112.72 138.916 112.391C138.451 112.19 137.251 112.528 136.088 112.861C134.496 113.313 132.845 113.782 132.06 113.276C131.627 112.993 131.18 112.724 130.737 112.469C130.094 112.099 129.469 111.78 128.876 111.506C128.439 111.31 128.439 110.968 128.439 110.717C128.439 110.63 128.439 110.553 128.42 110.494C128.407 110.466 128.393 110.434 128.334 110.412C128.055 110.535 126.892 110.986 126.778 111.023C126.766 111.026 126.755 111.029 126.746 111.032C126.74 111.035 126.733 111.038 126.723 111.041C126.723 111.041 126.722 111.041 126.719 111.041C126.422 111.137 126.158 111.219 125.907 111.292C125.319 111.474 124.707 111.652 124.114 111.83C121.323 112.651 118.435 113.504 118.057 114.161C117.984 114.284 117.934 114.462 118.016 114.603C118.102 114.759 118.335 114.841 118.686 114.845C119.206 114.85 119.868 114.8 120.511 114.754C122.157 114.631 123.175 114.576 123.339 114.959C123.435 115.178 123.22 115.411 123.056 115.561C121.948 116.583 119.548 117.733 117.623 118.659C116.25 119.32 114.95 119.945 114.763 120.232C114.663 120.387 114.631 120.538 114.677 120.67C114.732 120.839 114.905 120.985 115.16 121.076C115.206 121.09 115.238 121.131 115.238 121.176C115.242 121.222 115.215 121.268 115.174 121.286C114.695 121.514 114.44 121.815 114.494 122.089C114.554 122.39 115.01 122.764 116.114 122.837C116.15 122.841 116.187 122.86 116.205 122.891C116.223 122.923 116.228 122.964 116.209 122.996C116.136 123.161 116.146 123.307 116.246 123.443C116.588 123.922 117.961 124.196 119.302 124.05C119.308 124.05 119.313 124.05 119.316 124.05Z'
      fill='#101828'
    />
    <path
      d='M135.126 116.031C134.464 116.638 133.926 117.121 133.73 117.272L133.648 117.331C132.462 118.221 131.253 119.096 130.163 119.863L128.325 110.288L128.525 110.457L130.792 112.373L135.126 116.031Z'
      fill='#101828'
    />
    <path
      d='M115.22 121.295C115.186 121.295 115.154 121.295 115.124 121.295C115.06 121.295 115.01 121.245 115.01 121.181C115.01 121.117 115.06 121.067 115.124 121.067C118.81 121.108 122.655 118.713 122.691 118.69C122.746 118.654 122.814 118.672 122.851 118.727C122.883 118.777 122.869 118.85 122.814 118.882C122.773 118.905 118.942 121.295 115.22 121.295Z'
      fill='#101828'
    />
    <path
      d='M116.679 122.946C116.506 122.946 116.339 122.939 116.178 122.923C116.114 122.919 116.068 122.86 116.077 122.8C116.082 122.736 116.137 122.691 116.2 122.695C118.965 122.946 123.617 120.802 123.663 120.78C123.718 120.752 123.786 120.775 123.813 120.834C123.841 120.889 123.813 120.957 123.759 120.985C123.576 121.072 119.512 122.946 116.679 122.946Z'
      fill='#101828'
    />
    <path
      d='M118.267 124.429C118.207 124.429 118.157 124.383 118.153 124.319C118.148 124.26 118.198 124.205 118.258 124.201C121.04 124.036 124.425 122.65 124.456 122.636C124.516 122.609 124.584 122.636 124.607 122.695C124.63 122.755 124.602 122.818 124.543 122.846C124.511 122.86 121.095 124.26 118.271 124.429C118.271 124.429 118.27 124.429 118.267 124.429Z'
      fill='#101828'
    />
    <path
      d='M159.237 102.142L132.425 119.712L127.052 107.807L152.208 84.0147L159.237 102.142Z'
      fill='#FBFAFE'
    />
    <path
      d='M139.774 95.888C139.746 95.888 139.714 95.8743 139.691 95.8515C139.65 95.8059 139.65 95.7329 139.696 95.6919L147.026 88.7585C147.072 88.7129 147.145 88.7175 147.186 88.7631C147.231 88.8087 147.231 88.8771 147.181 88.9228L139.851 95.8561C139.833 95.8743 139.801 95.888 139.774 95.888Z'
      fill='#101828'
    />
    <path
      d='M135.413 117.965C135.367 117.965 135.326 117.942 135.308 117.901L129.666 105.28C129.643 105.225 129.666 105.157 129.725 105.129C129.784 105.102 129.848 105.129 129.875 105.189L135.518 117.805C135.541 117.865 135.518 117.933 135.459 117.956C135.443 117.962 135.428 117.965 135.413 117.965Z'
      fill='#101828'
    />
    <path
      d='M134.719 56.9384L127.449 63.7531L120.734 56.049H127.9L134.719 56.9384Z'
      fill='#F9F9F9'
    />
    <path
      d='M127.449 63.8673C127.449 63.8673 127.447 63.8673 127.444 63.8673C127.412 63.8673 127.385 63.8536 127.367 63.8262L120.502 56.1403C120.456 56.0947 120.461 56.0217 120.511 55.9807C120.556 55.9396 120.629 55.9442 120.67 55.9898L127.458 63.5891L134.615 56.8792C134.66 56.8336 134.733 56.8382 134.774 56.8838C134.82 56.9294 134.815 57.0024 134.77 57.0435L127.526 63.8354C127.508 63.8536 127.481 63.8673 127.449 63.8673Z'
      fill='#101828'
    />
    <path
      d='M35.6508 82.8199L69.592 93.7125L81.1825 57.5863L47.2412 46.6938L35.6508 82.8199Z'
      fill='#FBFAFE'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M70.0939 58.3253C69.9479 58.3253 69.8019 58.3025 69.656 58.2568C69.2956 58.1382 68.9991 57.8874 68.8258 57.5498C68.6525 57.2123 68.6205 56.8246 68.7346 56.4642C68.8532 56.0993 69.104 55.8028 69.4416 55.6295C69.7791 55.4561 70.1669 55.4242 70.5272 55.5383C70.8921 55.6568 71.1886 55.9077 71.3619 56.2453C71.5353 56.5828 71.5672 56.9705 71.4532 57.3354C71.3346 57.6958 71.0837 57.9923 70.7461 58.1656C70.5409 58.2705 70.3174 58.3253 70.0939 58.3253ZM70.0939 55.6979C69.9023 55.6979 69.7198 55.7435 69.5465 55.8347C69.2591 55.9807 69.0493 56.227 68.9535 56.5326C68.8532 56.8382 68.8805 57.1621 69.0265 57.4449C69.1725 57.7323 69.4233 57.9421 69.729 58.0379C70.03 58.1382 70.3584 58.1109 70.6412 57.9649C70.924 57.8189 71.1384 57.5681 71.2342 57.2625C71.33 56.9614 71.3072 56.633 71.1612 56.3502C71.0107 56.0674 70.7644 55.853 70.4588 55.7572C70.3402 55.7207 70.217 55.6979 70.0939 55.6979Z'
      fill='#101828'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M56.6605 54.0147C56.519 54.0147 56.3731 53.9919 56.2271 53.9463C55.4791 53.7046 55.064 52.9018 55.3057 52.1537C55.5429 51.4056 56.3503 50.9905 57.0983 51.2323C57.4587 51.3463 57.7552 51.5972 57.9331 51.9347C58.1064 52.2769 58.1383 52.66 58.0197 53.0249C57.8282 53.627 57.2626 54.0147 56.6605 54.0147ZM55.5201 52.2221C55.3194 52.8516 55.6661 53.5267 56.2955 53.7274C56.925 53.9326 57.6001 53.586 57.8054 52.9565C57.9011 52.6509 57.8738 52.327 57.7278 52.0397C57.5819 51.7569 57.331 51.547 57.0299 51.4467C56.4005 51.246 55.7254 51.5926 55.5201 52.2221Z'
      fill='#101828'
    />
    <path
      d='M70.1576 56.8153C70.1454 56.8153 70.1333 56.8138 70.1211 56.8108C70.0618 56.7925 70.0299 56.7287 70.0481 56.6694L71.8043 51.1957C72.3699 49.4305 72.2148 47.5512 71.3664 45.9045C70.5179 44.2533 69.0811 43.0354 67.3158 42.4698C63.6713 41.2975 59.7576 43.3136 58.5899 46.9536L56.8338 52.4273C56.8155 52.4866 56.7517 52.5231 56.6924 52.5003C56.6285 52.482 56.5966 52.4182 56.6148 52.3589L58.371 46.8852C59.5797 43.1221 63.6211 41.0421 67.3843 42.2508C71.1474 43.4596 73.2274 47.501 72.0186 51.2641L70.2625 56.7378C70.2488 56.788 70.2032 56.8153 70.1576 56.8153Z'
      fill='#101828'
    />
    <path
      d='M51.9806 53.8687C51.9684 53.8687 51.9547 53.8657 51.9395 53.8596C51.8802 53.8368 51.8529 53.7683 51.8757 53.709C52.5873 51.9803 53.4858 50.9722 54.5578 50.7031C55.7848 50.3975 56.7564 51.1957 56.7974 51.2277C56.8476 51.2687 56.8522 51.3417 56.8111 51.3873C56.7746 51.4375 56.7016 51.442 56.6515 51.401C56.6378 51.3919 55.7209 50.6484 54.608 50.9266C53.6136 51.1729 52.7651 52.1399 52.0855 53.7957C52.0718 53.8413 52.0262 53.8687 51.9806 53.8687Z'
      fill='#101828'
    />
    <path
      d='M45.1522 64.4512L41.8224 61.614L48.888 53.3351L52.5964 52.3544L52.2132 56.1723L45.1522 64.4512Z'
      fill='#F9F9F9'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M45.1522 64.5652C45.1249 64.5652 45.0975 64.5561 45.0792 64.5379L41.7494 61.7007C41.7266 61.6824 41.7129 61.6551 41.7084 61.6231C41.7084 61.5958 41.7175 61.5638 41.7357 61.541L48.8013 53.2621C48.815 53.2439 48.8333 53.2302 48.8561 53.2256L52.569 52.2449C52.6055 52.2358 52.642 52.2449 52.6694 52.2677C52.7013 52.2905 52.715 52.327 52.7104 52.3681L52.3273 56.186C52.3273 56.2088 52.3182 56.227 52.2999 56.2453L45.2389 64.5287C45.2161 64.5515 45.1842 64.5652 45.1522 64.5652ZM41.9866 61.6003L45.1385 64.2915L52.1038 56.1267L52.4687 52.5049L48.9519 53.4354L41.9866 61.6003Z'
      fill='#101828'
    />
    <path
      d='M69.5921 93.8266C69.5647 93.8266 69.5328 93.8129 69.5146 93.7947L67.4528 91.7466H63.1149C63.0784 91.7466 63.0419 91.7283 63.0237 91.6964C63.0009 91.669 62.9963 91.628 63.01 91.5915L76.7261 56.1495C76.7489 56.0902 76.8128 56.0583 76.8721 56.0811C76.9314 56.1039 76.9587 56.1723 76.9359 56.2316L63.2837 91.5185H67.503C67.5304 91.5185 67.5623 91.5322 67.5805 91.5505L69.6742 93.6304C69.7198 93.6761 69.7198 93.749 69.6742 93.7901C69.6514 93.8129 69.624 93.8266 69.5921 93.8266Z'
      fill='#101828'
    />
    <path
      d='M67.5029 91.7465C67.4907 91.7465 67.4786 91.7449 67.4664 91.7419C67.4071 91.7237 67.3752 91.6598 67.3934 91.5959L74.7555 69.0855C74.7738 69.0216 74.8376 68.9897 74.8969 69.0125C74.9562 69.0308 74.9881 69.0946 74.9699 69.1539L67.6124 91.6689C67.5941 91.7191 67.5485 91.7465 67.5029 91.7465Z'
      fill='#101828'
    />
    <path
      d='M67.4391 78.7417L88.718 70.7867L80.2475 48.144L58.9731 56.099L67.4391 78.7417Z'
      fill='#F9F9F9'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M67.4436 78.8559C67.3934 78.8559 67.3524 78.8285 67.3341 78.7829L58.8682 56.1356C58.8591 56.1082 58.8591 56.0763 58.8727 56.0489C58.8819 56.0216 58.9047 55.9988 58.9366 55.9896L80.2109 48.0346C80.2702 48.0118 80.3341 48.0437 80.3569 48.103L88.8228 70.7457C88.8319 70.7731 88.8319 70.805 88.8182 70.8324C88.8091 70.8598 88.7863 70.8826 88.7544 70.8917L67.4801 78.8468C67.4679 78.8528 67.4557 78.8559 67.4436 78.8559ZM59.1191 56.163L67.5074 78.5959L88.5674 70.7184L80.1835 48.29L59.1191 56.163Z'
      fill='#101828'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M74.4316 53.1297C74.2948 53.1297 74.1625 53.0977 74.0394 53.043C73.8067 52.9381 73.6288 52.7465 73.5422 52.5093C73.3597 52.0212 73.606 51.4693 74.0987 51.2869C74.5913 51.1044 75.1387 51.3553 75.3211 51.8433C75.4123 52.0805 75.4032 52.3405 75.2937 52.5732C75.1888 52.8012 75.0018 52.9791 74.7646 53.0658C74.6552 53.1069 74.5411 53.1297 74.4316 53.1297ZM73.7566 52.4318C73.8934 52.8012 74.313 52.9928 74.6825 52.8514C74.865 52.7876 75.0064 52.6507 75.0885 52.4774C75.166 52.2995 75.1752 52.1033 75.1067 51.9255C74.9699 51.5514 74.5502 51.3598 74.1762 51.5012C73.8067 51.6381 73.6152 52.0577 73.7566 52.4318Z'
      fill='#101828'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M66.016 56.2771C65.6283 56.2771 65.2634 56.0399 65.122 55.6568C64.9395 55.1687 65.1904 54.6168 65.6785 54.4343C65.9156 54.3477 66.1756 54.3568 66.4083 54.4617C66.6363 54.5666 66.8142 54.7536 66.9009 54.9908C66.9921 55.228 66.983 55.488 66.8781 55.7206C66.7732 55.9487 66.5816 56.1266 66.3444 56.2133C66.2349 56.2543 66.1255 56.2771 66.016 56.2771ZM65.3364 55.5792C65.4778 55.9487 65.8928 56.1403 66.2669 56.0034C66.6364 55.862 66.8279 55.447 66.6911 55.0729C66.5497 54.6989 66.1346 54.5073 65.7606 54.6487C65.3865 54.7901 65.195 55.2052 65.3364 55.5792Z'
      fill='#101828'
    />
    <path
      d='M65.9657 55.3192C65.9201 55.3192 65.879 55.2873 65.8608 55.2417L64.579 51.8115C63.6896 49.4304 64.8983 46.7712 67.2794 45.8817C69.6604 44.9922 72.3197 46.2055 73.2092 48.5866L74.4909 52.0167C74.5137 52.076 74.4864 52.1399 74.4271 52.1627C74.3678 52.1855 74.2994 52.1536 74.2765 52.0943L72.9948 48.6641C72.5843 47.5694 71.7723 46.6982 70.7095 46.2147C69.6467 45.7266 68.4562 45.6855 67.3615 46.0961C65.099 46.9399 63.945 49.4715 64.7889 51.7339L66.0752 55.1641C66.098 55.2234 66.0661 55.2873 66.0068 55.3101C65.9946 55.3162 65.9809 55.3192 65.9657 55.3192Z'
      fill='#101828'
    />
    <path
      d='M64.6019 57.5861C64.5518 57.5861 64.5107 57.5542 64.4925 57.5086C64.0956 56.3728 64.1047 55.497 64.5107 54.904C64.9805 54.2244 65.797 54.1925 65.8335 54.1925C65.8974 54.1925 65.9475 54.2381 65.9521 54.3019C65.9521 54.3658 65.9019 54.4205 65.8381 54.4205C65.8289 54.4205 65.0946 54.4525 64.6977 55.0363C64.3328 55.5655 64.3374 56.3683 64.7068 57.4356C64.7297 57.4949 64.6977 57.5588 64.6384 57.577C64.6263 57.5831 64.6141 57.5861 64.6019 57.5861Z'
      fill='#101828'
    />
    <path
      d='M65.8518 65.4636L63.0648 65.5092L62.9462 58.5759L64.3055 56.5461L65.7332 58.5303L65.8518 65.4636Z'
      fill='#101828'
    />
    <path
      d='M84.7496 72.3833C84.7435 72.3833 84.7359 72.3833 84.7268 72.3833C84.6857 72.3742 84.6538 72.3469 84.6401 72.3058C84.3299 71.3844 77.05 49.7269 76.9542 49.362C76.9405 49.2982 76.977 49.2389 77.0363 49.2206C77.0956 49.2069 77.1594 49.2434 77.1731 49.3027C77.2598 49.6448 84.0426 69.8198 84.7906 72.0367L86.3506 70.1255C86.378 70.089 86.4236 70.0753 86.4647 70.0844L88.7454 70.6774C88.8047 70.6911 88.8411 70.7549 88.8275 70.8142C88.8092 70.8735 88.7499 70.91 88.6861 70.8963L86.4783 70.3262L84.8362 72.3423C84.8134 72.3697 84.7815 72.3833 84.7496 72.3833Z'
      fill='#101828'
    />
    <path
      d='M86.4373 70.308C86.3917 70.308 86.3461 70.2806 86.3278 70.235L82.0264 58.1564C82.0036 58.0971 82.0356 58.0333 82.0949 58.0105C82.1542 57.9877 82.218 58.0196 82.2408 58.0789L86.5422 70.1575C86.565 70.2168 86.5331 70.2806 86.4738 70.3034C86.4616 70.3095 86.4495 70.311 86.4373 70.308Z'
      fill='#101828'
    />
    <circle cx='77.9487' cy='24.0037' r='2.63397' fill='#F7F39F' />
    <circle cx='165.199' cy='50.6725' r='2.63397' fill='#FFB3CB' />
    <circle cx='94.997' cy='94.1315' r='2.63397' fill='#FFB3CB' />
    <path
      d='M35.748 20.3484L36.8544 23.7535H40.4347L37.5382 25.858L38.6446 29.263L35.748 27.1586L32.8515 29.263L33.9579 25.858L31.0614 23.7535H34.6417L35.748 20.3484Z'
      fill='#00F7EF'
    />
    <path
      d='M168.854 122.148L169.961 125.553H173.541L170.645 127.657L171.751 131.062L168.854 128.958L165.958 131.062L167.064 127.657L164.168 125.553H167.748L168.854 122.148Z'
      fill='#00F7EF'
    />
  </svg>
);

export const ManagePromotionBanner = (
  <svg
    width='210'
    height='150'
    viewBox='0 0 210 150'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <rect
      x='0.337109'
      y='0.3'
      width='209.338'
      height='149.4'
      rx='3.7'
      fill='#8E76D7'
      stroke='#8E76D7'
      strokeWidth='0.6'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M183.537 32.7681C183.531 32.7681 183.525 32.7667 183.52 32.7639C183.474 32.7598 183.436 32.718 183.432 32.668L182.961 24.7572L176.848 29.8057C176.811 29.8349 176.757 29.8391 176.719 29.8099C176.681 29.7765 176.669 29.7264 176.686 29.6806L179.944 22.4582L172.188 24.0854C172.138 24.0979 172.092 24.0729 172.071 24.027C172.05 23.9853 172.063 23.931 172.1 23.9018L178.342 19.016L170.719 16.8547C170.669 16.8422 170.64 16.7963 170.64 16.7504C170.644 16.7003 170.677 16.6628 170.727 16.6503L178.521 15.2275L172.776 9.77002C172.743 9.73664 172.734 9.6824 172.759 9.64068C172.784 9.59895 172.834 9.57809 172.88 9.59478L180.445 11.9563L177.891 4.45443C177.875 4.40853 177.896 4.35429 177.937 4.32925C177.975 4.30422 178.029 4.31256 178.067 4.34594L183.666 9.9536L184.893 2.12207C184.901 2.07618 184.939 2.03863 184.989 2.03445C185.039 2.03028 185.08 2.05949 185.097 2.10538L187.45 9.67406L192.173 3.3112C192.203 3.27365 192.257 3.26113 192.299 3.27782C192.344 3.29868 192.37 3.34458 192.361 3.39464L190.93 11.1886L198.069 7.75059C198.115 7.72973 198.165 7.74225 198.198 7.7798C198.228 7.81735 198.228 7.87159 198.198 7.90914L193.304 14.1427L201.227 14.418C201.278 14.4222 201.315 14.4556 201.328 14.5015C201.336 14.5516 201.311 14.5974 201.265 14.6183L194.038 17.8686L200.923 21.7906C200.965 21.8156 200.985 21.8657 200.973 21.9116C200.956 21.9575 200.915 21.9867 200.864 21.9867L192.954 21.5027L197.23 28.1785C197.255 28.2202 197.251 28.2703 197.218 28.3078C197.18 28.3412 197.13 28.3496 197.088 28.3245L190.308 24.2189L190.988 32.1172C190.993 32.1631 190.963 32.209 190.918 32.2257C190.872 32.2382 190.822 32.2215 190.797 32.1798L186.699 25.3955L183.633 32.7013C183.616 32.7431 183.578 32.7681 183.537 32.7681ZM183.053 24.4442C183.067 24.4442 183.08 24.447 183.094 24.4526C183.128 24.4651 183.153 24.5026 183.157 24.5402L183.616 32.209L186.587 25.1243C186.599 25.0868 186.637 25.0617 186.674 25.0617C186.712 25.0576 186.749 25.0784 186.77 25.1118L190.742 31.6875L190.079 24.0312C190.079 23.9936 190.096 23.9561 190.129 23.9352C190.162 23.9143 190.204 23.9143 190.237 23.9352L196.813 27.9115L192.67 21.4443C192.649 21.4109 192.645 21.3692 192.666 21.3358C192.687 21.2983 192.724 21.2816 192.762 21.2816L200.431 21.7489L193.755 17.9479C193.721 17.927 193.7 17.8894 193.705 17.8519C193.705 17.8102 193.73 17.7768 193.763 17.7601L200.773 14.61L193.095 14.3471C193.054 14.3429 193.02 14.3221 193.004 14.2845C192.987 14.2511 192.991 14.2094 193.016 14.176L197.756 8.13028L190.834 11.464C190.801 11.4807 190.759 11.4765 190.726 11.4557C190.696 11.4306 190.68 11.3931 190.688 11.3513L192.073 3.79519L187.496 9.96612C187.471 9.99533 187.434 10.012 187.392 10.0037C187.354 9.9995 187.325 9.97029 187.313 9.93274L185.03 2.59772L183.841 10.1873C183.833 10.2248 183.808 10.2582 183.77 10.2707C183.733 10.2832 183.691 10.2749 183.662 10.2457L178.234 4.80908L180.708 12.0815C180.72 12.1191 180.712 12.1608 180.683 12.19C180.658 12.2192 180.616 12.2275 180.578 12.215L173.243 9.92857L178.818 15.2191C178.843 15.2442 178.855 15.2859 178.843 15.3234C178.834 15.361 178.801 15.3902 178.763 15.3944L171.207 16.7754L178.597 18.87C178.634 18.8825 178.663 18.9117 178.672 18.9534C178.68 18.9909 178.663 19.0285 178.634 19.0535L172.584 23.7892L180.103 22.2078C180.14 22.2037 180.178 22.2162 180.203 22.2454C180.228 22.2788 180.232 22.3205 180.22 22.3539L177.061 29.3593L182.986 24.4651C183.003 24.4526 183.028 24.4442 183.053 24.4442Z'
      fill='#F0EDFA'
    />
    <path
      d='M209.962 46.7681C200.583 46.1631 190.327 43.3342 179.483 38.3607C170.809 34.3845 161.738 29.0355 152.525 22.4599C144.327 16.6144 137.534 10.8565 133.274 7.05964C128.664 2.94569 125.951 0.175239 125.926 0.146033L126.072 0C126.102 0.0292066 128.81 2.79549 133.416 6.90527C137.672 10.7021 144.46 16.4516 152.65 22.293C167.108 32.6112 188.787 45.1951 209.975 46.5594L209.962 46.7681Z'
      fill='#F0EDFA'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M32.7681 123.467C32.7681 123.462 32.7667 123.456 32.7639 123.451C32.7598 123.405 32.718 123.367 32.668 123.363L24.7572 122.891L29.8057 116.779C29.8349 116.741 29.8391 116.687 29.8099 116.65C29.7765 116.612 29.7264 116.6 29.6806 116.616L22.4582 119.875L24.0854 112.118C24.0979 112.068 24.0729 112.022 24.027 112.002C23.9853 111.981 23.931 111.993 23.9018 112.031L19.016 118.273L16.8547 110.65C16.8422 110.6 16.7963 110.57 16.7504 110.57C16.7003 110.575 16.6628 110.608 16.6503 110.658L15.2275 118.452L9.77002 112.707C9.73664 112.673 9.6824 112.665 9.64068 112.69C9.59895 112.715 9.57809 112.765 9.59478 112.811L11.9563 120.376L4.45443 117.822C4.40853 117.805 4.35429 117.826 4.32925 117.868C4.30422 117.906 4.31256 117.96 4.34594 117.997L9.9536 123.597L2.12207 124.823C2.07618 124.832 2.03862 124.869 2.03445 124.919C2.03028 124.969 2.05949 125.011 2.10538 125.028L9.67405 127.381L3.3112 132.104C3.27364 132.133 3.26113 132.188 3.27782 132.229C3.29868 132.275 3.34457 132.3 3.39464 132.292L11.1886 130.861L7.75059 138C7.72973 138.046 7.74225 138.096 7.7798 138.129C7.81735 138.158 7.87159 138.158 7.90914 138.129L14.1427 133.235L14.418 141.158C14.4222 141.208 14.4556 141.246 14.5015 141.258C14.5516 141.267 14.5974 141.242 14.6183 141.196L17.8686 133.969L21.7906 140.854C21.8156 140.895 21.8657 140.916 21.9116 140.904C21.9575 140.887 21.9867 140.845 21.9867 140.795L21.5027 132.884L28.1785 137.161C28.2202 137.186 28.2703 137.182 28.3078 137.148C28.3412 137.111 28.3496 137.061 28.3245 137.019L24.2189 130.239L32.1172 130.919C32.1631 130.923 32.209 130.894 32.2257 130.848C32.2382 130.802 32.2215 130.752 32.1798 130.727L25.3955 126.63L32.7013 123.563C32.7431 123.547 32.7681 123.509 32.7681 123.467ZM24.4442 122.983C24.4442 122.997 24.447 123.011 24.4526 123.025C24.4651 123.058 24.5026 123.083 24.5402 123.088L32.209 123.547L25.1243 126.517C25.0868 126.53 25.0617 126.567 25.0617 126.605C25.0576 126.642 25.0784 126.68 25.1118 126.701L31.6875 130.673L24.0312 130.01C23.9936 130.01 23.9561 130.026 23.9352 130.06C23.9143 130.093 23.9143 130.135 23.9352 130.168L27.9115 136.744L21.4443 132.601C21.4109 132.58 21.3692 132.576 21.3358 132.596C21.2983 132.617 21.2816 132.655 21.2816 132.692L21.7489 140.361L17.9479 133.685C17.927 133.652 17.8894 133.631 17.8519 133.635C17.8102 133.635 17.7768 133.66 17.7601 133.694L14.61 140.703L14.3471 133.026C14.3429 132.984 14.3221 132.951 14.2845 132.934C14.2511 132.918 14.2094 132.922 14.176 132.947L8.13028 137.687L11.464 130.765C11.4807 130.731 11.4765 130.69 11.4557 130.656C11.4306 130.627 11.3931 130.61 11.3513 130.619L3.79519 132.004L9.96612 127.427C9.99533 127.402 10.012 127.364 10.0037 127.323C9.9995 127.285 9.97029 127.256 9.93274 127.243L2.59772 124.961L10.1873 123.772C10.2248 123.764 10.2582 123.738 10.2707 123.701C10.2832 123.663 10.2749 123.622 10.2457 123.592L4.80908 118.164L12.0815 120.638C12.1191 120.651 12.1608 120.643 12.19 120.613C12.2192 120.588 12.2275 120.547 12.215 120.509L9.92857 113.174L15.2191 118.748C15.2442 118.773 15.2859 118.786 15.3234 118.773C15.361 118.765 15.3902 118.732 15.3944 118.694L16.7754 111.138L18.87 118.527C18.8825 118.565 18.9117 118.594 18.9534 118.602C18.9909 118.611 19.0285 118.594 19.0535 118.565L23.7892 112.515L22.2078 120.033C22.2037 120.071 22.2162 120.109 22.2454 120.134C22.2788 120.159 22.3205 120.163 22.3539 120.15L29.3593 116.992L24.4651 122.917C24.4526 122.933 24.4442 122.958 24.4442 122.983Z'
      fill='#F0EDFA'
    />
    <path
      d='M46.7681 149.893C46.1631 140.513 43.3342 130.258 38.3607 119.414C34.3845 110.739 29.0355 101.669 22.4598 92.456C16.6144 84.2573 10.8565 77.4646 7.05964 73.2047C2.94569 68.5942 0.175239 65.8822 0.146033 65.8571L-6.3833e-09 66.0031C0.0292066 66.0324 2.79549 68.7402 6.90527 73.3465C10.7021 77.6023 16.4516 84.3908 22.293 92.5811C32.6112 107.038 45.1951 128.718 46.5594 149.905L46.7681 149.893Z'
      fill='#F0EDFA'
    />
    <circle cx='69.9347' cy='25.9627' r='2.63397' fill='#F7F39F' />
    <circle cx='171.564' cy='51.2213' r='2.63397' fill='#FFB3CB' />
    <circle cx='94.9969' cy='94.1315' r='2.63397' fill='#FFB3CB' />
    <path
      d='M35.748 20.3484L36.8544 23.7535H40.4347L37.5381 25.858L38.6445 29.263L35.748 27.1586L32.8515 29.263L33.9578 25.858L31.0613 23.7535H34.6416L35.748 20.3484Z'
      fill='#00F7EF'
    />
    <path
      d='M168.854 122.148L169.961 125.553H173.541L170.645 127.657L171.751 131.062L168.854 128.958L165.958 131.062L167.064 127.657L164.168 125.553H167.748L168.854 122.148Z'
      fill='#00F7EF'
    />
    <path
      d='M28.6616 125.922L29.1728 123.217L29.6841 120.426L48.0468 112.906L28.6616 125.922Z'
      fill='#00F7EF'
    />
    <path
      d='M34.2152 106.09L51.7685 99.1237L36.4946 111.373L34.2152 106.09Z'
      fill='url(#paint0_linear_11031_102031)'
    />
    <path
      d='M50.0639 120.128L47.6567 119.979L51.832 109.434L53.6214 120.341L50.0639 120.128Z'
      fill='url(#paint1_linear_11031_102031)'
    />
    <path
      d='M161.149 57.2478C161.082 55.7162 148.94 35.1393 147.209 32.631C145.499 30.1227 145.499 33.075 145.499 33.075C144.723 36.7819 142.037 41.6653 136.199 46.349C135.2 47.1481 134.112 47.925 132.958 48.7019C133.387 49.1458 133.779 49.6194 134.134 50.1225C136.376 53.3189 137.93 57.159 138.485 61.0658C139.972 60.3999 141.46 59.7339 142.902 59.1346C152.181 55.2279 159.55 58.5797 159.55 58.5797C160.66 59.0014 161.215 58.7795 161.149 57.2478Z'
      fill='url(#paint2_linear_11031_102031)'
    />
    <g opacity='0.4'>
      <path
        d='M135.733 46.7041C134.867 47.3701 133.935 48.036 132.958 48.7019C133.387 49.1458 133.779 49.6194 134.134 50.1225C136.376 53.3189 137.93 57.1591 138.485 61.0658C139.491 60.607 140.498 60.1631 141.504 59.7339C141.526 54.8505 139.329 50.0115 135.733 46.7041Z'
        fill='#182028'
      />
    </g>
    <path
      d='M152.403 49.3678C152.403 49.3678 143.79 53.3189 137.375 56.4931C137.775 57.6696 138.108 58.8682 138.33 60.0669C152.625 53.7407 157.597 57.381 157.597 57.381L152.403 49.3678Z'
      fill='url(#paint3_linear_11031_102031)'
    />
    <path
      d='M156.354 43.4633C160.816 51.8317 163.368 59.2012 162.037 59.9115C160.705 60.5996 156.021 54.4066 151.537 46.0382C147.076 37.6698 144.523 30.3003 145.855 29.59C147.164 28.8797 151.87 35.0949 156.354 43.4633Z'
      fill='url(#paint4_linear_11031_102031)'
    />
    <path
      d='M136.687 54.6951L138.907 53.5186L136.487 48.9904C135.792 49.5231 135.082 49.9967 134.357 50.411C135.244 51.765 136.044 53.1857 136.687 54.6951Z'
      fill='url(#paint5_linear_11031_102031)'
    />
    <path
      style={{ mixBlendMode: 'overlay' }}
      d='M135.4 46.9483L136.487 48.9904C141.548 45.1725 145.677 38.6465 146.254 34.1182L145.588 32.298C145.574 32.3424 145.566 32.3868 145.566 32.4312C145.566 32.4312 145.566 32.4386 145.566 32.4534C145.551 32.4978 145.544 32.5348 145.544 32.5644C145.544 32.5792 145.544 32.5866 145.544 32.5866C145.544 32.6162 145.537 32.6532 145.522 32.6976C145.522 32.6976 145.522 32.705 145.522 32.7198C145.522 32.7494 145.522 32.7864 145.522 32.8308C145.522 32.8604 145.522 32.89 145.522 32.9196C145.507 32.9788 145.5 33.0231 145.5 33.0527C145.5 33.0675 145.5 33.0749 145.5 33.0749C145.426 33.4153 145.337 33.7705 145.233 34.1404C145.159 34.392 145.078 34.6435 144.989 34.8951C144.9 35.1467 144.804 35.4057 144.7 35.672C144.597 35.9236 144.486 36.1826 144.368 36.4489C144.308 36.5821 144.242 36.7153 144.168 36.8485C143.783 37.6624 143.309 38.4985 142.747 39.3568C142.658 39.49 142.562 39.6305 142.459 39.7785C142.163 40.2077 141.844 40.6368 141.504 41.066C141.164 41.4951 140.794 41.9317 140.394 42.3756C140.143 42.6716 139.876 42.9675 139.595 43.2635C139.299 43.5595 139.003 43.8554 138.707 44.1514C138.396 44.4326 138.078 44.7211 137.753 45.0171C137.264 45.461 136.746 45.905 136.199 46.3489C135.888 46.5857 135.57 46.8299 135.244 47.0814C135.304 47.037 135.355 46.9927 135.4 46.9483Z'
      fill='url(#paint6_linear_11031_102031)'
    />
    <path
      d='M134.134 50.1225C134.208 50.226 134.282 50.3222 134.356 50.411C135.082 49.9967 135.792 49.5231 136.487 48.9904L135.4 46.9482C135.355 46.9926 135.304 47.037 135.244 47.0814C135.141 47.1554 135.037 47.2294 134.934 47.3034C134.845 47.3774 134.763 47.444 134.689 47.5032C134.571 47.5772 134.46 47.6586 134.356 47.7473C134.268 47.8065 134.179 47.8657 134.09 47.9249C133.972 47.9989 133.861 48.0803 133.757 48.1691C133.668 48.2283 133.58 48.2875 133.491 48.3467C133.372 48.4207 133.254 48.5021 133.136 48.5908C133.076 48.6204 133.017 48.6574 132.958 48.7018C133.387 49.1458 133.779 49.6193 134.134 50.1225Z'
      fill='url(#paint7_linear_11031_102031)'
    />
    <path
      style={{ mixBlendMode: 'overlay' }}
      d='M134.134 50.1225C134.208 50.226 134.282 50.3222 134.356 50.411C135.082 49.9967 135.792 49.5231 136.487 48.9904L135.4 46.9482C135.355 46.9926 135.304 47.037 135.244 47.0814C135.141 47.1554 135.037 47.2294 134.934 47.3034C134.845 47.3774 134.763 47.444 134.689 47.5032C134.571 47.5772 134.46 47.6586 134.356 47.7473C134.268 47.8065 134.179 47.8657 134.09 47.9249C133.972 47.9989 133.861 48.0803 133.757 48.1691C133.668 48.2283 133.58 48.2875 133.491 48.3467C133.372 48.4207 133.254 48.5021 133.136 48.5908C133.076 48.6204 133.017 48.6574 132.958 48.7018C133.387 49.1458 133.779 49.6193 134.134 50.1225Z'
      fill='url(#paint8_linear_11031_102031)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M156.354 43.4633C157.05 44.7655 157.723 46.0826 158.374 47.4144C159.04 48.7463 159.684 50.0781 160.283 51.4321C160.882 52.7862 161.482 54.1624 161.948 55.5608C162.192 56.2711 162.414 57.0036 162.592 57.7362C162.658 58.1135 162.725 58.4909 162.747 58.8904C162.747 59.1124 162.747 59.3122 162.68 59.5341C162.636 59.7561 162.547 60.0669 162.214 60.2445C161.904 60.422 161.593 60.3554 161.371 60.2666C161.127 60.2001 160.949 60.0891 160.771 59.9781C160.416 59.7561 160.128 59.5119 159.839 59.2456C159.262 58.735 158.752 58.1801 158.263 57.603C157.286 56.4709 156.376 55.2723 155.511 54.0514C154.667 52.8084 153.846 51.5653 153.069 50.2779C152.3 49.0052 151.56 47.7104 150.849 46.3933C149.473 43.7519 148.163 41.066 147.076 38.2691C146.528 36.8781 146.055 35.4575 145.655 34.0072C145.455 33.2747 145.278 32.5422 145.167 31.7875C145.1 31.388 145.056 31.0106 145.078 30.5889C145.078 30.3891 145.078 30.1671 145.167 29.9451C145.211 29.7232 145.322 29.4124 145.655 29.2348C146.01 29.0794 146.299 29.1682 146.521 29.257C146.743 29.3236 146.898 29.4568 147.076 29.5678C147.409 29.8119 147.675 30.0783 147.941 30.3447C148.474 30.8996 148.963 31.4767 149.406 32.0761C150.317 33.2525 151.116 34.5178 151.915 35.7608C152.714 37.0039 153.446 38.2913 154.201 39.5788C154.941 40.8514 155.659 42.1463 156.354 43.4633ZM156.354 43.4633C155.644 42.1611 154.904 40.8736 154.134 39.601C153.38 38.3357 152.558 37.0927 151.737 35.8718C150.871 34.6732 149.984 33.4967 149.029 32.3868C148.541 31.8319 148.03 31.277 147.497 30.8108C147.231 30.5667 146.965 30.3225 146.676 30.1449C146.543 30.0783 146.388 29.9895 146.254 29.9451C146.143 29.9007 146.032 29.9229 146.032 29.9451C146.032 29.9451 145.966 30.0117 145.944 30.1449C145.921 30.2781 145.921 30.4335 145.921 30.5889C145.944 30.9218 146.01 31.277 146.077 31.6099C146.232 32.3202 146.432 33.0084 146.676 33.6965C147.142 35.0727 147.742 36.4045 148.319 37.7586C148.918 39.0904 149.562 40.4223 150.206 41.7319C150.849 43.0637 151.537 44.3734 152.226 45.6608C152.921 46.9631 153.631 48.2505 154.356 49.5232C155.089 50.7884 155.844 52.0758 156.621 53.2967C157.42 54.5397 158.219 55.7828 159.084 56.9371C159.528 57.5142 159.995 58.0691 160.483 58.5797C160.727 58.846 160.993 59.0902 161.238 59.29C161.371 59.3788 161.526 59.4675 161.637 59.5119C161.748 59.5563 161.859 59.5563 161.859 59.5563C161.881 59.5563 161.948 59.4897 161.97 59.3566C162.015 59.2234 162.037 59.068 162.037 58.8904C162.037 58.5575 162.015 58.2023 161.97 57.8471C161.859 57.1368 161.682 56.4265 161.482 55.7162C161.104 54.2956 160.616 52.8971 160.083 51.5209C159.528 50.1447 158.951 48.7684 158.33 47.4366C157.693 46.1048 157.035 44.7803 156.354 43.4633Z'
      fill='#192028'
    />
    <path
      d='M47.2308 91.4549C47.2947 92.9247 58.9685 112.693 60.6087 115.079C62.2703 117.486 62.249 114.675 62.249 114.675C63.0159 111.096 65.5722 106.431 71.1961 101.914C72.1334 101.169 73.1985 100.402 74.2849 99.6563C73.8731 99.2445 73.4968 98.7971 73.1559 98.3143C71.0044 95.2467 69.5345 91.5614 68.9806 87.8121C67.5534 88.4512 66.1474 89.069 64.7414 89.6655C55.837 93.3934 48.7646 90.1767 48.7646 90.1767C47.6994 89.7933 47.1669 89.985 47.2308 91.4549Z'
      fill='url(#paint9_linear_11031_102031)'
    />
    <path
      d='M55.6239 99.0385C55.6239 99.0385 63.8892 95.2467 70.0457 92.1791C69.6622 91.0714 69.364 89.9211 69.1297 88.7494C55.4109 94.8419 50.6391 91.3483 50.6391 91.3483L55.6239 99.0385Z'
      fill='url(#paint10_linear_11031_102031)'
    />
    <path
      d='M51.8536 104.684C47.5505 96.6527 45.1007 89.6015 46.3788 88.9199C47.657 88.2382 52.1731 94.2029 56.4549 102.234C60.7367 110.265 63.1865 117.316 61.9296 117.998C60.6515 118.679 56.1354 112.715 51.8536 104.684Z'
      fill='url(#paint11_linear_11031_102031)'
    />
    <path
      d='M70.7066 93.9047L68.5764 95.055L70.8983 99.3794C71.5658 98.8682 72.2546 98.4137 72.9647 98.0161C72.0913 96.7379 71.3244 95.3533 70.7066 93.9047Z'
      fill='url(#paint12_linear_11031_102031)'
    />
    <path
      style={{ mixBlendMode: 'overlay' }}
      d='M71.9416 101.339L70.8978 99.3794C66.0408 103.043 62.0999 109.306 61.5247 113.652L62.1638 115.42C62.1638 115.406 62.1638 115.399 62.1638 115.399C62.178 115.356 62.1851 115.321 62.1851 115.292C62.1851 115.278 62.1851 115.271 62.1851 115.271C62.1993 115.228 62.2064 115.186 62.2064 115.143C62.2206 115.101 62.2277 115.058 62.2277 115.015C62.2277 114.973 62.2277 114.937 62.2277 114.909C62.2277 114.866 62.2348 114.838 62.249 114.824C62.249 114.81 62.249 114.802 62.249 114.802C62.249 114.746 62.249 114.71 62.249 114.696C62.249 114.682 62.249 114.675 62.249 114.675C62.32 114.334 62.4052 113.986 62.5046 113.631C62.5756 113.404 62.6537 113.169 62.739 112.928C62.8242 112.672 62.9165 112.424 63.0159 112.182C63.1153 111.927 63.2218 111.671 63.3354 111.415C63.3922 111.288 63.4561 111.16 63.5272 111.032C63.8964 110.251 64.3508 109.455 64.8905 108.646C64.9899 108.504 65.0822 108.369 65.1674 108.241C65.4515 107.829 65.7568 107.41 66.0834 106.984C66.4243 106.573 66.7793 106.154 67.1486 105.728C67.4042 105.444 67.6669 105.167 67.9368 104.897C68.2066 104.613 68.4835 104.329 68.7676 104.045C69.0658 103.761 69.3711 103.477 69.6836 103.193C70.1664 102.767 70.6706 102.34 71.196 101.914C71.4801 101.687 71.7783 101.46 72.0908 101.233C72.0339 101.261 71.9842 101.297 71.9416 101.339Z'
      fill='url(#paint13_linear_11031_102031)'
    />
    <path
      d='M73.1563 98.3143C73.0852 98.2149 73.0213 98.1155 72.9645 98.0161C72.2544 98.4137 71.5657 98.8682 70.8982 99.3794L71.942 101.339C71.9846 101.297 72.0343 101.261 72.0911 101.233C72.1905 101.148 72.29 101.069 72.3894 100.998C72.4746 100.942 72.5598 100.885 72.645 100.828C72.7444 100.743 72.8509 100.665 72.9645 100.594C73.0355 100.537 73.1136 100.48 73.1989 100.423C73.3125 100.338 73.4261 100.26 73.5397 100.189C73.6107 100.132 73.6888 100.075 73.774 100.018C73.8876 99.9333 74.0013 99.8552 74.1149 99.7842C74.1717 99.7416 74.2285 99.699 74.2853 99.6563C73.8734 99.2445 73.4971 98.7971 73.1563 98.3143Z'
      fill='url(#paint14_linear_11031_102031)'
    />
    <path
      style={{ mixBlendMode: 'overlay' }}
      d='M73.1563 98.3143C73.0852 98.2149 73.0213 98.1155 72.9645 98.0161C72.2544 98.4137 71.5657 98.8682 70.8982 99.3794L71.942 101.339C71.9846 101.297 72.0343 101.261 72.0911 101.233C72.1905 101.148 72.29 101.069 72.3894 100.998C72.4746 100.942 72.5598 100.885 72.645 100.828C72.7444 100.743 72.8509 100.665 72.9645 100.594C73.0355 100.537 73.1136 100.48 73.1989 100.423C73.3125 100.338 73.4261 100.26 73.5397 100.189C73.6107 100.132 73.6888 100.075 73.774 100.018C73.8876 99.9333 74.0013 99.8552 74.1149 99.7842C74.1717 99.7416 74.2285 99.699 74.2853 99.6563C73.8734 99.2445 73.4971 98.7971 73.1563 98.3143Z'
      fill='url(#paint15_linear_11031_102031)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M51.8533 104.684C51.1716 103.434 50.5184 102.17 49.8935 100.892C49.2544 99.635 48.6366 98.3569 48.0615 97.0361C47.4863 95.7367 46.9324 94.4372 46.4638 93.0739C46.2295 92.3922 46.0164 91.7105 45.8673 90.9862C45.7821 90.6241 45.7182 90.2619 45.6969 89.8785C45.6969 89.6868 45.6969 89.4951 45.7608 89.2607C45.8034 89.0477 45.8886 88.7708 46.2082 88.5791C46.5277 88.4086 46.8259 88.4938 47.0177 88.5577C47.252 88.6217 47.4224 88.7282 47.5928 88.8347C47.9337 89.0477 48.2106 89.282 48.4875 89.5377C49.0414 90.0276 49.5313 90.5815 50 91.114C50.9586 92.2218 51.832 93.3508 52.6415 94.5438C53.451 95.7154 54.2392 96.9083 54.9848 98.1439C55.7233 99.3794 56.4333 100.622 57.115 101.872C58.4571 104.407 59.6926 106.984 60.7365 109.669C61.2619 111.003 61.7164 112.367 62.0998 113.759C62.2915 114.462 62.462 115.165 62.5898 115.91C62.6324 116.272 62.675 116.634 62.675 117.039C62.6537 117.252 62.6537 117.444 62.5898 117.678C62.5259 117.87 62.4193 118.168 62.0998 118.339C61.7803 118.488 61.482 118.403 61.2903 118.339C61.0773 118.253 60.9069 118.147 60.7365 118.04C60.4169 117.806 60.1613 117.55 59.9057 117.295C59.3944 116.762 58.947 116.208 58.4997 115.633C57.6476 114.483 56.8594 113.29 56.0925 112.097C55.3256 110.883 54.6226 109.647 53.8984 108.433C53.1883 107.197 52.5066 105.948 51.8533 104.684ZM51.8533 104.684C52.5208 105.933 53.2238 107.169 53.9623 108.39C54.6865 109.605 55.4747 110.798 56.2842 111.969C57.0937 113.141 57.9458 114.27 58.8831 115.335C59.3305 115.868 59.8204 116.379 60.3317 116.847C60.5873 117.082 60.843 117.295 61.1199 117.465C61.2477 117.55 61.3968 117.614 61.5246 117.657C61.6525 117.7 61.7377 117.7 61.7377 117.678C61.759 117.678 61.8016 117.593 61.8229 117.465C61.8442 117.359 61.8442 117.188 61.8442 117.039C61.8229 116.72 61.7803 116.4 61.6951 116.059C61.5459 115.399 61.3542 114.739 61.1199 114.078C60.6725 112.757 60.0974 111.458 59.5435 110.158C58.9683 108.88 58.3506 107.602 57.7328 106.345C57.115 105.067 56.4547 103.832 55.7943 102.575C55.141 101.325 54.4593 100.089 53.7492 98.8682C53.0463 97.6539 52.322 96.4397 51.5764 95.2467C50.8095 94.0538 50.0639 92.8821 49.2118 91.7531C48.7858 91.1993 48.3384 90.6667 47.8698 90.1767C47.6354 89.9424 47.4011 89.7081 47.1455 89.5164C47.0177 89.4311 46.8898 89.3459 46.762 89.3033C46.6555 89.2394 46.5703 89.2394 46.549 89.2394C46.549 89.2394 46.4851 89.3033 46.4425 89.4312C46.3999 89.559 46.3999 89.7294 46.3786 89.8785C46.3786 90.198 46.3999 90.5389 46.4638 90.8797C46.549 91.5614 46.7194 92.2644 46.9111 92.9248C47.2946 94.2881 47.7419 95.6302 48.2532 96.9722C48.7858 98.2717 49.3396 99.5924 49.9361 100.871C50.5468 102.163 51.1858 103.434 51.8533 104.684Z'
      fill='#192028'
    />
    <path
      d='M182.905 29.2872L182.061 31.9509L181.195 34.7033L161.817 39.9419L182.905 29.2872Z'
      fill='url(#paint16_linear_11031_102031)'
    />
    <path
      d='M175.155 45.1947L156.665 49.9893L173.535 39.6231L175.155 45.1947Z'
      fill='#F98CAE'
    />
    <path
      d='M161.015 29.1238L163.413 29.59L157.886 39.6676L157.442 28.4579L161.015 29.1238Z'
      fill='#00F7EF'
    />
    <g opacity='0.5'>
      <path
        d='M68.2224 87.0585C65.593 92.0158 66.6983 98.6815 70.8016 102.517C70.9858 102.701 71.2035 102.885 71.4547 102.952C71.8902 103.069 72.3424 102.801 72.7108 102.517C74.2516 101.294 75.1058 99.3514 75.4072 97.3919C75.7254 95.4492 75.5412 93.4562 75.357 91.4799C75.1672 89.3474 74.9718 87.2148 74.7708 85.0822C74.7541 84.8478 74.7206 84.5798 74.5196 84.4626C74.3521 84.3621 74.1511 84.3956 73.9669 84.4458C72.1358 84.8254 70.3047 85.2106 68.4736 85.6014'
        fill='#182028'
      />
    </g>
    <path
      d='M50.7763 71.5667L52.0826 70.3274L51.7812 68.5521L53.3722 69.4062L54.9633 68.5856L54.6451 70.3441L55.9179 71.6002L54.1426 71.8514L53.3387 73.4592L52.5516 71.8347L50.7763 71.5667Z'
      fill='white'
    />
    <path
      d='M93.2488 114.207L94.3039 113.185L94.0694 111.728L95.359 112.431L96.6653 111.745L96.4141 113.202L97.4525 114.24L95.9954 114.441L95.3423 115.748L94.6891 114.424L93.2488 114.207Z'
      fill='#00F7EF'
    />
    <path
      d='M130.848 118.31L131.836 117.372L131.618 116.032L132.807 116.669L134.013 116.049L133.779 117.389L134.733 118.344L133.393 118.528L132.791 119.734L132.188 118.511L130.848 118.31Z'
      fill='#00F7EF'
    />
    <path
      d='M118.873 125.88L119.844 124.942L119.627 123.602L120.816 124.239L122.022 123.619L121.787 124.959L122.758 125.914L121.402 126.098L120.799 127.304L120.213 126.081L118.873 125.88Z'
      fill='white'
    />
    <path
      d='M151.699 95.7841L152.369 95.1477L152.218 94.2266L153.039 94.662L153.859 94.2433L153.709 95.1477L154.362 95.8009L153.441 95.9348L153.022 96.7555L152.62 95.9348L151.699 95.7841Z'
      fill='#00F7EF'
    />
    <path
      d='M142.404 107.374L143.794 106.051L143.492 104.141L145.184 105.046L146.892 104.175L146.557 106.067L147.931 107.424L146.021 107.692L145.151 109.417L144.313 107.675L142.404 107.374Z'
      fill='white'
    />
    <path
      d='M123.194 28.4074L124.701 26.9671L124.367 24.8904L126.226 25.8785L128.085 24.9239L127.716 26.9839L129.207 28.4577L127.13 28.7424L126.175 30.6182L125.271 28.7256L123.194 28.4074Z'
      fill='white'
    />
    <path
      d='M105.693 26.6489L106.949 25.4431L106.664 23.7013L108.205 24.5387L109.762 23.7348L109.461 25.4598L110.7 26.6824L108.958 26.9169L108.171 28.4912L107.418 26.9169L105.693 26.6489Z'
      fill='#FFB3CB'
    />
    <path
      d='M132.003 40.5664L133.075 39.528L132.841 38.071L134.147 38.7744L135.47 38.0877L135.202 39.5448L136.257 40.5999L134.8 40.8009L134.13 42.124L133.477 40.7841L132.003 40.5664Z'
      fill='#FEEE00'
    />
    <path
      d='M69.4202 34.4779L70.559 33.3725L70.3078 31.8149L71.6979 32.5686L73.1047 31.8484L72.82 33.3892L73.9421 34.5113L72.3845 34.7291L71.6644 36.1359L70.9777 34.7123L69.4202 34.4779Z'
      fill='white'
    />
    <path
      d='M69.7349 49.9117L70.7733 48.9068L70.5388 47.4665L71.8284 48.1532L73.118 47.5L72.85 48.9236L73.8884 49.9452L72.4481 50.1294L71.7949 51.4358L71.1585 50.1294L69.7349 49.9117Z'
      fill='#FEEE00'
    />
    <path
      d='M53.322 49.9452L54.6618 48.6724L54.3603 46.8469L56.0016 47.7178L57.6429 46.8636L57.308 48.6891L58.631 49.9955L56.7888 50.2467L55.9681 51.9047L55.1475 50.2299L53.322 49.9452Z'
      fill='#00F7EF'
    />
    <path
      d='M46.4218 81.18L47.6109 80.0411L47.3429 78.4166L48.8 79.187L50.257 78.4333L49.9723 80.0579L51.1447 81.2135L49.5034 81.4312L48.7665 82.905L48.0463 81.4312L46.4218 81.18Z'
      fill='#FEEE00'
    />
    <path
      d='M55.4656 98.3465L56.102 97.7269L55.968 96.8392L56.7552 97.2747L57.5591 96.856L57.3916 97.7436L58.028 98.38L57.1404 98.4973L56.7384 99.3012L56.3532 98.4973L55.4656 98.3465Z'
      fill='#00F7EF'
    />
    <path
      d='M71.125 120.705L72.4816 119.415L72.1801 117.556L73.8382 118.444L75.5129 117.59L75.178 119.432L76.5011 120.755L74.6421 121.006L73.8047 122.681L72.984 120.99L71.125 120.705Z'
      fill='white'
    />
    <path
      d='M87.9733 125.746L89.2963 124.473L88.9949 122.664L90.6027 123.535L92.244 122.698L91.909 124.507L93.2153 125.796L91.4066 126.031L90.5859 127.672L89.782 126.031L87.9733 125.746Z'
      fill='#FFB3CB'
    />
    <path
      d='M151.527 65.4998L152.532 64.5451L152.314 63.1718L153.537 63.825L154.76 63.2053L154.525 64.5619L155.497 65.5333L154.123 65.7342L153.504 66.9568L152.901 65.7175L151.527 65.4998Z'
      fill='white'
    />
    <path
      d='M155.635 78.9358L156.874 77.7467L156.606 76.0216L158.13 76.8423L159.671 76.0551L159.369 77.7634L160.592 78.986L158.884 79.2205L158.097 80.7613L157.343 79.2037L155.635 78.9358Z'
      fill='#00F7EF'
    />
    <path
      d='M95.4094 17.1864L73.2687 64.5493L124.417 59.8264L129.257 44.4352L97.7876 46.3109L95.4094 17.1864Z'
      fill='#8E76D7'
    />
    <path
      d='M94.505 21.6413L79.3147 56.6276L85.009 55.9744L94.505 21.6413Z'
      fill='white'
    />
    <path
      d='M104.956 132.814L127.113 90.3578L75.9484 95.0639L71.1082 110.472L102.577 108.596L104.956 132.814Z'
      fill='#8E76D7'
    />
    <path
      d='M119.158 104.275L106.061 127.89L114.703 104.979L119.158 104.275Z'
      fill='white'
    />
    <path
      d='M128.386 83.1227L67.9429 88.147C63.3205 88.5322 59.4684 84.3955 59.7029 79.3209L60.1886 64.6665C60.3896 60.3791 63.4879 56.8788 67.3902 56.5606L128.017 51.5195C132.64 51.1343 136.492 55.271 136.257 60.3456L135.587 75.0167C135.387 79.3209 132.288 82.8045 128.386 83.1227Z'
      fill='#101828'
      stroke='#FFFEE7'
      strokeWidth='5'
      strokeMiterlimit='10'
    />
    <path
      d='M126.192 79.6077L70.5723 83.577C66.3183 83.8952 62.7678 80.4116 62.9688 76.1577L63.5214 63.8815C63.6889 60.2807 66.5193 57.3665 70.1201 57.1153L125.757 53.1293C129.994 52.8279 133.561 56.2947 133.36 60.5486L132.791 72.8416C132.623 76.4424 129.793 79.3565 126.192 79.6077Z'
      fill='#FF004F'
    />
    <path
      d='M119.66 101.746L79.1473 104.962C74.4914 105.33 70.6059 101.277 70.8403 96.3033L71.1083 90.2405C71.3093 86.0201 74.4244 82.6035 78.3601 82.2853L118.873 79.0697C123.529 78.7013 127.415 82.7542 127.197 87.7283L126.912 93.8078C126.728 98.0115 123.613 101.428 119.66 101.746Z'
      fill='#101828'
      stroke='white'
      strokeWidth='5'
      strokeMiterlimit='10'
    />
    <path
      d='M117.835 98.8976L80.8722 101.544C76.635 101.845 73.0677 98.3617 73.2687 94.1245L73.5032 88.9326C73.6707 85.3318 76.5011 82.4177 80.1018 82.1665L117.064 79.5203C121.302 79.2189 124.869 82.6857 124.668 86.9396L124.433 92.1315C124.266 95.7323 121.436 98.6296 117.835 98.8976Z'
      fill='#14CCC6'
    />
    <path
      d='M126.483 35.1709C118.36 30.7662 109.082 29.0746 100.038 30.18C100.155 33.3453 100.322 36.5107 100.49 39.6593C107.926 38.5874 115.613 39.9608 122.262 43.6453C123.501 40.7646 124.925 37.9343 126.483 35.1709Z'
      fill='#29F1EB'
    />
    <path
      d='M147.881 67.7113C147.42 67.795 146.965 67.884 146.515 67.9782C146.31 68.0096 145.855 68.1195 145.62 68.1823C145.447 68.2294 145.478 68.2137 145.62 68.1823C145.777 68.1352 146.091 68.0724 146.624 67.9311C145.729 68.1509 144.835 68.355 143.94 68.5906C142.631 68.9255 141.333 69.3076 140.046 69.7367C140.14 70.0508 140.224 70.3648 140.297 70.6788C143.798 84.9512 137.267 99.3178 125.224 106.383C126.778 108.911 128.458 111.361 130.232 113.732C145.243 104.625 153.313 86.537 148.901 68.5749C148.817 68.2399 148.734 67.9049 148.65 67.57C148.388 67.6118 148.132 67.659 147.881 67.7113Z'
      fill='#FF75A0'
    />
    <path
      d='M122.903 61.1849L126.701 60.9194L125.236 72.3414L121.438 72.607L122.903 61.1849ZM117.93 72.8523L114.132 73.1178L115.597 61.6958L119.395 61.4302L117.93 72.8523ZM122.226 68.3798L118.219 68.66L118.628 65.4942L122.635 65.214L122.226 68.3798Z'
      fill='white'
    />
    <path
      d='M108.048 73.8021C107.382 73.8486 106.741 73.8449 106.122 73.7911C105.504 73.7373 104.937 73.6423 104.421 73.5059C103.914 73.358 103.471 73.1895 103.092 73.0005L104.36 70.098C104.795 70.3048 105.227 70.474 105.657 70.6057C106.097 70.7259 106.528 70.8089 106.952 70.8547C107.386 70.8998 107.813 70.9077 108.231 70.8785C108.564 70.8552 108.835 70.8093 109.046 70.7406C109.268 70.6712 109.429 70.5845 109.529 70.4804C109.64 70.3649 109.691 70.2428 109.682 70.114C109.67 69.9424 109.563 69.8097 109.363 69.7159C109.162 69.6221 108.898 69.5436 108.57 69.4803C108.253 69.4162 107.898 69.3547 107.506 69.2959C107.124 69.2256 106.735 69.1342 106.339 69.0218C105.942 68.8986 105.575 68.7356 105.237 68.5328C104.91 68.3293 104.638 68.0626 104.421 67.7328C104.204 67.403 104.078 66.9914 104.044 66.4979C103.984 65.6396 104.157 64.8783 104.563 64.2138C104.98 63.5486 105.601 63.0147 106.424 62.6122C107.258 62.1981 108.264 61.9498 109.445 61.8673C110.281 61.8088 111.065 61.8402 111.796 61.9616C112.537 62.0715 113.181 62.2637 113.728 62.538L112.554 65.4015C112.084 65.1541 111.576 64.9794 111.03 64.8774C110.494 64.7747 109.953 64.7425 109.406 64.7808C109.041 64.8063 108.738 64.8652 108.496 64.9576C108.254 65.0392 108.073 65.1435 107.952 65.2705C107.842 65.3968 107.792 65.5243 107.801 65.653C107.813 65.8247 107.92 65.9627 108.121 66.0672C108.322 66.161 108.586 66.2396 108.914 66.3029C109.241 66.3555 109.596 66.4169 109.978 66.4872C110.37 66.546 110.759 66.6321 111.144 66.7453C111.539 66.847 111.906 66.9993 112.243 67.202C112.58 67.3941 112.857 67.655 113.074 67.9848C113.291 68.3039 113.416 68.7102 113.45 69.2037C113.509 70.0405 113.33 70.7915 112.913 71.4567C112.495 72.1112 111.869 72.6454 111.036 73.0595C110.213 73.4728 109.217 73.7203 108.048 73.8021Z'
      fill='white'
    />
    <path
      d='M89.3682 74.8495L95.7576 63.0831L99.491 62.8221L102.95 73.8998L99.1683 74.1642L96.6849 64.7809L98.1654 64.6774L93.3751 74.5693L89.3682 74.8495ZM92.5459 72.6545L93.8673 69.813L99.0489 69.4507L99.6586 72.1571L92.5459 72.6545Z'
      fill='white'
    />
    <path
      d='M80.5021 75.4695L81.9673 64.0474L85.7651 63.7819L84.6893 72.2174L89.7745 71.8618L89.385 74.8484L80.5021 75.4695Z'
      fill='white'
    />
    <path
      d='M74.5211 69.387L79.4775 69.0404L79.0985 71.9454L74.1582 72.2908L74.5211 69.387ZM73.9436 75.9281L70.1458 76.1937L71.6111 64.7716L80.7675 64.1313L80.3885 67.0362L75.0298 67.411L73.9436 75.9281Z'
      fill='white'
    />
    <path
      d='M115.129 88.167L120.15 87.816L119.794 90.5899L114.773 90.941L115.129 88.167ZM114.829 92.4248L120.477 92.0299L120.098 94.9348L110.732 95.5897L112.197 84.1676L121.354 83.5273L120.975 86.4323L115.552 86.8115L114.829 92.4248Z'
      fill='white'
    />
    <path
      d='M100.8 96.2842L102.266 84.8621L106.063 84.5966L104.988 93.0321L110.073 92.6765L109.683 95.663L100.8 96.2842Z'
      fill='white'
    />
    <path
      d='M86.6126 97.2763L93.0021 85.5099L96.7354 85.2488L100.194 96.3266L96.4128 96.591L93.9293 87.2077L95.4098 87.1042L90.6196 96.9961L86.6126 97.2763ZM89.7903 95.0812L91.1117 92.2398L96.2934 91.8775L96.9031 94.5839L89.7903 95.0812Z'
      fill='white'
    />
    <path
      d='M81.7509 97.875C81.0858 97.9215 80.4441 97.9179 79.8258 97.8641C79.2075 97.8103 78.6403 97.7152 78.1241 97.5788C77.6178 97.4309 77.1748 97.2625 76.7951 97.0734L78.0637 94.171C78.4986 94.3777 78.9308 94.547 79.3605 94.6786C79.8001 94.7988 80.2318 94.8818 80.6554 94.9277C81.0898 94.9727 81.5162 94.9807 81.9346 94.9514C82.2671 94.9281 82.5388 94.8822 82.7496 94.8136C82.9712 94.7442 83.1322 94.6574 83.2327 94.5534C83.3432 94.4378 83.394 94.3157 83.385 94.187C83.373 94.0153 83.2667 93.8826 83.0661 93.7888C82.8655 93.6951 82.6012 93.6165 82.2734 93.5532C81.9563 93.4891 81.6016 93.4277 81.2094 93.3689C80.8272 93.2986 80.4381 93.2072 80.0421 93.0947C79.6454 92.9715 79.2782 92.8085 78.9406 92.6058C78.6138 92.4022 78.3418 92.1356 78.1247 91.8058C77.9076 91.476 77.7817 91.0643 77.7472 90.5708C77.6872 89.7126 77.8604 88.9512 78.2667 88.2868C78.6837 87.6215 79.304 87.0877 80.1275 86.6851C80.961 86.271 81.9678 86.0228 83.1479 85.9402C83.9847 85.8817 84.7685 85.9132 85.4993 86.0346C86.24 86.1445 86.8841 86.3366 87.4316 86.611L86.2573 89.4745C85.7872 89.227 85.2791 89.0523 84.7329 88.9504C84.1975 88.8477 83.6562 88.8155 83.1091 88.8537C82.7443 88.8792 82.4412 88.9382 82.1997 89.0305C81.9575 89.1121 81.7761 89.2164 81.6556 89.3435C81.5459 89.4697 81.4955 89.5972 81.5045 89.726C81.5165 89.8976 81.6232 90.0357 81.8245 90.1402C82.0251 90.234 82.2894 90.3125 82.6172 90.3758C82.9443 90.4284 83.299 90.4899 83.6812 90.5602C84.0734 90.619 84.4621 90.705 84.8474 90.8182C85.2426 90.9199 85.609 91.0722 85.9466 91.275C86.2834 91.467 86.5604 91.728 86.7775 92.0578C86.9939 92.3768 87.1193 92.7831 87.1538 93.2766C87.2123 94.1134 87.0331 94.8644 86.616 95.5296C86.1982 96.1841 85.5726 96.7184 84.7391 97.1324C83.9163 97.5457 82.9203 97.7932 81.7509 97.875Z'
      fill='white'
    />
    <defs>
      <linearGradient
        id='paint0_linear_11031_102031'
        x1='54.2941'
        y1='73.0748'
        x2='14.8404'
        y2='100.416'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#E0A500' />
        <stop offset='1' stopColor='#FEEE00' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_11031_102031'
        x1='66.9008'
        y1='100.301'
        x2='29.7926'
        y2='126.016'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#E0A500' />
        <stop offset='1' stopColor='#FEEE00' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_11031_102031'
        x1='156.493'
        y1='25.6642'
        x2='173.411'
        y2='52.0241'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.006' stopColor='#F7F39F' />
        <stop offset='0.522' stopColor='#FFFEFC' />
        <stop offset='1' stopColor='#FFFCBC' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_11031_102031'
        x1='146.66'
        y1='66.7636'
        x2='143.355'
        y2='57.4281'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#211915' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint4_linear_11031_102031'
        x1='159.598'
        y1='23.3791'
        x2='178.729'
        y2='40.6556'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.006' stopColor='#F7F39F' />
        <stop offset='0.522' stopColor='#FFFEFC' />
        <stop offset='1' stopColor='#FFFCBC' />
      </linearGradient>
      <linearGradient
        id='paint5_linear_11031_102031'
        x1='111.864'
        y1='42.3183'
        x2='131.527'
        y2='45.7474'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='#BF0811' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint6_linear_11031_102031'
        x1='140.725'
        y1='33.2923'
        x2='147.363'
        y2='43.6342'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.006' stopColor='#E9EBEE' />
        <stop offset='0.522' stopColor='#FFFEFC' />
        <stop offset='1' stopColor='#9E9E9E' />
      </linearGradient>
      <linearGradient
        id='paint7_linear_11031_102031'
        x1='110.028'
        y1='42.7791'
        x2='131.221'
        y2='46.4748'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='#BF0811' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint8_linear_11031_102031'
        x1='130.354'
        y1='39.8136'
        x2='136.454'
        y2='49.3182'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.006' stopColor='#E9EBEE' />
        <stop offset='0.522' stopColor='#FFFEFC' />
        <stop offset='1' stopColor='#9E9E9E' />
      </linearGradient>
      <linearGradient
        id='paint9_linear_11031_102031'
        x1='69.8116'
        y1='82.0991'
        x2='86.0342'
        y2='107.39'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.006' stopColor='#F7F39F' />
        <stop offset='0.522' stopColor='#FFFEFC' />
        <stop offset='1' stopColor='#FFFCBC' />
      </linearGradient>
      <linearGradient
        id='paint10_linear_11031_102031'
        x1='61.1387'
        y1='82.331'
        x2='64.3106'
        y2='91.2902'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#211915' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint11_linear_11031_102031'
        x1='59.5778'
        y1='82.963'
        x2='77.929'
        y2='99.5573'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.006' stopColor='#F7F39F' />
        <stop offset='0.522' stopColor='#FFFEFC' />
        <stop offset='1' stopColor='#FFFCBC' />
      </linearGradient>
      <linearGradient
        id='paint12_linear_11031_102031'
        x1='94.5328'
        y1='105.791'
        x2='75.6622'
        y2='102.5'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='#BF0811' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint13_linear_11031_102031'
        x1='66.8344'
        y1='114.453'
        x2='60.4643'
        y2='104.528'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.006' stopColor='#E9EBEE' />
        <stop offset='0.522' stopColor='#FFFEFC' />
        <stop offset='1' stopColor='#9E9E9E' />
      </linearGradient>
      <linearGradient
        id='paint14_linear_11031_102031'
        x1='96.2937'
        y1='105.349'
        x2='75.9554'
        y2='101.802'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' />
        <stop offset='1' stopColor='#BF0811' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint15_linear_11031_102031'
        x1='76.7879'
        y1='108.195'
        x2='70.9336'
        y2='99.0731'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0.006' stopColor='#E9EBEE' />
        <stop offset='0.522' stopColor='#FFFEFC' />
        <stop offset='1' stopColor='#9E9E9E' />
      </linearGradient>
      <linearGradient
        id='paint16_linear_11031_102031'
        x1='132.846'
        y1='43.9239'
        x2='183.13'
        y2='43.8086'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#E0A500' />
        <stop offset='1' stopColor='#FEEE00' />
      </linearGradient>
    </defs>
  </svg>
);
export const TiktokAwardIcon = (
  <svg
    width='200'
    viewBox='0 0 200 50'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M46.5 42.6C46.2 42.4 45.9 42.2 45.5 42.1C45.1 42 44.8 41.9 44.4 41.9C44 41.9 43.7 41.9 43.4 41.9C43.1 41.9 42.8 42 42.7 42C42.6 42 42.5 42 42.5 42.1C42.4 42.1 42.4 42.1 42.4 42.1C42.4 42.1 42.5 42.5 42.7 43.1C43 43.6 43.4 44.2 44.2 44.5C45 44.8 45.9 44.7 46.6 44.6C46.9 44.5 47.2 44.4 47.4 44.3C47.6 44.2 47.7 44.1 47.7 44.1C47.7 44.1 47.5 43.7 47.1 43.3C47 43 46.8 42.8 46.5 42.6Z'
      fill='black'
    />
    <path
      d='M46.9 40.4C47.3 40.3 47.8 40.1 48.2 39.7C48.4 39.5 48.6 39.3 48.7 39C48.8 38.8 48.8 38.7 48.9 38.5C48.9 38.3 49 38.2 49 38C49 37.7 49 37.3 48.9 37.1C48.8 36.5 48.6 36.2 48.6 36.2C48.6 36.2 48.4 36.3 48.1 36.4C48 36.5 47.8 36.6 47.6 36.7C47.4 36.8 47.3 36.9 47.1 37.1C46.9 37.3 46.8 37.5 46.7 37.7C46.4 38.3 46.3 39 46.3 39.6C46.3 40.2 46.4 40.6 46.4 40.6C46.4 40.6 46.5 40.6 46.9 40.4Z'
      fill='black'
    />
    <path
      d='M42.7 41.4C42.9 41.4 43.1 41.4 43.4 41.3C43.7 41.2 44 41.2 44.3 41C44.6 40.8 44.9 40.6 45.1 40.3C45.3 40 45.5 39.7 45.5 39.4C45.6 39.1 45.6 38.7 45.6 38.5C45.6 37.9 45.5 37.5 45.5 37.5C45.5 37.5 45.4 37.5 45.3 37.5C45.2 37.5 44.9 37.6 44.7 37.6C44.2 37.7 43.7 38 43.3 38.5C42.9 39 42.7 39.7 42.5 40.3C42.4 40.9 42.4 41.3 42.4 41.3C42.4 41.3 42.4 41.3 42.5 41.3C42.5 41.4 42.6 41.4 42.7 41.4Z'
      fill='black'
    />
    <path
      d='M51.3 41.4C51.1 41.2 50.8 41 50.5 40.9C50.3 40.8 50.2 40.8 50 40.7C49.8 40.6 49.6 40.6 49.4 40.6C49.1 40.6 48.8 40.6 48.5 40.6C47.9 40.7 47.4 40.8 47 41C46.6 41.2 46.4 41.3 46.4 41.3C46.4 41.3 46.6 41.7 46.9 42.1C47.3 42.5 47.8 43 48.7 43.2C49 43.3 49.4 43.2 49.7 43.2C50 43.1 50.3 43 50.6 42.9C50.9 42.8 51.1 42.7 51.3 42.5C51.7 42.2 52 42 52 42C52 42 51.8 41.7 51.3 41.4Z'
      fill='black'
    />
    <path
      d='M52.9 38.3C52.1 38.3 51.5 38.7 51 39C50.5 39.3 50.1 39.6 50.1 39.6C50.1 39.6 50.4 40 50.8 40.3C51.3 40.7 51.9 41 52.8 41C53.2 41 53.6 40.8 54 40.7C54.4 40.5 54.7 40.3 55 40.1C55.5 39.6 55.9 39.2 55.9 39.2C55.9 39.2 55.6 38.9 55 38.7C54.4 38.4 53.7 38.2 52.9 38.3Z'
      fill='black'
    />
    <path
      d='M52 33.9C52 34.6 52.2 35.2 52.4 35.8C52.6 36.3 52.9 36.7 52.9 36.7C52.9 36.7 53.1 36.6 53.5 36.3C53.8 36 54.1 35.6 54.4 35.1C54.5 35 54.5 34.8 54.5 34.7C54.5 34.6 54.5 34.4 54.5 34.3C54.5 33.6 54.2 32.9 53.8 32.5C53.5 32.1 53.1 31.8 53.1 31.8C53.1 31.8 52.9 31.9 52.7 32.2C52.6 32.3 52.5 32.5 52.4 32.7C52.3 32.8 52.3 32.9 52.3 33C52.2 33.1 52.2 33.2 52.2 33.3C52 33.4 52 33.6 52 33.9Z'
      fill='black'
    />
    <path
      d='M50.4 34.7C50.2 34.9 50 35.1 49.9 35.3C49.7 35.5 49.6 35.8 49.5 36.1C49.3 36.7 49.4 37.4 49.5 38C49.6 38.6 49.8 39 49.8 39C49.8 39 50.2 38.9 50.7 38.5C51.2 38.2 51.7 37.6 51.9 36.9C52.1 36.2 51.8 35.5 51.6 35C51.4 34.5 51.1 34.1 51.1 34.1C51.1 34.1 50.7 34.3 50.4 34.7Z'
      fill='black'
    />
    <path
      d='M55.9 35.3C55.8 35.3 55.6 35.4 55.5 35.5C55.4 35.6 55.2 35.6 55.1 35.7C54.6 36 54.2 36.4 53.9 36.7C53.6 37 53.4 37.2 53.4 37.2C53.4 37.2 53.7 37.5 54.3 37.8C54.8 38.1 55.6 38.3 56.3 38C56.6 37.9 56.9 37.8 57.2 37.6C57.3 37.5 57.5 37.4 57.6 37.3C57.7 37.2 57.8 37.1 57.9 37C58.1 36.8 58.3 36.5 58.4 36.3C58.7 35.9 58.8 35.6 58.8 35.6C58.8 35.6 58.4 35.4 57.8 35.3C57.3 35.1 56.6 35 55.9 35.3Z'
      fill='black'
    />
    <path
      d='M58.1 31.7C57.8 31.9 57.5 32.1 57.3 32.4C57 32.7 56.8 32.9 56.7 33.2C56.5 33.5 56.4 33.7 56.3 33.9C56.2 34.1 56.2 34.2 56.2 34.2C56.2 34.2 56.6 34.4 57.2 34.6C57.8 34.7 58.5 34.8 59.2 34.4C59.6 34.2 59.9 33.9 60.2 33.6C60.5 33.3 60.7 32.9 60.8 32.6C61 32.3 61.1 32 61.1 31.8C61.2 31.6 61.2 31.5 61.2 31.5C61.2 31.5 60.8 31.4 60.2 31.4C59.5 31.3 58.7 31.4 58.1 31.7Z'
      fill='black'
    />
    <path
      d='M57.4 30.3C57.4 30.3 57.5 30.1 57.7 29.7C57.8 29.5 57.9 29.3 57.9 29C57.9 28.9 58 28.8 58 28.6C58 28.5 58 28.3 58 28.2C58 27.9 57.9 27.6 57.8 27.4C57.7 27.1 57.5 26.8 57.2 26.6C56.9 26.4 56.7 26.2 56.4 26.1C55.9 25.8 55.5 25.7 55.5 25.7C55.5 25.7 55.4 25.9 55.3 26.2C55.2 26.5 55.1 26.9 55.2 27.4C55.2 27.5 55.2 27.6 55.3 27.8C55.3 27.9 55.4 28 55.4 28.2C55.6 28.8 56.1 29.3 56.6 29.7C57 30.1 57.4 30.3 57.4 30.3Z'
      fill='black'
    />
    <path
      d='M55.5 33.7C55.5 33.7 55.6 33.6 55.7 33.5C55.8 33.4 56 33.1 56.1 32.9C56.2 32.6 56.4 32.3 56.5 32C56.6 31.7 56.6 31.3 56.5 31C56.4 30.3 55.9 29.8 55.5 29.4C55.1 29 54.7 28.8 54.7 28.8C54.7 28.8 54.6 28.9 54.6 29C54.5 29.1 54.4 29.3 54.3 29.5C54.2 29.7 54.1 30 54.1 30.3C54.1 30.6 54 30.9 54.1 31.2C54.2 31.8 54.6 32.5 54.9 32.9C55.2 33.4 55.5 33.7 55.5 33.7Z'
      fill='black'
    />
    <path
      d='M61.3 26.9C61 27 60.7 27.1 60.4 27.2C60.1 27.3 59.7 27.5 59.5 27.8C59.3 28 59.1 28.3 58.9 28.5C58.8 28.6 58.8 28.7 58.7 28.9C58.6 29 58.6 29.1 58.5 29.3C58.4 29.5 58.3 29.8 58.2 30C58.1 30.4 58 30.7 58 30.7C58 30.7 58.4 30.8 59 30.8C59.6 30.8 60.3 30.7 61 30.2C61.1 30.1 61.3 30 61.4 29.8C61.5 29.7 61.6 29.5 61.7 29.4C62 28.8 62.2 28.2 62.3 27.7C62.4 27.2 62.4 26.9 62.4 26.9C62.4 26.9 61.9 26.8 61.3 26.9Z'
      fill='black'
    />
    <path
      d='M62.7 22.4C62.7 22.2 62.6 22.1 62.6 22.1C62.6 22.1 62.2 22.2 61.6 22.4C61.3 22.5 61 22.7 60.8 22.9C60.7 23 60.5 23.1 60.4 23.2C60.3 23.3 60.1 23.5 60 23.6C59.8 23.9 59.6 24.2 59.5 24.6C59.4 24.8 59.4 24.9 59.4 25.1C59.4 25.3 59.3 25.4 59.3 25.6C59.2 26.2 59.2 26.7 59.2 26.7C59.2 26.7 59.6 26.7 60.2 26.6C60.8 26.5 61.5 26.2 62 25.6C62.5 25 62.6 24.1 62.7 23.4C62.7 23 62.7 22.7 62.7 22.4Z'
      fill='black'
    />
    <path
      d='M58.9 22C58.9 21.6 58.8 21.1 58.6 20.6C58.5 20.3 58.3 20.1 58.1 19.9C57.6 19.4 56.8 19.3 56.3 19.2C55.7 19.2 55.3 19.3 55.3 19.3C55.3 19.3 55.3 19.4 55.3 19.5C55.3 19.6 55.3 19.7 55.3 19.9C55.3 20.1 55.4 20.2 55.4 20.4C55.5 20.6 55.5 20.8 55.7 21C55.8 21.2 56 21.4 56.2 21.6C56.4 21.8 56.7 22 57 22.2C57.3 22.3 57.6 22.5 57.9 22.5C58.5 22.7 58.9 22.7 58.9 22.7C58.9 22.7 58.9 22.4 58.9 22Z'
      fill='black'
    />
    <path
      d='M58.7 25.5C58.7 25.4 58.7 25.2 58.7 25C58.7 24.8 58.7 24.7 58.6 24.5C58.5 24.2 58.4 23.8 58.2 23.5C58.1 23.4 58 23.2 57.9 23.1C57.8 23 57.6 22.9 57.5 22.8C57.2 22.6 56.9 22.5 56.6 22.5C56 22.4 55.6 22.3 55.6 22.3C55.6 22.3 55.5 22.7 55.5 23.1C55.5 23.6 55.6 24.2 56 24.7C56.3 25.2 56.9 25.6 57.5 25.9C58 26.2 58.4 26.3 58.4 26.3C58.4 26.3 58.7 26.1 58.7 25.5Z'
      fill='black'
    />
    <path
      d='M59.7 19.5C59.6 19.8 59.5 20.1 59.5 20.4C59.4 21 59.4 21.5 59.5 21.9C59.5 22.3 59.6 22.6 59.6 22.6C59.6 22.6 60 22.5 60.6 22.3C60.9 22.2 61.2 22 61.4 21.8C61.7 21.6 61.9 21.3 62.1 20.9C62.2 20.6 62.3 20.3 62.4 19.9C62.4 19.6 62.4 19.3 62.4 19C62.4 18.7 62.3 18.4 62.2 18.2C62.1 18 62 17.8 62 17.6C62 17.5 61.9 17.4 61.9 17.4C61.9 17.4 61.5 17.6 61 17.9C60.5 18.3 60 18.8 59.7 19.5Z'
      fill='black'
    />
    <path
      d='M58.4 16.6C58.4 17 58.5 17.3 58.6 17.6C58.7 17.9 58.8 18.1 58.8 18.3C58.9 18.5 58.9 18.6 58.9 18.6C58.9 18.6 59.3 18.5 59.8 18.1C60.3 17.8 60.8 17.2 61 16.4C61.2 15.6 61 14.7 60.7 14.1C60.6 13.8 60.4 13.5 60.3 13.3C60.2 13.1 60.1 13 60.1 13C60.1 13 59.7 13.3 59.4 13.7C59 14.1 58.6 14.8 58.5 15.5C58.4 15.9 58.4 16.3 58.4 16.6Z'
      fill='black'
    />
    <path
      d='M55.8 13.3C55.6 13.1 55.3 13 55 12.9C54.3 12.7 53.6 12.9 53.1 13.1C52.6 13.3 52.2 13.6 52.2 13.6C52.2 13.6 52.3 13.8 52.5 14.1C52.7 14.4 53 14.7 53.4 15C53.6 15.1 53.8 15.3 54.1 15.4C54.7 15.6 55.4 15.6 56 15.5C56.6 15.4 57 15.3 57 15.3C57 15.3 56.9 15 56.7 14.7C56.5 14.1 56.2 13.7 55.8 13.3Z'
      fill='black'
    />
    <path
      d='M55 16C54.4 16.1 54 16.3 54 16.3C54 16.3 54 16.4 54.1 16.5C54.2 16.6 54.2 16.8 54.3 17.1C54.5 17.5 54.8 18 55.4 18.4C55.9 18.7 56.7 18.9 57.2 18.9C57.8 18.9 58.2 18.9 58.2 18.9C58.2 18.9 58.2 18.8 58.2 18.6C58.2 18.4 58.1 18.2 58 17.9C57.9 17.6 57.8 17.3 57.6 17C57.4 16.7 57.2 16.5 56.8 16.3C56.3 15.8 55.5 15.9 55 16Z'
      fill='black'
    />
    <path
      d='M56.5 12.8C56.6 13.4 56.9 13.8 57.1 14.2C57.3 14.6 57.5 14.8 57.5 14.8C57.5 14.8 57.9 14.6 58.3 14.1C58.7 13.7 59.1 13 59.1 12.2C59.1 11.9 59 11.5 58.9 11.2C58.7 10.6 58.3 10 58 9.7C57.7 9.3 57.4 9.1 57.4 9.1C57.4 9.1 57.1 9.4 56.8 9.9C56.5 10.4 56.3 11.1 56.3 11.9C56.4 12.2 56.5 12.5 56.5 12.8Z'
      fill='black'
    />
    <path
      d='M54 9.8C54.2 10.1 54.4 10.4 54.6 10.6C55 11.1 55.3 11.4 55.3 11.4C55.3 11.4 55.6 11.1 55.9 10.6C56.2 10.1 56.4 9.4 56.3 8.6C56.1 7.8 55.6 7.1 55.1 6.6C54.6 6.1 54.1 5.9 54.1 5.9C54.1 5.9 53.9 6.3 53.7 6.8C53.5 7.4 53.4 8.1 53.6 8.8C53.7 9.1 53.9 9.5 54 9.8Z'
      fill='black'
    />
    <path
      d='M50.6 10.6C50.1 10.9 49.8 11.3 49.8 11.3C49.8 11.3 50 11.6 50.4 11.9C50.8 12.2 51.3 12.5 52 12.6C52.6 12.7 53.4 12.5 53.9 12.3C54.4 12.1 54.8 11.9 54.8 11.9C54.8 11.9 54.6 11.5 54.2 11.1C54 10.9 53.8 10.7 53.5 10.5C53.2 10.3 52.9 10.2 52.5 10.2C51.7 10 51.1 10.3 50.6 10.6Z'
      fill='black'
    />
    <path
      d='M49.3 8.5C49.7 8.7 50.1 9 50.5 9.1C50.9 9.2 51.3 9.3 51.6 9.4C52.3 9.5 52.8 9.5 52.8 9.5C52.8 9.5 52.8 9 52.7 8.3C52.6 7.6 52.2 6.8 51.5 6.2C50.7 5.6 49.7 5.4 48.9 5.4C48.1 5.4 47.5 5.5 47.5 5.5C47.5 5.5 47.6 6 47.9 6.6C48.1 7.2 48.6 8 49.3 8.5Z'
      fill='black'
    />
    <path
      d='M16.6 42.6C16.9 42.4 17.2 42.2 17.6 42.1C18 42 18.3 41.9 18.7 41.9C19.1 41.9 19.4 41.9 19.7 41.9C20 41.9 20.3 42 20.4 42C20.5 42 20.6 42 20.6 42.1C20.7 42.1 20.7 42.1 20.7 42.1C20.7 42.1 20.6 42.5 20.4 43.1C20.1 43.6 19.7 44.2 18.9 44.5C18.1 44.8 17.2 44.7 16.5 44.6C16.2 44.5 15.9 44.4 15.7 44.3C15.5 44.2 15.4 44.1 15.4 44.1C15.4 44.1 15.6 43.7 16 43.3C16.1 43 16.4 42.8 16.6 42.6Z'
      fill='black'
    />
    <path
      d='M16.3 40.4C15.9 40.3 15.4 40.1 15 39.7C14.8 39.5 14.6 39.3 14.5 39C14.4 38.8 14.4 38.7 14.3 38.5C14.3 38.3 14.2 38.2 14.2 38C14.2 37.7 14.2 37.3 14.3 37.1C14.4 36.5 14.6 36.2 14.6 36.2C14.6 36.2 14.8 36.3 15.1 36.4C15.2 36.5 15.4 36.6 15.6 36.7C15.8 36.8 15.9 36.9 16.1 37.1C16.3 37.3 16.4 37.5 16.5 37.7C17 38.3 17 39 17 39.6C17 40.2 16.9 40.6 16.9 40.6C16.9 40.6 16.7 40.6 16.3 40.4Z'
      fill='black'
    />
    <path
      d='M20.5 41.4C20.3 41.4 20.1 41.4 19.8 41.3C19.5 41.2 19.2 41.2 18.9 41C18.6 40.8 18.3 40.6 18.1 40.3C17.9 40 17.7 39.7 17.7 39.4C17.6 39.1 17.6 38.7 17.6 38.5C17.6 37.9 17.7 37.5 17.7 37.5C17.7 37.5 17.8 37.5 17.9 37.5C18 37.5 18.3 37.6 18.5 37.6C19 37.7 19.5 38 19.9 38.5C20.3 39 20.5 39.7 20.7 40.3C20.8 40.9 20.8 41.3 20.8 41.3C20.8 41.3 20.8 41.3 20.7 41.3C20.7 41.4 20.6 41.4 20.5 41.4Z'
      fill='black'
    />
    <path
      d='M11.8 41.4C12 41.2 12.3 41 12.6 40.9C12.8 40.8 12.9 40.8 13.1 40.7C13.3 40.6 13.5 40.6 13.7 40.6C14 40.6 14.3 40.6 14.6 40.6C15.2 40.7 15.7 40.8 16.1 41C16.5 41.2 16.7 41.3 16.7 41.3C16.7 41.3 16.5 41.7 16.2 42.1C15.8 42.5 15.3 43 14.4 43.2C14.1 43.3 13.7 43.2 13.4 43.2C13.1 43.1 12.8 43 12.5 42.9C12.2 42.8 12 42.7 11.8 42.5C11.4 42.2 11.1 42 11.1 42C11.1 42 11.4 41.7 11.8 41.4Z'
      fill='black'
    />
    <path
      d='M10.2 38.3C11 38.3 11.6 38.7 12.2 39C12.7 39.3 13.1 39.6 13.1 39.6C13.1 39.6 12.8 40 12.4 40.3C11.9 40.7 11.3 41 10.4 41C10 41 9.6 40.8 9.2 40.7C8.8 40.5 8.5 40.3 8.2 40.1C7.7 39.6 7.3 39.2 7.3 39.2C7.3 39.2 7.6 38.9 8.2 38.7C8.7 38.4 9.5 38.2 10.2 38.3Z'
      fill='black'
    />
    <path
      d='M11.2 33.9C11.2 34.6 11 35.2 10.8 35.8C10.6 36.3 10.3 36.7 10.3 36.7C10.3 36.7 10.1 36.6 9.7 36.3C9.4 36 9.1 35.6 8.8 35.1C8.7 35 8.7 34.8 8.7 34.7C8.7 34.6 8.7 34.4 8.7 34.3C8.7 33.6 9 32.9 9.4 32.5C9.7 32 10 31.7 10 31.7C10 31.7 10.2 31.8 10.4 32.1C10.5 32.2 10.6 32.4 10.7 32.6C10.8 32.7 10.8 32.8 10.8 32.9C10.9 33 10.9 33.1 10.9 33.2C11.1 33.4 11.2 33.6 11.2 33.9Z'
      fill='black'
    />
    <path
      d='M12.8 34.7C13 34.9 13.2 35.1 13.3 35.3C13.5 35.5 13.6 35.8 13.7 36.1C13.9 36.7 13.8 37.4 13.7 38C13.6 38.6 13.4 39 13.4 39C13.4 39 13 38.9 12.5 38.5C12 38.2 11.5 37.6 11.3 36.9C11.1 36.2 11.4 35.5 11.6 35C11.8 34.5 12.1 34.1 12.1 34.1C12.1 34.1 12.5 34.3 12.8 34.7Z'
      fill='black'
    />
    <path
      d='M7.3 35.3C7.4 35.3 7.6 35.4 7.7 35.5C7.8 35.6 8 35.6 8.1 35.7C8.6 36 9 36.4 9.3 36.7C9.6 37 9.8 37.2 9.8 37.2C9.8 37.2 9.5 37.5 8.9 37.8C8.4 38.1 7.6 38.3 6.9 38C6.6 37.9 6.3 37.8 6 37.6C5.9 37.5 5.7 37.4 5.6 37.3C5.5 37.2 5.4 37.1 5.3 37C5.1 36.8 4.9 36.5 4.8 36.3C4.5 35.9 4.4 35.6 4.4 35.6C4.4 35.6 4.8 35.4 5.4 35.3C5.8 35.1 6.6 35 7.3 35.3Z'
      fill='black'
    />
    <path
      d='M5.10001 31.7C5.40001 31.9 5.70001 32.1 5.90001 32.4C6.20001 32.7 6.40001 32.9 6.50001 33.2C6.70001 33.5 6.80001 33.7 6.90001 33.9C7.00001 34 7.10001 34.1 7.10001 34.1C7.10001 34.1 6.70001 34.3 6.10001 34.5C5.50001 34.6 4.80001 34.7 4.10001 34.3C3.70001 34.1 3.40001 33.8 3.10001 33.5C2.80001 33.2 2.60001 32.8 2.50001 32.5C2.30001 32.2 2.20001 31.9 2.20001 31.7C2.10001 31.5 2.10001 31.4 2.10001 31.4C2.10001 31.4 2.50001 31.3 3.10001 31.3C3.60001 31.3 4.40001 31.4 5.10001 31.7Z'
      fill='black'
    />
    <path
      d='M5.7 30.3C5.7 30.3 5.6 30.1 5.4 29.7C5.3 29.5 5.2 29.3 5.2 29C5.2 28.9 5.1 28.8 5.1 28.6C5.1 28.5 5.1 28.3 5.1 28.2C5.1 27.9 5.2 27.6 5.3 27.4C5.4 27.1 5.6 26.8 5.9 26.6C6.2 26.4 6.4 26.2 6.7 26.1C7.2 25.8 7.6 25.7 7.6 25.7C7.6 25.7 7.7 25.9 7.8 26.2C7.9 26.6 8 27 7.9 27.5C7.9 27.6 7.9 27.7 7.8 27.9C7.8 28 7.7 28.1 7.7 28.3C7.5 28.9 7 29.4 6.5 29.8C6.1 30.1 5.7 30.3 5.7 30.3Z'
      fill='black'
    />
    <path
      d='M7.6 33.7C7.6 33.7 7.5 33.6 7.4 33.5C7.3 33.4 7.1 33.1 7 32.9C6.9 32.6 6.7 32.3 6.6 32C6.5 31.7 6.5 31.3 6.6 31C6.7 30.3 7.2 29.8 7.6 29.4C8 29 8.4 28.8 8.4 28.8C8.4 28.8 8.5 28.9 8.5 29C8.6 29.1 8.7 29.3 8.8 29.5C9 29.8 9.1 30 9.1 30.3C9.1 30.6 9.2 30.9 9.1 31.2C9 31.8 8.6 32.5 8.3 32.9C8 33.4 7.6 33.7 7.6 33.7Z'
      fill='black'
    />
    <path
      d='M1.8 26.9C2.1 27 2.4 27.1 2.7 27.2C3 27.3 3.4 27.5 3.6 27.8C3.8 28 4 28.3 4.2 28.5C4.3 28.6 4.3 28.7 4.4 28.9C4.5 29 4.5 29.1 4.6 29.3C4.7 29.5 4.8 29.8 4.9 30C5 30.4 5.1 30.7 5.1 30.7C5.1 30.7 4.7 30.8 4.1 30.8C3.5 30.8 2.8 30.7 2.1 30.2C2 30 1.9 29.9 1.7 29.7C1.6 29.6 1.5 29.4 1.4 29.3C1.1 28.7 0.900005 28.1 0.800005 27.6C0.700005 27.1 0.700005 26.8 0.700005 26.8C0.700005 26.8 1.2 26.8 1.8 26.9Z'
      fill='black'
    />
    <path
      d='M0.500003 22.4C0.500003 22.2 0.600003 22.1 0.600003 22.1C0.600003 22.1 1 22.2 1.6 22.4C1.9 22.5 2.2 22.7 2.4 22.9C2.5 23 2.7 23.1 2.8 23.2C2.9 23.3 3.1 23.5 3.2 23.6C3.4 23.9 3.6 24.2 3.7 24.6C3.8 24.8 3.8 24.9 3.8 25.1C3.8 25.3 3.9 25.4 3.9 25.6C4 26.2 4 26.7 4 26.7C4 26.7 3.6 26.7 3 26.6C2.4 26.5 1.7 26.2 1.2 25.6C0.700003 25 0.600003 24.1 0.500003 23.4C0.400003 23 0.400003 22.7 0.500003 22.4Z'
      fill='black'
    />
    <path
      d='M4.3 22C4.3 21.6 4.4 21.1 4.6 20.6C4.7 20.3 4.9 20.1 5.1 19.9C5.6 19.4 6.4 19.3 6.9 19.2C7.5 19.2 7.9 19.3 7.9 19.3C7.9 19.3 7.9 19.4 7.9 19.5C7.9 19.6 7.9 19.7 7.8 19.9C7.8 20.1 7.7 20.2 7.7 20.4C7.6 20.6 7.6 20.8 7.4 21C7.3 21.2 7.1 21.4 6.9 21.6C6.7 21.8 6.4 22 6.1 22.2C5.8 22.3 5.5 22.5 5.2 22.5C4.6 22.7 4.2 22.7 4.2 22.7C4.2 22.7 4.3 22.4 4.3 22Z'
      fill='black'
    />
    <path
      d='M4.4 25.5C4.4 25.4 4.4 25.2 4.4 25C4.4 24.8 4.4 24.7 4.5 24.5C4.6 24.2 4.7 23.8 4.9 23.5C5 23.4 5.1 23.2 5.2 23.1C5.3 23.1 5.4 23 5.6 23C5.9 22.8 6.2 22.7 6.5 22.7C7.1 22.6 7.5 22.5 7.5 22.5C7.5 22.5 7.6 22.9 7.6 23.3C7.6 23.8 7.5 24.4 7.1 24.9C6.8 25.4 6.2 25.8 5.6 26.1C5.1 26.4 4.7 26.5 4.7 26.5C4.7 26.5 4.5 26.1 4.4 25.5Z'
      fill='black'
    />
    <path
      d='M3.5 19.5C3.6 19.8 3.7 20.1 3.7 20.4C3.8 21 3.8 21.5 3.7 21.9C3.7 22.3 3.6 22.6 3.6 22.6C3.6 22.6 3.2 22.5 2.6 22.3C2.3 22.2 2 22 1.8 21.8C1.5 21.6 1.3 21.3 1.1 20.9C1 20.6 0.900003 20.3 0.800003 19.9C0.800003 19.6 0.800003 19.3 0.800003 19C0.800003 18.7 0.900003 18.4 1 18.2C1.1 18 1.1 17.8 1.2 17.6C1.2 17.5 1.3 17.4 1.3 17.4C1.3 17.4 1.7 17.6 2.2 17.9C2.6 18.3 3.2 18.8 3.5 19.5Z'
      fill='black'
    />
    <path
      d='M4.70001 16.6C4.70001 17 4.60001 17.3 4.50001 17.6C4.40001 17.9 4.30001 18.1 4.30001 18.3C4.20001 18.5 4.20001 18.6 4.20001 18.6C4.20001 18.6 3.80001 18.5 3.30001 18.1C2.80001 17.8 2.30001 17.2 2.10001 16.4C1.90001 15.6 2.10001 14.7 2.40001 14.1C2.50001 13.8 2.70001 13.5 2.80001 13.3C2.90001 13.1 3.00001 13 3.00001 13C3.00001 13 3.40001 13.3 3.70001 13.7C4.10001 14.1 4.50001 14.8 4.60001 15.5C4.80001 15.9 4.80001 16.3 4.70001 16.6Z'
      fill='black'
    />
    <path
      d='M7.4 13.3C7.6 13.1 7.9 13 8.2 12.9C8.9 12.7 9.60001 12.9 10.1 13.1C10.6 13.3 11 13.6 11 13.6C11 13.6 10.9 13.8 10.7 14.1C10.5 14.4 10.2 14.7 9.8 15C9.6 15.1 9.40001 15.3 9.10001 15.4C8.50001 15.6 7.8 15.6 7.2 15.5C6.6 15.4 6.2 15.3 6.2 15.3C6.2 15.3 6.3 15 6.5 14.7C6.7 14.1 7 13.7 7.4 13.3Z'
      fill='black'
    />
    <path
      d='M8.2 16C8.8 16.1 9.2 16.3 9.2 16.3C9.2 16.3 9.2 16.4 9.1 16.5C9 16.6 9 16.8 8.8 17C8.6 17.4 8.3 17.9 7.7 18.3C7.2 18.6 6.4 18.8 5.9 18.8C5.3 18.8 4.9 18.8 4.9 18.8C4.9 18.8 4.9 18.7 4.9 18.5C4.9 18.3 5 18.1 5.1 17.8C5.2 17.5 5.3 17.2 5.5 16.9C5.7 16.6 5.9 16.4 6.3 16.2C6.9 15.8 7.6 15.9 8.2 16Z'
      fill='black'
    />
    <path
      d='M6.6 12.8C6.5 13.4 6.2 13.8 6 14.2C5.8 14.6 5.6 14.8 5.6 14.8C5.6 14.8 5.2 14.6 4.8 14.1C4.4 13.7 4 13 4 12.2C4 11.9 4.1 11.5 4.2 11.2C4.4 10.6 4.8 10 5.1 9.7C5.4 9.3 5.7 9.1 5.7 9.1C5.7 9.1 6 9.4 6.3 9.9C6.6 10.4 6.8 11.1 6.8 11.9C6.8 12.2 6.7 12.5 6.6 12.8Z'
      fill='black'
    />
    <path
      d='M9.1 9.8C8.9 10.1 8.7 10.4 8.5 10.6C8.1 11.1 7.8 11.4 7.8 11.4C7.8 11.4 7.5 11.1 7.2 10.6C6.9 10.1 6.7 9.4 6.8 8.6C7 7.7 7.5 7 8 6.5C8.6 6 9 5.8 9 5.8C9 5.8 9.2 6.2 9.4 6.7C9.6 7.3 9.7 8 9.5 8.7C9.4 9.1 9.3 9.5 9.1 9.8Z'
      fill='black'
    />
    <path
      d='M12.5 10.6C13 10.9 13.3 11.3 13.3 11.3C13.3 11.3 13.1 11.6 12.7 11.9C12.3 12.2 11.8 12.5 11.1 12.6C10.5 12.7 9.7 12.5 9.2 12.3C8.7 12.1 8.3 11.9 8.3 11.9C8.3 11.9 8.5 11.5 8.9 11.1C9.1 10.9 9.3 10.7 9.6 10.5C9.9 10.3 10.2 10.2 10.6 10.2C11.4 10 12.1 10.3 12.5 10.6Z'
      fill='black'
    />
    <path
      d='M13.8 8.5C13.4 8.7 13 9 12.6 9.1C12.2 9.2 11.8 9.3 11.5 9.4C10.8 9.5 10.3 9.5 10.3 9.5C10.3 9.5 10.3 9 10.4 8.3C10.5 7.6 10.9 6.8 11.6 6.2C12.4 5.6 13.4 5.4 14.2 5.4C15 5.4 15.6 5.5 15.6 5.5C15.6 5.5 15.5 6 15.2 6.6C15 7.2 14.6 8 13.8 8.5Z'
      fill='black'
    />
    <path
      d='M21 25.1H19.2V21.3H21C21.8 21.3 22.2 21.7 22.2 22.3C22.2 22.8 21.9 23.1 21.5 23.2C21.9 23.3 22.2 23.7 22.2 24.1C22.3 24.7 21.8 25.1 21 25.1ZM20.8 22H20.2V22.8H20.8C21.1 22.8 21.3 22.7 21.3 22.4C21.3 22.1 21.1 22 20.8 22ZM20.8 23.5H20.1V24.3H20.8C21.1 24.3 21.3 24.2 21.3 23.9C21.3 23.7 21.2 23.5 20.8 23.5Z'
      fill='#EE3658'
    />
    <path
      d='M24.2 25.1C23.3 25.1 22.7 24.5 22.7 23.5C22.7 22.5 23.3 21.9 24.2 21.9C25.1 21.9 25.7 22.5 25.7 23.4C25.7 23.5 25.7 23.6 25.7 23.7H23.6C23.6 24.1 23.9 24.3 24.2 24.3C24.5 24.3 24.6 24.2 24.7 24H25.7C25.5 24.7 24.9 25.1 24.2 25.1ZM23.6 23.3H24.8C24.8 23 24.5 22.8 24.2 22.8C23.9 22.8 23.6 22.9 23.6 23.3Z'
      fill='#EE3658'
    />
    <path
      d='M27.4 25.1C26.6 25.1 26 24.6 26 24.1H27C27 24.3 27.2 24.5 27.5 24.5C27.7 24.5 27.9 24.4 27.9 24.3C27.9 23.8 26.2 24.2 26.2 23C26.2 22.5 26.6 22.1 27.4 22.1C28.2 22.1 28.6 22.5 28.7 23.1H27.8C27.8 22.9 27.6 22.8 27.4 22.8C27.2 22.8 27.1 22.9 27.1 23C27.1 23.5 28.7 23.1 28.8 24.3C28.7 24.7 28.2 25.1 27.4 25.1Z'
      fill='#EE3658'
    />
    <path
      d='M29.4 22.8H29V22H29.4V21.3H30.3V22H30.9V22.8H30.3V24C30.3 24.2 30.4 24.3 30.6 24.3H30.9V25.1H30.4C29.8 25.1 29.3 24.8 29.3 24V22.8H29.4Z'
      fill='#EE3658'
    />
    <path
      d='M34 25.1C33.2 25.1 32.5 24.7 32.5 23.9H33.5C33.5 24.2 33.7 24.3 34 24.3C34.3 24.3 34.4 24.2 34.4 23.9C34.4 23.2 32.5 23.6 32.5 22.2C32.5 21.5 33.1 21.1 33.9 21.1C34.7 21.1 35.3 21.5 35.3 22.2H34.3C34.3 22 34.1 21.8 33.9 21.8C33.7 21.8 33.5 21.9 33.5 22.1C33.5 22.8 35.4 22.5 35.4 23.7C35.4 24.6 34.9 25.1 34 25.1Z'
      fill='#EE3658'
    />
    <path
      d='M36 21.3H37.1L38.2 24L39.3 21.3H40.4V25.1H39.5V22.8L38.6 25.1H37.8L36.9 22.8V25.1H36V21.3Z'
      fill='#EE3658'
    />
    <path
      d='M42.8 25.1H41V21.3H42.7C43.5 21.3 43.9 21.7 43.9 22.3C43.9 22.8 43.6 23.1 43.2 23.2C43.6 23.3 43.9 23.7 43.9 24.1C44.1 24.7 43.6 25.1 42.8 25.1ZM42.5 22H41.9V22.8H42.5C42.8 22.8 43 22.7 43 22.4C43 22.1 42.8 22 42.5 22ZM42.6 23.5H41.9V24.3H42.6C42.9 24.3 43.1 24.2 43.1 23.9C43.1 23.7 42.9 23.5 42.6 23.5Z'
      fill='#EE3658'
    />
    <path d='M16.1 27.8H17V31.6H16.1V27.8Z' fill='#EE3658' />
    <path
      d='M19.8 30C19.8 29.6 19.6 29.4 19.2 29.4C18.8 29.4 18.6 29.6 18.6 30V31.7H17.7V28.7H18.6V29C18.8 28.7 19.1 28.6 19.5 28.6C20.2 28.6 20.7 29.1 20.7 29.9V31.7H19.8V30Z'
      fill='#EE3658'
    />
    <path
      d='M21.5 29.4H21.1V28.6H21.5V27.9H22.4V28.6H23V29.4H22.4V30.6C22.4 30.8 22.5 30.9 22.7 30.9H23V31.7H22.5C21.9 31.7 21.4 31.4 21.4 30.6V29.4H21.5Z'
      fill='#EE3658'
    />
    <path
      d='M25 31.7C24.1 31.7 23.5 31.1 23.5 30.1C23.5 29.1 24.1 28.5 25 28.5C25.9 28.5 26.5 29.1 26.5 30C26.5 30.1 26.5 30.2 26.5 30.3H24.4C24.4 30.7 24.7 30.9 25 30.9C25.3 30.9 25.4 30.8 25.5 30.6H26.5C26.3 31.2 25.7 31.7 25 31.7ZM24.4 29.8H25.6C25.6 29.5 25.3 29.3 25 29.3C24.7 29.3 24.4 29.5 24.4 29.8Z'
      fill='#EE3658'
    />
    <path
      d='M28.1 28.6C28.5 28.6 28.9 28.8 29 29.1V28.7H30V31.7C30 32.5 29.5 33.2 28.5 33.2C27.6 33.2 27 32.7 26.9 32H27.8C27.9 32.2 28.1 32.4 28.4 32.4C28.8 32.4 29 32.2 29 31.7V31.3C28.8 31.6 28.5 31.8 28.1 31.8C27.4 31.8 26.8 31.2 26.8 30.2C26.8 29.2 27.4 28.6 28.1 28.6ZM28.4 29.4C28.1 29.4 27.7 29.7 27.7 30.1C27.7 30.6 28 30.9 28.4 30.9C28.8 30.9 29.1 30.6 29.1 30.1C29.1 29.6 28.8 29.4 28.4 29.4Z'
      fill='#EE3658'
    />
    <path
      d='M31.6 31.6H30.7V28.6H31.6V29.1C31.8 28.8 32.1 28.6 32.6 28.6V29.6H32.3C31.9 29.6 31.6 29.8 31.6 30.3V31.6Z'
      fill='#EE3658'
    />
    <path
      d='M34.2 28.6C34.7 28.6 35 28.8 35.1 29.1V28.7H36V31.7H35.1V31.3C34.9 31.6 34.6 31.8 34.2 31.8C33.5 31.8 32.9 31.2 32.9 30.2C32.8 29.2 33.4 28.6 34.2 28.6ZM34.5 29.4C34.2 29.4 33.8 29.7 33.8 30.1C33.8 30.6 34.1 30.9 34.5 30.9C34.9 30.9 35.2 30.6 35.2 30.1C35.1 29.6 34.8 29.4 34.5 29.4Z'
      fill='#EE3658'
    />
    <path
      d='M36.9 29.4H36.5V28.6H36.9V27.9H37.8V28.6H38.4V29.4H37.8V30.6C37.8 30.8 37.9 30.9 38.1 30.9H38.4V31.7H38C37.4 31.7 36.9 31.4 36.9 30.6V29.4Z'
      fill='#EE3658'
    />
    <path
      d='M38.9 27.8C38.9 27.5 39.1 27.3 39.5 27.3C39.8 27.3 40.1 27.5 40.1 27.8C40.1 28.1 39.9 28.3 39.5 28.3C39.1 28.3 38.9 28.1 38.9 27.8ZM39 28.6H39.9V31.6H39V28.6Z'
      fill='#EE3658'
    />
    <path
      d='M42 31.7C41.1 31.7 40.4 31.1 40.4 30.1C40.4 29.1 41.1 28.5 42 28.5C42.9 28.5 43.6 29.1 43.6 30.1C43.6 31.1 42.8 31.7 42 31.7ZM42 30.9C42.3 30.9 42.6 30.7 42.6 30.1C42.6 29.6 42.3 29.3 42 29.3C41.7 29.3 41.4 29.5 41.4 30.1C41.3 30.6 41.6 30.9 42 30.9Z'
      fill='#EE3658'
    />
    <path
      d='M46.1 30C46.1 29.6 45.9 29.4 45.5 29.4C45.1 29.4 44.9 29.6 44.9 30V31.7H44V28.7H45V29C45.2 28.7 45.5 28.6 45.9 28.6C46.6 28.6 47.1 29.1 47.1 29.9V31.7H46.2V30H46.1Z'
      fill='#EE3658'
    />
    <path
      d='M32.5 38L31.6 36.4L30.7 38L28.9 38.4L30.1 39.8L29.9 41.6L31.6 40.8L33.3 41.6L33 39.8L34.3 38.4L32.5 38Z'
      fill='#44B6BB'
    />
    <path
      d='M25.8 39.6L25.2 38.7L24.7 39.6L23.7 39.8L24.4 40.5L24.3 41.6L25.2 41.1L26.2 41.6L26.1 40.5L26.8 39.8L25.8 39.6Z'
      fill='#44B6BB'
    />
    <path
      d='M39.5 39.8L38.4 39.6L37.9 38.7L37.4 39.6L36.4 39.8L37.1 40.5L37 41.6L37.9 41.1L38.9 41.6L38.7 40.5L39.5 39.8Z'
      fill='#44B6BB'
    />
    <path
      d='M73.2 18.7H70.2L69.7 20.1H68.5L71 13H72.3L74.8 20.1H73.6L73.2 18.7ZM71.7 14.5L70.5 17.8H72.8L71.7 14.5Z'
      fill='black'
    />
    <path
      d='M75.4 14.6H76.6L77.8 19.1L79 14.6H80.2L81.3 19.1L82.5 14.6H83.6L81.9 20.2H80.7L79.5 16L78.4 20.2H77.2L75.4 14.6Z'
      fill='black'
    />
    <path
      d='M86.7 14.5C87.6 14.5 88.3 14.9 88.6 15.4V14.6H89.8V20.2H88.6V19.4C88.2 19.9 87.6 20.3 86.6 20.3C85.1 20.3 84 19.1 84 17.4C84 15.7 85.3 14.5 86.7 14.5ZM87 15.5C86.1 15.5 85.3 16.2 85.3 17.4C85.3 18.6 86.1 19.3 87 19.3C87.9 19.3 88.7 18.6 88.7 17.4C88.7 16.2 87.9 15.5 87 15.5Z'
      fill='black'
    />
    <path
      d='M92.6 20.2H91.4V14.6H92.6V15.4C92.9 14.8 93.5 14.5 94.3 14.5V15.7H94C93.1 15.7 92.6 16.1 92.6 17.3V20.2Z'
      fill='black'
    />
    <path
      d='M97.6 14.5C98.3 14.5 99.1 14.8 99.5 15.4V12.7H100.7V20.3H99.5V19.5C99.1 20 98.5 20.4 97.6 20.4C96.1 20.4 94.9 19.2 94.9 17.5C94.9 15.8 96.1 14.5 97.6 14.5ZM97.8 15.5C96.9 15.5 96.1 16.2 96.1 17.4C96.1 18.6 96.9 19.3 97.8 19.3C98.7 19.3 99.5 18.6 99.5 17.4C99.5 16.2 98.7 15.5 97.8 15.5Z'
      fill='black'
    />
    <path
      d='M104.6 20.3C103 20.3 101.8 19.2 101.8 17.4C101.8 15.6 102.9 14.5 104.6 14.5C106.2 14.5 107.3 15.6 107.3 17.3C107.3 17.5 107.3 17.7 107.3 17.9H103C103.1 18.8 103.7 19.4 104.6 19.4C105.3 19.4 105.7 19.1 105.9 18.6H107.2C106.9 19.5 106 20.3 104.6 20.3ZM103.1 16.9H106.2C106.2 16 105.5 15.5 104.6 15.5C103.8 15.4 103.2 16 103.1 16.9Z'
      fill='black'
    />
    <path
      d='M110.8 14.5C111.5 14.5 112.3 14.8 112.7 15.4V12.7H113.9V20.3H112.7V19.5C112.3 20 111.7 20.4 110.8 20.4C109.3 20.4 108.1 19.2 108.1 17.5C108.1 15.8 109.3 14.5 110.8 14.5ZM111 15.5C110.1 15.5 109.3 16.2 109.3 17.4C109.3 18.6 110.1 19.3 111 19.3C111.9 19.3 112.7 18.6 112.7 17.4C112.7 16.2 111.9 15.5 111 15.5Z'
      fill='black'
    />
    <path
      d='M117.7 13.1H122.7V14H120.8V20.1H119.6V14H117.7V13.1Z'
      fill='black'
    />
    <path
      d='M123.7 13.1C123.7 12.7 124 12.4 124.4 12.4C124.8 12.4 125.1 12.7 125.1 13.1C125.1 13.5 124.8 13.8 124.4 13.8C124 13.8 123.7 13.5 123.7 13.1ZM123.8 14.6H125V20.2H123.8V14.6Z'
      fill='black'
    />
    <path
      d='M126.5 12.6H127.7V17L129.7 14.5H131.3L128.7 17.3L131.3 20.1H129.7L127.6 17.7V20.1H126.4V12.6H126.5Z'
      fill='black'
    />
    <path
      d='M131.8 13.1H136.8V14H134.9V20.1H133.7V14H131.8V13.1Z'
      fill='black'
    />
    <path
      d='M140.4 20.3C138.8 20.3 137.6 19.2 137.6 17.4C137.6 15.6 138.9 14.5 140.5 14.5C142.1 14.5 143.4 15.6 143.4 17.4C143.4 19.2 142 20.3 140.4 20.3ZM140.4 19.3C141.3 19.3 142.1 18.7 142.1 17.4C142.1 16.1 141.3 15.5 140.4 15.5C139.5 15.5 138.7 16.1 138.7 17.4C138.7 18.7 139.5 19.3 140.4 19.3Z'
      fill='black'
    />
    <path
      d='M144.5 12.6H145.7V17L147.7 14.5H149.3L146.7 17.3L149.3 20.1H147.7L145.6 17.7V20.1H144.4V12.6H144.5Z'
      fill='black'
    />
    <path
      d='M155.1 20.3C153.7 20.3 152.6 19.5 152.6 18.3H153.8C153.9 18.9 154.3 19.4 155.1 19.4C155.9 19.4 156.4 19 156.4 18.4C156.4 16.7 152.6 17.8 152.6 15.2C152.6 14 153.6 13.2 155 13.2C156.4 13.2 157.3 13.9 157.4 15.1H156.1C156.1 14.6 155.6 14.2 154.9 14.2C154.2 14.2 153.7 14.5 153.7 15.2C153.7 16.8 157.5 15.8 157.5 18.4C157.6 19.2 156.7 20.3 155.1 20.3Z'
      fill='black'
    />
    <path
      d='M158.9 12.6H160.1V15.2C160.5 14.7 161.1 14.5 161.8 14.5C163.1 14.5 164 15.3 164 16.9V20.2H162.8V17C162.8 16 162.2 15.4 161.4 15.4C160.5 15.4 160 15.9 160 17V20.1H158.8V12.6H158.9Z'
      fill='black'
    />
    <path
      d='M168 20.3C166.4 20.3 165.2 19.2 165.2 17.4C165.2 15.6 166.5 14.5 168.1 14.5C169.7 14.5 171 15.6 171 17.4C171 19.2 169.6 20.3 168 20.3ZM168 19.3C168.9 19.3 169.7 18.7 169.7 17.4C169.7 16.1 168.9 15.5 168 15.5C167.1 15.5 166.3 16.1 166.3 17.4C166.3 18.7 167.1 19.3 168 19.3Z'
      fill='black'
    />
    <path
      d='M175.2 14.5C176.7 14.5 177.8 15.6 177.8 17.4C177.8 19.2 176.6 20.3 175.2 20.3C174.3 20.3 173.6 19.8 173.2 19.4V22.9H172V14.6H173.2V15.4C173.6 14.9 174.3 14.5 175.2 14.5ZM174.9 15.5C174 15.5 173.2 16.2 173.2 17.4C173.2 18.6 174 19.3 174.9 19.3C175.8 19.3 176.6 18.6 176.6 17.4C176.6 16.2 175.8 15.5 174.9 15.5Z'
      fill='black'
    />
    <path d='M178.5 15.5L179.1 13.1H180.4L179.3 15.5H178.5Z' fill='black' />
    <path
      d='M183.5 20.3C182.2 20.3 181.2 19.5 181.2 18.5H182.4C182.4 19 182.9 19.3 183.5 19.3C184.2 19.3 184.5 19 184.5 18.6C184.5 17.5 181.2 18.1 181.2 16.1C181.2 15.2 182 14.5 183.4 14.5C184.7 14.5 185.5 15.2 185.6 16.3H184.4C184.4 15.8 184 15.5 183.3 15.5C182.7 15.5 182.4 15.8 182.4 16.1C182.4 17.2 185.6 16.6 185.6 18.6C185.6 19.6 184.8 20.3 183.5 20.3Z'
      fill='black'
    />
    <path
      d='M73 35H69V26.3H72.9C74.7 26.3 75.7 27.2 75.7 28.5C75.7 29.5 75.1 30.2 74.2 30.5C75.2 30.7 75.9 31.6 75.9 32.6C75.9 34.1 74.8 35 73 35ZM72.4 28H71V29.8H72.4C73.1 29.8 73.5 29.5 73.5 28.9C73.5 28.3 73.1 28 72.4 28ZM72.6 31.4H71.1V33.3H72.7C73.4 33.3 73.8 33 73.8 32.4C73.8 31.8 73.3 31.4 72.6 31.4Z'
      fill='black'
    />
    <path
      d='M80.1 35.1C78.1 35.1 76.6 33.7 76.6 31.6C76.6 29.4 78 28.1 80.1 28.1C82.1 28.1 83.5 29.4 83.5 31.5C83.5 31.7 83.5 31.9 83.5 32.1H78.7C78.8 33 79.3 33.4 80 33.4C80.6 33.4 80.9 33.1 81.1 32.7H83.3C83.1 34.1 81.9 35.1 80.1 35.1ZM78.8 30.9H81.4C81.4 30.1 80.8 29.7 80.1 29.7C79.4 29.7 78.9 30.1 78.8 30.9Z'
      fill='black'
    />
    <path
      d='M87.5 35.1C85.7 35.1 84.4 34.1 84.3 32.7H86.4C86.4 33.2 86.9 33.5 87.5 33.5C88 33.5 88.3 33.3 88.3 32.9C88.3 31.8 84.5 32.6 84.5 30.1C84.5 28.9 85.5 28 87.3 28C89.1 28 90.1 29 90.2 30.3H88.2C88.1 29.8 87.8 29.5 87.2 29.5C86.7 29.5 86.4 29.7 86.4 30C86.4 31.1 90.1 30.3 90.2 32.9C90.3 34.2 89.2 35.1 87.5 35.1Z'
      fill='black'
    />
    <path
      d='M91.9 29.9H91.1V28.1H91.9V26.4H94V28.1H95.4V29.9H94V32.7C94 33.1 94.2 33.3 94.6 33.3H95.4V35H94.3C92.9 35 91.9 34.4 91.9 32.6V29.9Z'
      fill='black'
    />
    <path
      d='M102.3 35.1C100.4 35.1 99 34.2 98.9 32.4H101.1C101.2 33.1 101.6 33.4 102.2 33.4C102.8 33.4 103.2 33.1 103.2 32.6C103.2 31 98.9 31.9 98.9 28.8C98.9 27.2 100.2 26.2 102.1 26.2C104 26.2 105.3 27.1 105.3 28.8H103C103 28.2 102.6 27.9 102 27.9C101.5 27.9 101.1 28.1 101.1 28.7C101.1 30.2 105.4 29.5 105.4 32.4C105.5 33.9 104.4 35.1 102.3 35.1Z'
      fill='black'
    />
    <path
      d='M106.8 26.3H109.3L111.7 32.3L114.1 26.3H116.6V35H114.5V29.8L112.6 35H110.9L108.9 29.8V35H106.8V26.3Z'
      fill='black'
    />
    <path
      d='M122.2 35H118.2V26.3H122.1C123.9 26.3 124.9 27.2 124.9 28.5C124.9 29.5 124.3 30.2 123.4 30.5C124.4 30.7 125.1 31.6 125.1 32.6C125 34.1 124 35 122.2 35ZM121.6 28H120.2V29.8H121.6C122.3 29.8 122.7 29.5 122.7 28.9C122.7 28.3 122.3 28 121.6 28ZM121.8 31.4H120.3V33.3H121.9C122.6 33.3 123 33 123 32.4C123 31.8 122.5 31.4 121.8 31.4Z'
      fill='black'
    />
    <path d='M128.9 26.3H131V35H128.9V26.3Z' fill='black' />
    <path
      d='M137.3 31.3C137.3 30.4 136.8 29.8 136 29.8C135.2 29.8 134.7 30.3 134.7 31.3V35H132.6V28.1H134.7V29C135.1 28.4 135.9 28 136.8 28C138.4 28 139.5 29.1 139.5 30.9V34.9H137.4V31.3H137.3Z'
      fill='black'
    />
    <path
      d='M141.2 29.9H140.4V28.1H141.2V26.4H143.3V28.1H144.7V29.9H143.3V32.7C143.3 33.1 143.5 33.3 143.9 33.3H144.7V35H143.6C142.2 35 141.2 34.4 141.2 32.6V29.9Z'
      fill='black'
    />
    <path
      d='M148.9 35.1C146.9 35.1 145.4 33.7 145.4 31.6C145.4 29.4 146.8 28.1 148.9 28.1C150.9 28.1 152.3 29.4 152.3 31.5C152.3 31.7 152.3 31.9 152.3 32.1H147.5C147.6 33 148.1 33.4 148.8 33.4C149.4 33.4 149.7 33.1 149.9 32.7H152.1C151.9 34.1 150.6 35.1 148.9 35.1ZM147.5 30.9H150.1C150.1 30.1 149.5 29.7 148.8 29.7C148.2 29.7 147.7 30.1 147.5 30.9Z'
      fill='black'
    />
    <path
      d='M156.1 28C157.1 28 157.9 28.5 158.2 29.1V28.1H160.3V35C160.3 36.8 159.2 38.4 156.9 38.4C154.9 38.4 153.5 37.4 153.3 35.7H155.4C155.5 36.2 156.1 36.6 156.8 36.6C157.6 36.6 158.2 36.2 158.2 35V34C157.8 34.6 157.1 35.1 156.1 35.1C154.4 35.1 153.1 33.7 153.1 31.5C153 29.4 154.4 28 156.1 28ZM156.7 29.9C155.9 29.9 155.2 30.5 155.2 31.6C155.2 32.7 155.9 33.3 156.7 33.3C157.5 33.3 158.2 32.7 158.2 31.6C158.2 30.5 157.5 29.9 156.7 29.9Z'
      fill='black'
    />
    <path
      d='M164 35H161.9V28.1H164V29.2C164.5 28.5 165.2 28 166.2 28V30.2H165.6C164.6 30.2 164 30.5 164 31.7V35Z'
      fill='black'
    />
    <path
      d='M169.7 28C170.7 28 171.5 28.5 171.8 29.1V28.1H173.9V35H171.8V34C171.4 34.6 170.7 35.1 169.7 35.1C168 35.1 166.7 33.7 166.7 31.5C166.7 29.4 168.1 28 169.7 28ZM170.4 29.9C169.6 29.9 168.9 30.5 168.9 31.6C168.9 32.7 169.6 33.3 170.4 33.3C171.2 33.3 171.9 32.7 171.9 31.6C171.9 30.5 171.2 29.9 170.4 29.9Z'
      fill='black'
    />
    <path
      d='M175.8 29.9H175V28.1H175.8V26.4H177.9V28.1H179.3V29.9H178V32.7C178 33.1 178.2 33.3 178.6 33.3H179.4V35H178.3C176.9 35 175.9 34.4 175.9 32.6V29.9H175.8Z'
      fill='black'
    />
    <path
      d='M180.3 26.3C180.3 25.7 180.8 25.2 181.6 25.2C182.3 25.2 182.8 25.7 182.8 26.3C182.8 26.9 182.3 27.4 181.6 27.4C180.8 27.4 180.3 26.9 180.3 26.3ZM180.5 28.1H182.6V35H180.5V28.1Z'
      fill='black'
    />
    <path
      d='M187.3 35.1C185.3 35.1 183.7 33.7 183.7 31.6C183.7 29.4 185.3 28.1 187.3 28.1C189.3 28.1 190.9 29.5 190.9 31.6C190.9 33.7 189.3 35.1 187.3 35.1ZM187.3 33.3C188.1 33.3 188.8 32.7 188.8 31.6C188.8 30.4 188.1 29.9 187.4 29.9C186.6 29.9 186 30.4 186 31.6C185.9 32.7 186.5 33.3 187.3 33.3Z'
      fill='black'
    />
    <path
      d='M196.8 31.3C196.8 30.4 196.3 29.8 195.5 29.8C194.7 29.8 194.2 30.3 194.2 31.3V35H192V28.1H194.1V29C194.5 28.4 195.3 28 196.2 28C197.8 28 198.9 29.1 198.9 30.9V34.9H196.8V31.3Z'
      fill='black'
    />
    <path
      d='M30.6 13.1V12.7C30.5 12.7 30.3 12.7 30.2 12.7C29.8 12.7 29.4 12.8 29 12.9C28.6 13.1 28.3 13.3 28 13.6C27.7 13.9 27.5 14.2 27.3 14.6C27.1 15 27.1 15.4 27.1 15.8C27.1 16.3 27.2 16.8 27.4 17.2C27.6 17.7 27.9 18 28.4 18.3C27.9 17.8 27.6 17 27.6 16.3C27.6 15.9 27.7 15.5 27.8 15.2C28 14.8 28.2 14.5 28.4 14.2C28.7 13.9 29 13.7 29.4 13.5C29.8 13.2 30.2 13.1 30.6 13.1Z'
      fill='#6CCAD4'
    />
    <path
      d='M35.5 11.8V11.4C35 11.4 34.6 11.3 34.2 11C34.6 11.4 35 11.7 35.5 11.8ZM30.7 17.5C30.9 17.5 31.1 17.5 31.2 17.4C31.4 17.3 31.5 17.2 31.7 17.1C31.8 17 31.9 16.8 32 16.7C32.1 16.5 32.1 16.4 32.1 16.2V9.5H33.3C33.3 9.3 33.3 9.2 33.3 9.1H31.6V15.8C31.6 16 31.6 16.1 31.5 16.3C31.4 16.5 31.3 16.6 31.2 16.7C31.1 16.8 30.9 16.9 30.7 17C30.5 17.1 30.4 17.1 30.2 17.1C30 17.1 29.7 17 29.6 16.9C29.8 17.3 30.2 17.5 30.7 17.5Z'
      fill='#6CCAD4'
    />
    <path
      d='M30.2 14.3C30 14.3 29.8 14.3 29.7 14.4C29.5 14.5 29.4 14.6 29.2 14.7C29.1 14.8 29 15 28.9 15.2C28.8 15.4 28.8 15.5 28.8 15.7C28.8 16.2 29.1 16.7 29.6 16.9C29.4 16.6 29.3 16.4 29.3 16.1C29.3 15.9 29.3 15.7 29.4 15.6C29.5 15.4 29.6 15.3 29.7 15.1C29.8 15 30 14.9 30.2 14.8C30.4 14.7 30.5 14.7 30.7 14.7C30.8 14.7 31 14.7 31.1 14.8V13.1C31 13.1 30.8 13.1 30.7 13.1C30.7 13.1 30.7 13.1 30.6 13.1V14.4C30.4 14.3 30.3 14.3 30.2 14.3ZM34.3 11C33.9 10.6 33.7 10.1 33.7 9.5H33.2C33.4 10.1 33.8 10.7 34.3 11Z'
      fill='#EE3658'
    />
    <path
      d='M35.5 11.7V13C34.7 13 33.9 12.7 33.2 12.2V15.6C33.2 16 33.1 16.4 33 16.8C32.8 17.2 32.6 17.5 32.3 17.8C32 18.1 31.7 18.3 31.3 18.5C30.9 18.7 30.5 18.7 30.1 18.7C29.5 18.7 28.9 18.5 28.3 18.2C28.9 18.9 29.6 19.2 30.5 19.2C30.9 19.2 31.3 19.1 31.7 19C32.1 18.8 32.4 18.6 32.7 18.3C33 18 33.2 17.7 33.4 17.3C33.6 16.9 33.6 16.5 33.6 16.1V12.7C34.3 13.2 35.1 13.5 35.9 13.5V11.8C35.9 11.8 35.7 11.8 35.5 11.7Z'
      fill='#EE3658'
    />
    <path
      d='M33.2 15.7V12.3C33.9 12.8 34.7 13.1 35.5 13.1V11.8C35 11.7 34.6 11.4 34.2 11C33.7 10.6 33.3 10.1 33.2 9.5H32V16.2C32 16.4 32 16.5 31.9 16.7C31.8 16.9 31.7 17 31.6 17.1C31.5 17.2 31.3 17.3 31.1 17.4C30.9 17.5 30.8 17.5 30.6 17.5C30.1 17.5 29.8 17.3 29.5 16.9C29.2 16.7 29 16.5 28.9 16.2C28.8 15.9 28.7 15.6 28.8 15.3C28.9 15 29.1 14.7 29.3 14.5C29.6 14.3 29.8 14.2 30.2 14.2C30.3 14.2 30.5 14.2 30.6 14.3V13C30.2 13 29.8 13.1 29.5 13.3C29.1 13.5 28.8 13.7 28.5 14C28.2 14.3 28 14.6 27.9 15C27.7 15.4 27.7 15.8 27.7 16.1C27.7 16.9 28 17.6 28.5 18.2C29 18.6 29.6 18.7 30.3 18.7C30.7 18.7 31.1 18.6 31.5 18.5C31.9 18.3 32.2 18.1 32.5 17.8C32.8 17.5 33 17.2 33.2 16.8C33.2 16.5 33.3 16.1 33.2 15.7Z'
      fill='black'
    />
  </svg>
);
